
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lVF98", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $6cnUO = parcelRequire("6cnUO");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");


var $1qfLF = parcelRequire("1qfLF");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $3gadb = parcelRequire("3gadb");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gZTYb = parcelRequire("gZTYb");

/**
 * __AnimateIn__
 *
 * Useful for Animating in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $6260267e05cdfdb2$var$AnimateIn = ({ children: children, duration: duration = 'large', enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation, onFinish: onFinish, isPaused: isPaused, animationTimingFunction: animationTimingFunction })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gZTYb.default), {
        duration: duration,
        enteringAnimation: enteringAnimation,
        exitingAnimation: exitingAnimation,
        animationTimingFunction: animationTimingFunction,
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
var $6260267e05cdfdb2$export$2e2bcd8739ae039 = $6260267e05cdfdb2$var$AnimateIn;



var $1iSzD = parcelRequire("1iSzD");


var $iV5Ic = parcelRequire("iV5Ic");


var $8unJx = parcelRequire("8unJx");


var $hR4U4 = parcelRequire("hR4U4");


var $jln20 = parcelRequire("jln20");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $hU34N = parcelRequire("hU34N");


var $iIQbF = parcelRequire("iIQbF");


var $3jwuS = parcelRequire("3jwuS");


var $9wGTI = parcelRequire("9wGTI");


var $D7PHQ = parcelRequire("D7PHQ");


var $kM55L = parcelRequire("kM55L");


var $6mKj3 = parcelRequire("6mKj3");


var $efvKr = parcelRequire("efvKr");


var $aWwYt = parcelRequire("aWwYt");


var $eNjW4 = parcelRequire("eNjW4");


var $jmjWc = parcelRequire("jmjWc");


var $e4o8D = parcelRequire("e4o8D");


var $3qFIQ = parcelRequire("3qFIQ");


var $2VQ4B = parcelRequire("2VQ4B");


var $8uM2K = parcelRequire("8uM2K");


var $bj5fB = parcelRequire("bj5fB");


var $dppWL = parcelRequire("dppWL");


var $3tUdX = parcelRequire("3tUdX");








var $4acD6 = parcelRequire("4acD6");


var $3Am3T = parcelRequire("3Am3T");


var $kEiOB = parcelRequire("kEiOB");


var $amW67 = parcelRequire("amW67");

/**
 * @generated SignedSource<<f1c23bdd0d6b81d646bf2fc341e8a6a6>>
 * @relayHash dea9c3cbfe29b9c92cdeb224b8f076c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3535a366980d7daaf35b172ee45b177da449ae9442b6943bdb0c465be89ae8b7
const $e82e32b99e59f54f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isCurrentUserContributor"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useNudgeContributorFilterQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useNudgeContributorFilterQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "dea9c3cbfe29b9c92cdeb224b8f076c7",
            "id": "3535a366980d7daaf35b172ee45b177da449ae9442b6943bdb0c465be89ae8b7",
            "metadata": {},
            "name": "useNudgeContributorFilterQuery",
            "operationKind": "query",
            "text": "query useNudgeContributorFilterQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}}"
        }
    };
}();
$e82e32b99e59f54f$var$node.hash = "427fb0db9de3e615035eab567b67ccf0";
var $e82e32b99e59f54f$export$2e2bcd8739ae039 = $e82e32b99e59f54f$var$node;






var $jMyy4 = parcelRequire("jMyy4");

const $fc07d009da21f8b9$var$useNudgeContributorFilterQuery = (0, $e82e32b99e59f54f$export$2e2bcd8739ae039);
function $fc07d009da21f8b9$export$cb9bdc967aae1b21(contentId, skip) {
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($fc07d009da21f8b9$var$useNudgeContributorFilterQuery, {
        variables: {
            contentId: contentId
        },
        skip: !contentId || skip
    });
    const isCurrentUserContributor = data?.contentContributors?.isCurrentUserContributor ?? false;
    return (0, $42omo.useMemo)(()=>({
            isCurrentUserContributor: isCurrentUserContributor,
            loading: loading
        }), [
        isCurrentUserContributor,
        loading
    ]);
}















var $bQm3c = parcelRequire("bQm3c");


var $h2uld = parcelRequire("h2uld");

const $e4cd8876e4f83d2e$export$b68936138edb7d6e = (contentType, contentId)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT);
    const readTimeMinutes = readTimeLoading ? null : Number(readTime);
    const minReadTimeMinutes = (0, $9wGTI.fg)('rovo_button_proactive_nudge_min_read_time_increase') ? 1.0 : 0.5;
    /**
	 * Base eligibility checks (page-level, shared across all nudges):
	 * 1. Rovo Button must be enabled
	 * 2. Content type must be 'page' (TODO: extend to 'blogpost' when backend 500s are fixed)
	 * 3. Page must not be in edit mode
	 * 4. Read time query must be completed
	 * 5. Read time must exceed the minimum threshold (1 min with gate on, 30s with gate off)
	 */ const isBaseEligible = isRovoButtonEnabled && contentType === 'page' && pageMode !== (0, $cD1qu.PageMode).EDIT && readTimeMinutes !== null && readTimeMinutes > minReadTimeMinutes;
    return {
        isBaseEligible: isBaseEligible,
        readTimeMinutes: readTimeMinutes
    };
};












var $dWpd3 = parcelRequire("dWpd3");











var $AL4QS = parcelRequire("AL4QS");


var $5gEqE = parcelRequire("5gEqE");


var $6Htct = parcelRequire("6Htct");


var $1AJi3 = parcelRequire("1AJi3");

const $c3e3eb1b5def3766$var$messages = (0, $aXWIB.defineMessages)({
    insightsNudgeTitle: {
        id: "page-rovo-config-common.insights-nudge-title",
        defaultMessage: "Explore your weekly insights"
    },
    insightsNudgeIconLabel: {
        id: "page-rovo-config-common.insights-nudge-icon-label",
        defaultMessage: "Insights icon"
    }
});
function $c3e3eb1b5def3766$export$efd7aeb42217b406() {
    const { setActiveMenu: setActiveMenu } = (0, $5gEqE.useUIStore)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { mode: mode, toggleConversationAssistant: toggleConversationAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
    const onClick = (0, $42omo.useCallback)(()=>{
        if (!mode) toggleConversationAssistant();
        setActiveMenu('pulse');
    }, [
        mode,
        toggleConversationAssistant,
        setActiveMenu
    ]);
    return (0, $42omo.useMemo)(()=>({
            id: 'rovo-insights-nudge',
            title: formatMessage($c3e3eb1b5def3766$var$messages.insightsNudgeTitle),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($AL4QS))), {
                    size: "small",
                    label: formatMessage($c3e3eb1b5def3766$var$messages.insightsNudgeIconLabel)
                }),
            onClick: onClick,
            type: 'ai-action',
            handleType: (0, $6Htct.HandleActionType).Base,
            nudgeContext: {
                id: 'rovo-insights'
            }
        }), [
        onClick,
        formatMessage
    ]);
}











const $c07f2db40a5a574b$var$CONVO_STARTER_NUDGE_ID = 'convo-starter';
function $c07f2db40a5a574b$export$26385239543be8d2() {
    return (0, $42omo.useMemo)(()=>{
        if (!(0, $9wGTI.fg)('aix_convo_starter_nudge_enabled')) return null;
        return {
            id: $c07f2db40a5a574b$var$CONVO_STARTER_NUDGE_ID,
            title: '',
            type: 'convo-starter-action',
            handleType: (0, $6Htct.HandleActionType).Chat,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
            staticPrompt: '',
            starterType: 'static'
        };
    }, []);
}


const $8bdd9ea855fe08b8$var$isNudgeByAction = (entry)=>'action' in entry;
/** Minimum read time (in minutes) required for the convo starter nudge. */ const $8bdd9ea855fe08b8$var$CONVO_STARTER_MIN_READ_TIME_MINUTES = 2;
function $8bdd9ea855fe08b8$export$730669e74cd8a0c9(isBaseEligible, readTimeMinutes, isCurrentUserContributor) {
    const viewPageRovoActions = (0, $kEiOB.useViewPageRovoActions)();
    const insightsNudgeAction = (0, $c3e3eb1b5def3766$export$efd7aeb42217b406)();
    const convoStartersNudgeAction = (0, $c07f2db40a5a574b$export$26385239543be8d2)();
    const { eligibleForChangeboarding: eligibleForChangeboarding } = (0, $dWpd3.useAudioButtonWrapperStore)();
    const actionsById = (0, $42omo.useMemo)(()=>new Map(viewPageRovoActions.map((registeredAction)=>[
                registeredAction.actionId,
                registeredAction.action
            ])), [
        viewPageRovoActions
    ]);
    return (0, $42omo.useMemo)(()=>{
        if (!isBaseEligible) return [];
        const nudgeEntries = [
            {
                actionId: 'page-catchup',
                enabled: true
            },
            {
                actionId: 'audio-briefing',
                enabled: !eligibleForChangeboarding
            },
            // Insights nudge — 1 min read time threshold covered by isBaseEligible
            {
                action: insightsNudgeAction,
                enabled: (0, $6mKj3.expVal)('rovo_growth_chat_pulse', 'isEnabled', false)
            },
            // Convo starter nudge — requires higher read time than the base threshold
            // Excluded for contributors — they already know the page content
            {
                action: convoStartersNudgeAction,
                enabled: !isCurrentUserContributor && readTimeMinutes !== null && readTimeMinutes > $8bdd9ea855fe08b8$var$CONVO_STARTER_MIN_READ_TIME_MINUTES && (0, $9wGTI.fg)('aix_convo_starter_nudge_enabled')
            }
        ];
        return nudgeEntries.reduce((acc, nudgeEntry)=>{
            if (!nudgeEntry.enabled) return acc;
            const action = $8bdd9ea855fe08b8$var$isNudgeByAction(nudgeEntry) ? nudgeEntry.action : actionsById.get(nudgeEntry.actionId);
            if (action) acc.push(action);
            return acc;
        }, []);
    }, [
        isBaseEligible,
        readTimeMinutes,
        eligibleForChangeboarding,
        isCurrentUserContributor,
        insightsNudgeAction,
        convoStartersNudgeAction,
        actionsById
    ]);
}


const $2b7ed8ae830eb95a$var$ViewPageConfigProviderInner = ({ setConfiguration: setConfiguration })=>{
    const { contentType: contentType, contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    const viewPageRovoActions = (0, $kEiOB.useViewPageRovoActions)();
    const { isBaseEligible: isBaseEligible, readTimeMinutes: readTimeMinutes } = (0, $e4cd8876e4f83d2e$export$b68936138edb7d6e)(contentType, contentId);
    const { isCurrentUserContributor: isCurrentUserContributor } = (0, $fc07d009da21f8b9$export$cb9bdc967aae1b21)(contentId, !isBaseEligible || !(0, $9wGTI.fg)('aix_convo_starter_nudge_enabled'));
    const nudges = (0, $8bdd9ea855fe08b8$export$730669e74cd8a0c9)(isBaseEligible, readTimeMinutes, isCurrentUserContributor);
    const { setNudges: setNudges } = (0, $4acD6.useAISmartButtonActions)();
    const rovoConfiguration = (0, $42omo.useMemo)(()=>{
        return {
            getActions: async ()=>{
                const actions = viewPageRovoActions.map((action)=>action.action);
                return Promise.resolve(actions);
            }
        };
    }, [
        viewPageRovoActions
    ]);
    (0, $42omo.useEffect)(()=>{
        setConfiguration(rovoConfiguration);
        setNudges(nudges);
    }, [
        rovoConfiguration,
        setConfiguration,
        nudges,
        setNudges
    ]);
    return null;
};
const $2b7ed8ae830eb95a$export$299010de885adda = (props)=>{
    const { contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2b7ed8ae830eb95a$var$ViewPageConfigProviderInner, props));
};












var $la9AC = parcelRequire("la9AC");































const $23e0c73c9feee0cc$export$5569745b4d0a5343 = (contentType, _contentId)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const isLiveDoc = pageMode === (0, $cD1qu.PageMode).LIVE;
    /**
	 * Filters to prevent high request volume checking for nudge recommendations on live docs
	 * 1. Feature gate 'confluence_rovo_live_doc_nudges' must be enabled
	 * 2. Page must be a live doc
	 * 3. Rovo Button must be enabled
	 * 4. Content type must be 'page'
	 */ return isLiveDoc && isRovoButtonEnabled && contentType === 'page' && isAdminHubAIEnabled && (0, $9wGTI.fg)('confluence_rovo_live_doc_nudges');
};



var $02cx8 = parcelRequire("02cx8");

/* getEmptyPageCreationActions.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $1s5hv = parcelRequire("1s5hv");


var $boRaI = parcelRequire("boRaI");




const $efb362169c233167$export$4b8c4c333cdd165d = [
    'create-product-requirements-document',
    'create-customer-onboarding-strategy',
    'create-background-research-plan'
];
/* istanbul ignore next */ const $efb362169c233167$var$styles = {
    iconContainer: "_1yt412x7"
};
const $efb362169c233167$export$4e5c71902381581b = (promptCards)=>{
    const promptCardsById = new Map(promptCards.map((card)=>[
            card.id,
            card
        ]));
    return $efb362169c233167$export$4b8c4c333cdd165d.reduce((actions, targetId)=>{
        const card = promptCardsById.get(targetId);
        if (card) actions.push({
            handleType: (0, $6Htct.HandleActionType).Chat,
            id: card.id,
            title: card.title,
            dynamicPrompt: card.prompt,
            icon: ()=>{
                const Icon = (0, $boRaI.getUseCaseIcon)(card.useCase);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                    alignItems: "center",
                    justifyContent: "center",
                    xcss: $efb362169c233167$var$styles.iconContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, null));
            }
        });
        return actions;
    }, []);
};


var $9c464318090b4e27$exports = {};
$9c464318090b4e27$exports = new URL("empty-page-greeting-icon.9a2c7bfb.svg", import.meta.url).toString();


const $7e583ad86f1e8aa8$var$messages = (0, $aXWIB.defineMessages)({
    emptyPageGreetingTitle: {
        id: "edit-page-rovo-config-provider.empty-page-greeting-title",
        defaultMessage: "Start your doc with a prompt"
    },
    copiedPageGreetingTitle: {
        id: "edit-page-rovo-config-provider.copied-page-greeting-title",
        defaultMessage: "Need help editing your copied page?"
    }
});
const $7e583ad86f1e8aa8$var$EditPageConfigProviderInner = ({ setConfiguration: setConfiguration })=>{
    const viewPageRovoActions = (0, $kEiOB.useViewPageRovoActions)();
    const editorActions = (0, $02cx8.useEditorRovoButtonActionsActions)();
    const editorActionsContext = (0, $02cx8.useEditorRovoButtonActionsContext)();
    const rovoConfigProviderProps = (0, $amW67.useRovoConfigProviderProps)();
    const isEditorEmpty = (0, $dppWL.isPageRovoConfigProviderProps)(rovoConfigProviderProps) && rovoConfigProviderProps.isEditorEmpty;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { promptCards: promptCards } = (0, $la9AC.usePromptCards)();
    const isEmptyPageWithPromptCards = isEditorEmpty && Array.isArray(promptCards);
    const pageProps = (0, $dppWL.isPageRovoConfigProviderProps)(rovoConfigProviderProps) ? rovoConfigProviderProps : null;
    const contentType = pageProps?.contentType ?? '';
    const contentId = pageProps?.contentId ?? '';
    const enableLiveDocNudges = (0, $23e0c73c9feee0cc$export$5569745b4d0a5343)(contentType, contentId);
    const { setNudges: setNudges } = (0, $4acD6.useAISmartButtonActions)();
    const config = (0, $42omo.useMemo)(()=>{
        const getCustomGreeting = ()=>{
            if (isEmptyPageWithPromptCards) return {
                iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($9c464318090b4e27$exports))),
                title: formatMessage($7e583ad86f1e8aa8$var$messages.emptyPageGreetingTitle)
            };
            if ((0, $6mKj3.expValEquals)('cc_fd_copy_with_rovo', 'cohort', 'rovoChat')) return {
                title: formatMessage($7e583ad86f1e8aa8$var$messages.copiedPageGreetingTitle)
            };
            return undefined;
        };
        const customGreeting = getCustomGreeting();
        return {
            getActions: async ()=>{
                if (isEmptyPageWithPromptCards) return Promise.resolve((0, $efb362169c233167$export$4e5c71902381581b)(promptCards));
                if (editorActionsContext?.reference) return Promise.resolve(editorActions);
                // Find create-new-content action
                const createNewContentAction = viewPageRovoActions.find((action)=>action.actionId === 'create-new-content');
                // If create-new-content action exists, reposition it to 4th item, last visible before show more
                if (createNewContentAction) {
                    // Filter out create-new-content from view page actions
                    // Small bounded array (typically <10 actions), no risk of quadratic performance issues.
                    // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
                    const viewPageActionsWithoutCreate = viewPageRovoActions.filter((action)=>action.actionId !== 'create-new-content').map((action)=>action.action);
                    // Build final actions array
                    const combinedActions = [
                        ...editorActions,
                        ...viewPageActionsWithoutCreate
                    ];
                    // Insert create-new-content at position index 3 (4th position), or at the end if there are less than 3 actions
                    const insertIndex = Math.min(3, combinedActions.length);
                    combinedActions.splice(insertIndex, 0, createNewContentAction.action);
                    return Promise.resolve(combinedActions);
                }
                // Fallback: no create-new-content action, use original behavior
                const viewPageActions = viewPageRovoActions.map((action)=>action.action);
                return Promise.resolve([
                    ...editorActions,
                    ...viewPageActions
                ]);
            },
            customGreeting: customGreeting,
            shouldShowGreeting: customGreeting !== undefined || undefined,
            prioritizeCustomActionResults: isEmptyPageWithPromptCards ? true : undefined
        };
    }, [
        editorActions,
        editorActionsContext,
        viewPageRovoActions,
        isEmptyPageWithPromptCards,
        promptCards,
        formatMessage
    ]);
    (0, $42omo.useEffect)(()=>{
        setConfiguration(config);
        if (!enableLiveDocNudges) {
            setNudges([]);
            return;
        }
        const nudges = [
            viewPageRovoActions.find((a)=>a.actionId === 'audio-briefing')?.action
        ].filter(Boolean);
        if (nudges.length > 0) setNudges(nudges);
    }, [
        config,
        setConfiguration,
        enableLiveDocNudges,
        viewPageRovoActions,
        setNudges,
        contentType,
        contentId
    ]);
    return null;
};
const $7e583ad86f1e8aa8$export$d95c465cd9bfae9f = (props)=>{
    const { contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7e583ad86f1e8aa8$var$EditPageConfigProviderInner, props));
};


















var $gIaMn = parcelRequire("gIaMn");




var $5Abqh = parcelRequire("5Abqh");


const $8a4bdd953279ff48$export$75b705e7e413826a = (0, $jmjWc.LoadableActivatable)({
    __loadable_id__: "h5GrM",
    name: "AudioButtonLoaderActivatable",
    loader: async ()=>(await (parcelRequire("17128"))).AudioButton,
    triggers: [
        {
            type: (0, $gIaMn.ActivationTriggerType).HOVER
        }
    ],
    ssrSuccessCheckName: (0, $5Abqh.SSR_PARTIAL_COMPONENT).AudioButton
});

const $8a4bdd953279ff48$export$2cf028d3aae3c5f9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IJrya",
    name: "AudioButtonLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("17128"))).AudioButton
});


const $46bbba5af56c1c8e$export$6210e0bba7c89213 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(8);
    const { isView: isView, contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = props;
    if (isView && (0, $6mKj3.expVal)("confluence_selective_hydration_audio_button", "isEnabled", false)) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== contentId || $[3] !== contentTitle || $[4] !== contentType || $[5] !== isDisabled || $[6] !== spaceKey) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a4bdd953279ff48$export$2cf028d3aae3c5f9), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            contentTitle: contentTitle,
            isDisabled: isDisabled
        });
        $[2] = contentId;
        $[3] = contentTitle;
        $[4] = contentType;
        $[5] = isDisabled;
        $[6] = spaceKey;
        $[7] = t0;
    } else t0 = $[7];
    return t0;
} : (props)=>{
    const { isView: isView, contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = props;
    if (isView && (0, $6mKj3.expVal)('confluence_selective_hydration_audio_button', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper, props);
    // functionality is unchanged, AudioButton is only wrapped in a Loadable
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a4bdd953279ff48$export$2cf028d3aae3c5f9), {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        contentTitle: contentTitle,
        isDisabled: isDisabled
    });
};
/**
 * Internal component used only when selective hydration is enabled.
 * Contains all SH-specific logic (browser support, keyboard focus unlock).
 *
 * JS for AudioButton is delayed until user hovers (currently for View Page and Space Overviews)
 * Cases for immediate unlock (bypassing selective hydration) include:
 *
 * Disabled browser (Firefox)
 * User activation via keyboard (tab)
 *
 */ const $46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = t0;
    const wrapperRef = (0, $42omo.useRef)(null);
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $42omo.useState)(true);
    const [isFocusActivated, setIsFocusActivated] = (0, $42omo.useState)(false);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            const isAudioSupportedByBrowser = typeof MediaSource !== "undefined" && MediaSource.isTypeSupported("audio/mpeg");
            if (!isAudioSupportedByBrowser) (0, $42omo.startTransition)(()=>{
                setAudioSupportedByBrowser(false);
            });
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const wrapper = wrapperRef.current;
            if (!wrapper) return;
            const handleFocus = (event)=>{
                const target = event.target;
                if (!target || !target.matches("button, [role=\"button\"]")) return;
                const isKeyboardFocus = target.matches(":focus-visible");
                if (!isKeyboardFocus) return;
                (0, $42omo.startTransition)(()=>{
                    setIsFocusActivated(true);
                });
            };
            wrapper.addEventListener("focus", handleFocus, true);
            return ()=>{
                wrapper.removeEventListener("focus", handleFocus, true);
            };
        };
        t4 = [];
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    (0, $42omo.useEffect)(t3, t4);
    const immediateActivationCondition = audioSupportedByBrowser === false || isFocusActivated;
    let t5;
    if ($[4] !== audioSupportedByBrowser || $[5] !== isDisabled || $[6] !== renderServerPlaceholder) {
        t5 = isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false) || !renderServerPlaceholder && !audioSupportedByBrowser;
        $[4] = audioSupportedByBrowser;
        $[5] = isDisabled;
        $[6] = renderServerPlaceholder;
        $[7] = t5;
    } else t5 = $[7];
    const isButtonDisabled = t5;
    const t6 = audioSupportedByBrowser ?? true;
    let t7;
    if ($[8] !== t6) {
        t7 = {
            audioSupportedByBrowserFromWrapper: t6
        };
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    const wrapperProps = t7;
    let t8;
    if ($[10] !== contentId || $[11] !== contentTitle || $[12] !== contentType || $[13] !== immediateActivationCondition || $[14] !== isButtonDisabled || $[15] !== spaceKey || $[16] !== wrapperProps) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: wrapperRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a4bdd953279ff48$export$75b705e7e413826a), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            contentTitle: contentTitle,
            isDisabled: isButtonDisabled,
            immediateActivationCondition: immediateActivationCondition,
            selectiveHydrationEnabled: true,
            ...wrapperProps
        }));
        $[10] = contentId;
        $[11] = contentTitle;
        $[12] = contentType;
        $[13] = immediateActivationCondition;
        $[14] = isButtonDisabled;
        $[15] = spaceKey;
        $[16] = wrapperProps;
        $[17] = t8;
    } else t8 = $[17];
    return t8;
} : ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    // Assume audio is enabled for SSR until client-side useEffect checks browser support
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $42omo.useState)(true);
    const [isFocusActivated, setIsFocusActivated] = (0, $42omo.useState)(false);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    (0, $42omo.useEffect)(()=>{
        // Only check audio support when selective hydration is enabled.
        // For FG-OFF we rely on the browser check within AudioButton.
        const isAudioSupportedByBrowser = typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg');
        if (!isAudioSupportedByBrowser) (0, $42omo.startTransition)(()=>{
            setAudioSupportedByBrowser(false);
        });
    }, []);
    (0, $42omo.useEffect)(()=>{
        // Focus listener to determine if a user has tabbed to the button via keyboard, in which case
        // the component is immediately hydrated. This listener must live outside AudioButton code and hydrate if button is activated.
        const wrapper = wrapperRef.current;
        if (!wrapper) return;
        const handleFocus = (event)=>{
            const target = event.target;
            if (!target || !target.matches('button, [role="button"]')) return;
            const isKeyboardFocus = target.matches(':focus-visible');
            if (!isKeyboardFocus) return;
            (0, $42omo.startTransition)(()=>{
                setIsFocusActivated(true);
            });
        };
        wrapper.addEventListener('focus', handleFocus, true);
        return ()=>{
            wrapper.removeEventListener('focus', handleFocus, true);
        };
    }, []);
    // Only immediately hydrate if:
    // 1) audio button is not supported by browser (firefox) and component needs to hydrate to show as disabled on page load
    // 2) user activates the button via keyboard focus
    const immediateActivationCondition = audioSupportedByBrowser === false || isFocusActivated;
    const isButtonDisabled = isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) || !renderServerPlaceholder && !audioSupportedByBrowser;
    const wrapperProps = {
        audioSupportedByBrowserFromWrapper: audioSupportedByBrowser ?? true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a4bdd953279ff48$export$75b705e7e413826a), {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        contentTitle: contentTitle,
        isDisabled: isButtonDisabled,
        immediateActivationCondition: immediateActivationCondition,
        selectiveHydrationEnabled: true,
        ...wrapperProps
    }));
};
























var $h8ZMZ = parcelRequire("h8ZMZ");

/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 


parcelRequire("42omo");

const $507d1897964ccd80$export$dfb24f670bfd5854 = ()=>{
    const width = 24;
    const height = 24;
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 156 156",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                filter: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        clipPath: "url(#b)",
                        "data-figma-skip-parse": "true",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("foreignObject", {
                            width: 1789.03,
                            height: 1789.03,
                            x: -894.514,
                            y: -894.514,
                            transform: "matrix(.05 -.06262 .06262 .05 74 74)",
                            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                style: {
                                    background: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
                                    'conic-gradient(from 90deg,#fca700 0deg,#fca700 72.6913deg,#6a9922 72.7273deg,#6a9922 167.895deg,#1868db 167.931deg,#1868db 252.667deg,#af59e0 252.703deg,#af59e0 360deg)',
                                    height: '100%',
                                    width: '100%',
                                    opacity: 1
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M24 24h100v100H24z",
                        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":100.00002288818359,"m01":125.23040008544922,"m02":-38.615222930908203,"m10":-125.23040008544922,"m11":100.00002288818359,"m12":86.615180969238281},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "b",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M24 24h100v100H24z"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("filter", {
                        id: "a",
                        width: 164,
                        height: 164,
                        x: -8,
                        y: -8,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("feGaussianBlur", {
                                result: "effect1_foregroundBlur_3077_178",
                                stdDeviation: 16
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


function $cd68455bb63fab05$export$eca6b6ab857179f1({ contentId: contentId, cloudId: cloudId, contentType: contentType }) {
    const { isHerActive: isHerActive, toggleHer: toggleHer } = (0, $h8ZMZ.useHerStore)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        toggleHer(contentId, cloudId, contentType);
    }, [
        toggleHer,
        contentId,
        cloudId,
        contentType
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: "Enterprise HER",
        position: "left",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
            appearance: "subtle",
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $507d1897964ccd80$export$dfb24f670bfd5854), {}),
            label: "Enterprise HER",
            shape: "circle",
            isSelected: isHerActive,
            onClick: handleClick,
            testId: "enterprise-her-button"
        })
    });
}





const $d34346cf549a725a$export$2501aa4690daf770 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { contentId: contentId, contentType: contentType } = t0;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== contentType) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cd68455bb63fab05$export$eca6b6ab857179f1), {
            contentId: contentId,
            contentType: contentType,
            cloudId: cloudId
        });
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = contentType;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ contentId: contentId, contentType: contentType })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cd68455bb63fab05$export$eca6b6ab857179f1), {
        contentId: contentId,
        contentType: contentType,
        cloudId: cloudId
    });
};



var $4ZXww = parcelRequire("4ZXww");


var $fgdVB = parcelRequire("fgdVB");

const $3265ee1fae39f7d6$var$hoistedNav4RightSlotWidthVar = [
    '--right',
    'PanelWidth'
].join('');

const $3265ee1fae39f7d6$var$CommentPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "R3F99",
    name: "CommentPanelButton",
    loader: async ()=>(await (parcelRequire("k7UhM"))).CommentPanelButton
});

const $3265ee1fae39f7d6$var$DetailsPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wgj5o",
    name: "DetailsPanelButton",
    loader: async ()=>(await (parcelRequire("9Ima4"))).DetailsPanelButton
});

const $3265ee1fae39f7d6$var$EditorAIActions = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gSc9d",
    name: "EditorAIActions",
    loader: async ()=>(await (parcelRequire("7rWz7"))).EditorAIActions
});

const $3265ee1fae39f7d6$var$UndoButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KP43A",
    name: "UndoButton",
    loader: async ()=>(await (parcelRequire("7K4N2"))).UndoButton
});

const $3265ee1fae39f7d6$var$RedoButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "jZ8ML",
    name: "RedoButton",
    loader: async ()=>(await (parcelRequire("7K4N2"))).RedoButton
});

const $3265ee1fae39f7d6$var$ShowDiffButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "41USm",
    name: "ShowDiffButton",
    loader: async ()=>(await (parcelRequire("3abxA"))).ShowDiffButton
});

const $3265ee1fae39f7d6$var$FeedbackCollectorButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "erEzF",
    name: "FeedbackCollectorButton",
    loader: async ()=>(await (parcelRequire("6HPDw"))).FeedbackCollectorButton
});

const $3265ee1fae39f7d6$var$RemixPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CmH6Z",
    name: "RemixPanelButton",
    loader: async ()=>(await (parcelRequire("6hYoU"))).RemixPanelButton
});

const $3265ee1fae39f7d6$var$AudioListenButtonWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bAx22",
    name: "AudioListenButtonWrapper",
    loader: async ()=>(await (parcelRequire("f9r3q"))).AudioListenButtonWrapper
});

const $3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "hFsXW",
    name: "ObjectSidebarSpotlightTour",
    loader: async ()=>(await (parcelRequire("7mgQ0"))).ObjectSidebarSpotlightTour
});
const $3265ee1fae39f7d6$var$objectSidebarStyles = null;
const $3265ee1fae39f7d6$var$objectSidebarPaddingStyles = null;
const $3265ee1fae39f7d6$var$databaseObjectSidebarPaddingStyles = null;
const $3265ee1fae39f7d6$var$largeBottomPaddingStyles = null;
const $3265ee1fae39f7d6$var$viewModeStylesWithLegacyFooter = null;
const $3265ee1fae39f7d6$var$viewModeStylesWithNewFooter = null;
const $3265ee1fae39f7d6$var$miniModalModeStyles = null;
const $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.full'
});
const $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.xlarge'
});
const $3265ee1fae39f7d6$var$collapsibleContainerStyles = null;
const $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.100',
    marginBottom: 'space.050'
});
const $3265ee1fae39f7d6$var$rovoButtonCollapsibleBottomSidebarStyles = null;
const $3265ee1fae39f7d6$var$collapsibleToggleStyles = null;
const $3265ee1fae39f7d6$var$dividerStyle = (0, $ecnYn.xcss)({
    borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    display: 'inline-block',
    width: '16px',
    height: '1px'
});
const $3265ee1fae39f7d6$var$hiddenStyles = null;
const $3265ee1fae39f7d6$var$i18n = (0, $aXWIB.defineMessages)({
    expandToggleLabel: {
        id: "object-sidebar-components.expand-toggle-label",
        defaultMessage: "Expand action bar"
    },
    collapseToggleLabel: {
        id: "object-sidebar-components.collapse-toggle-label",
        defaultMessage: "Collapse action bar"
    }
});
const $3265ee1fae39f7d6$export$3fab07431350539e = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(204);
    const { hasCommentsButton: hasCommentsButton, hasDetailsButton: hasDetailsButton, hasLoomButton: hasLoomButton, hasAiButton: hasAiButton, hasRemixButton: hasRemixButton, undoRedoButtonActions: undoRedoButtonActions, hasUndoRedoButton: hasUndoRedoButton, showDiffButtonActions: showDiffButtonActions, hasAudioButton: hasAudioButton, hasFeedbackButton: t1, contentId: contentId, spaceKey: spaceKey, contentType: contentType, contentTitle: contentTitle, lastModifiedDate: lastModifiedDate, aiIsStreaming: t2, pageCommentsSectionInView: pageCommentsSectionInView, contentIdFromQuery: contentIdFromQuery, contentBodyDynamic: contentBodyDynamic, getAdfDocument: getAdfDocument, isUnpublishedDraft: isUnpublishedDraft, largeBottomPadding: largeBottomPadding, editorAIActions: editorAIActions, shouldDisableUndoRedo: t3, isDatabasesStagingArea: t4, disabled: disabled, isEditorEmpty: isEditorEmpty } = t0;
    const hasFeedbackButton = t1 === undefined ? true : t1;
    const aiIsStreaming = t2 === undefined ? false : t2;
    const shouldDisableUndoRedo = t3 === undefined ? false : t3;
    const isDatabasesStagingArea = t4 === undefined ? false : t4;
    const [t5] = (0, $kM55L.useCollabNetworkStatus)();
    const { isCollabOffline: isCollabOffline } = t5;
    let t6;
    if ($[0] !== isCollabOffline) {
        t6 = isCollabOffline && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false) && !(0, $9wGTI.fg)("platform_editor_offline_editing_wrapper_override");
        $[0] = isCollabOffline;
        $[1] = t6;
    } else t6 = $[1];
    const isNetworkDisabled = t6;
    const { isFullScreenEmbedView: isFullScreenEmbedView } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [actionBarIsHovered, setActionBarIsHovered] = (0, $42omo.useState)(false);
    const sidebarControlState = (0, $aWwYt.useSidebarControlState)();
    const sidebarControlExpandCollapsedState = (0, $aWwYt.useSidebarControlExpandCollapsedState)();
    const { setSidebarControlState: setSidebarControlState, toggleObjectSidebarControl: toggleObjectSidebarControl, setSidebarControlExpandCollapsedState: setSidebarControlExpandCollapsedState } = (0, $aWwYt.useObjectSidebarActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const { width: previewPanelWidth } = (0, $3qFIQ.usePreviewPanelsState)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    let t7;
    if ($[2] !== rightSidebarContext) {
        t7 = rightSidebarContext.getCurrent() || {};
        $[2] = rightSidebarContext;
        $[3] = t7;
    } else t7 = $[3];
    const { width: globalSidebarWidth } = t7;
    const { mode: rovoExperienceMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    let t8;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            selector: $3265ee1fae39f7d6$var$_temp
        };
        $[4] = t8;
    } else t8 = $[4];
    const isOnPDFExportPageRouteArgs = t8;
    const isOnPDFExportPageRoute = (0, $dPJCf.useRouteName)(isOnPDFExportPageRouteArgs);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [t9] = (0, $efvKr.useLivePageMode)();
    const { isViewMode: isLiveViewMode } = t9;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t10;
    if ($[5] !== setSidebarControlExpandCollapsedState) {
        t10 = ()=>{
            setSidebarControlExpandCollapsedState("expanded");
        };
        $[5] = setSidebarControlExpandCollapsedState;
        $[6] = t10;
    } else t10 = $[6];
    let t11;
    if ($[7] !== contentId || $[8] !== setSidebarControlExpandCollapsedState) {
        t11 = [
            contentId,
            setSidebarControlExpandCollapsedState
        ];
        $[7] = contentId;
        $[8] = setSidebarControlExpandCollapsedState;
        $[9] = t11;
    } else t11 = $[9];
    (0, $42omo.useEffect)(t10, t11);
    let t12;
    let t13;
    if ($[10] !== setSidebarControlExpandCollapsedState || $[11] !== setSidebarControlState) {
        t12 = ()=>{
            setSidebarControlState("shown");
            setSidebarControlExpandCollapsedState("expanded");
            return ()=>{
                setSidebarControlExpandCollapsedState("collapsed");
            };
        };
        t13 = [
            setSidebarControlState,
            setSidebarControlExpandCollapsedState
        ];
        $[10] = setSidebarControlExpandCollapsedState;
        $[11] = setSidebarControlState;
        $[12] = t12;
        $[13] = t13;
    } else {
        t12 = $[12];
        t13 = $[13];
    }
    (0, $42omo.useEffect)(t12, t13);
    const sidebarIsExpanded = sidebarControlExpandCollapsedState === "expanded" || renderServerPlaceholder;
    let collapsedActions;
    let primaryActions;
    let secondaryActions;
    let secondaryActionsTeam25;
    if ($[14] !== aiIsStreaming || $[15] !== contentBodyDynamic?.value || $[16] !== contentId || $[17] !== contentTitle || $[18] !== contentType || $[19] !== disabled || $[20] !== editorAIActions || $[21] !== getAdfDocument || $[22] !== hasAudioButton || $[23] !== hasCommentsButton || $[24] !== hasDetailsButton || $[25] !== hasFeedbackButton || $[26] !== hasLoomButton || $[27] !== hasRemixButton || $[28] !== hasUndoRedoButton || $[29] !== isDatabasesStagingArea || $[30] !== isEditorEmpty || $[31] !== isLiveViewMode || $[32] !== isLoomDisabled || $[33] !== isNetworkDisabled || $[34] !== isRovoButtonEnabled || $[35] !== pageMode || $[36] !== shouldDisableUndoRedo || $[37] !== showDiffButtonActions || $[38] !== sidebarIsExpanded || $[39] !== spaceKey || $[40] !== undoRedoButtonActions) {
        collapsedActions = [];
        primaryActions = [];
        if (hasUndoRedoButton && undoRedoButtonActions && !isLiveViewMode && (0, $9wGTI.fg)("aifc_create_enabled") && isDatabasesStagingArea) {
            const { canUndo: canUndo, undo: undo, canRedo: canRedo, redo: redo } = undoRedoButtonActions;
            if (undo && canUndo !== undefined) {
                const t14 = aiIsStreaming || shouldDisableUndoRedo;
                let t15;
                if ($[45] !== canUndo || $[46] !== t14 || $[47] !== undo) {
                    t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$UndoButton, {
                        canUndo: canUndo,
                        undo: undo,
                        isDisabled: t14
                    });
                    $[45] = canUndo;
                    $[46] = t14;
                    $[47] = undo;
                    $[48] = t15;
                } else t15 = $[48];
                primaryActions.push(t15);
            }
            if (redo && canRedo !== undefined) {
                const t14 = aiIsStreaming || shouldDisableUndoRedo;
                let t15;
                if ($[49] !== canRedo || $[50] !== redo || $[51] !== t14) {
                    t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$RedoButton, {
                        canRedo: canRedo,
                        redo: redo,
                        isDisabled: t14
                    });
                    $[49] = canRedo;
                    $[50] = redo;
                    $[51] = t14;
                    $[52] = t15;
                } else t15 = $[52];
                primaryActions.push(t15);
            }
        }
        if (showDiffButtonActions && !isLiveViewMode && (0, $9wGTI.fg)("aifc_create_enabled") && isDatabasesStagingArea) {
            const { onShowDiff: onShowDiff, isShowDiffEnabled: isShowDiffEnabled, isShowDiffSelected: isShowDiffSelected } = showDiffButtonActions;
            const t14 = isShowDiffEnabled && !aiIsStreaming;
            let t15;
            if ($[53] !== isShowDiffSelected || $[54] !== onShowDiff || $[55] !== t14) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$ShowDiffButton, {
                    isShowDiffSelected: isShowDiffSelected,
                    isShowDiffEnabled: t14,
                    onShowDiff: onShowDiff
                });
                $[53] = isShowDiffSelected;
                $[54] = onShowDiff;
                $[55] = t14;
                $[56] = t15;
            } else t15 = $[56];
            primaryActions.push(t15);
        }
        secondaryActions = [];
        secondaryActionsTeam25 = [];
        if ((0, $9wGTI.fg)("aifc_create_enabled")) {
            if (hasCommentsButton) {
                let t14;
                if ($[57] !== contentId || $[58] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                        key: "comment-panel-button",
                        contentId: contentId,
                        isDisabled: isNetworkDisabled
                    });
                    $[57] = contentId;
                    $[58] = isNetworkDisabled;
                    $[59] = t14;
                } else t14 = $[59];
                secondaryActionsTeam25.push(t14);
                if (!sidebarIsExpanded) {
                    let t15;
                    if ($[60] !== contentId || $[61] !== isNetworkDisabled) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                            key: "comment-panel-button-collapsed",
                            contentId: contentId,
                            collapsed: true,
                            isDisabled: isNetworkDisabled
                        });
                        $[60] = contentId;
                        $[61] = isNetworkDisabled;
                        $[62] = t15;
                    } else t15 = $[62];
                    collapsedActions.push(t15);
                }
            }
            if (hasDetailsButton) {
                let t14;
                if ($[63] !== contentId || $[64] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                        key: "details-panel-button",
                        contentId: contentId,
                        isDisabled: isNetworkDisabled
                    });
                    $[63] = contentId;
                    $[64] = isNetworkDisabled;
                    $[65] = t14;
                } else t14 = $[65];
                secondaryActionsTeam25.push(t14);
                if (!sidebarIsExpanded) {
                    let t15;
                    if ($[66] !== contentId || $[67] !== isNetworkDisabled) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                            key: "details-panel-button-collapsed",
                            contentId: contentId,
                            collapsed: true,
                            isDisabled: isNetworkDisabled
                        });
                        $[66] = contentId;
                        $[67] = isNetworkDisabled;
                        $[68] = t15;
                    } else t15 = $[68];
                    collapsedActions.push(t15);
                }
            }
            if ((0, $6mKj3.isExperimentEnabled)("enterprise_her")) {
                const t14 = contentType ?? "";
                let t15;
                if ($[69] !== contentId || $[70] !== t14) {
                    t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d34346cf549a725a$export$2501aa4690daf770), {
                        key: "enterprise-her-button-wrapper",
                        contentId: contentId,
                        contentType: t14
                    });
                    $[69] = contentId;
                    $[70] = t14;
                    $[71] = t15;
                } else t15 = $[71];
                secondaryActionsTeam25.push(t15);
            }
            if (hasAudioButton) {
                if ((0, $6mKj3.isExperimentEnabled)("confluence_audio_v3")) {
                    const t14 = contentType ?? "";
                    const t15 = spaceKey ?? "";
                    const t16 = contentTitle ?? "";
                    let t17;
                    if ($[72] !== contentId || $[73] !== disabled || $[74] !== isRovoButtonEnabled || $[75] !== t14 || $[76] !== t15 || $[77] !== t16) {
                        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
                            key: "audio-listen-button-wrapper",
                            isRovoButtonEnabled: isRovoButtonEnabled,
                            contentId: contentId,
                            contentType: t14,
                            spaceKey: t15,
                            title: t16,
                            isAutoOpenDisabled: disabled
                        });
                        $[72] = contentId;
                        $[73] = disabled;
                        $[74] = isRovoButtonEnabled;
                        $[75] = t14;
                        $[76] = t15;
                        $[77] = t16;
                        $[78] = t17;
                    } else t17 = $[78];
                    secondaryActionsTeam25.push(t17);
                } else {
                    const t14 = pageMode === (0, $cD1qu.PageMode).VIEW;
                    let t15;
                    if ($[79] !== contentId || $[80] !== contentTitle || $[81] !== contentType || $[82] !== isNetworkDisabled || $[83] !== spaceKey || $[84] !== t14) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
                            key: "audio-button-loader-wrapper",
                            contentId: contentId,
                            contentType: contentType,
                            spaceKey: spaceKey,
                            contentTitle: contentTitle,
                            isDisabled: isNetworkDisabled,
                            isView: t14
                        });
                        $[79] = contentId;
                        $[80] = contentTitle;
                        $[81] = contentType;
                        $[82] = isNetworkDisabled;
                        $[83] = spaceKey;
                        $[84] = t14;
                        $[85] = t15;
                    } else t15 = $[85];
                    secondaryActionsTeam25.push(t15);
                }
            }
            if (hasLoomButton && !isLoomDisabled) {
                const t14 = spaceKey ?? "";
                const t15 = contentType ?? "";
                const t16 = !isRovoButtonEnabled;
                let t17;
                if ($[86] !== contentId || $[87] !== isNetworkDisabled || $[88] !== t14 || $[89] !== t15 || $[90] !== t16) {
                    t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
                        key: "page-header-loom-entry-point",
                        contentId: contentId,
                        crossSellPopupPlacement: "left-end",
                        crossSellSpotlightPlacement: "left-start",
                        spaceKey: t14,
                        contentType: t15,
                        isCircle: t16,
                        testId: "sidebar-loom-button",
                        source: "contentWrapper",
                        isDisabled: isNetworkDisabled
                    });
                    $[86] = contentId;
                    $[87] = isNetworkDisabled;
                    $[88] = t14;
                    $[89] = t15;
                    $[90] = t16;
                    $[91] = t17;
                } else t17 = $[91];
                secondaryActionsTeam25.push(t17);
            }
            if (editorAIActions) {
                let t14;
                if ($[92] !== aiIsStreaming || $[93] !== editorAIActions) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$EditorAIActions, {
                        key: "editor-ai-actions",
                        editorAIActions: editorAIActions,
                        isDisabled: aiIsStreaming
                    });
                    $[92] = aiIsStreaming;
                    $[93] = editorAIActions;
                    $[94] = t14;
                } else t14 = $[94];
                secondaryActionsTeam25.push(t14);
            }
            if (hasRemixButton && (0, $6mKj3.expValEquals)("cc-maui-object-level-remix-experiment", "isEnabled", true)) {
                const t14 = contentBodyDynamic?.value;
                let t15;
                if ($[95] !== getAdfDocument || $[96] !== isEditorEmpty || $[97] !== isNetworkDisabled || $[98] !== t14) {
                    t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$RemixPanelButton, {
                        key: "remix-panel-button",
                        contentBodyValue: t14,
                        getAdfDocument: getAdfDocument,
                        isEditorEmpty: isEditorEmpty,
                        isDisabled: isNetworkDisabled
                    });
                    $[95] = getAdfDocument;
                    $[96] = isEditorEmpty;
                    $[97] = isNetworkDisabled;
                    $[98] = t14;
                    $[99] = t15;
                } else t15 = $[99];
                secondaryActionsTeam25.push(t15);
            }
        } else {
            if (hasCommentsButton) {
                let t14;
                if ($[100] !== contentId || $[101] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                        key: "comment-panel-button",
                        contentId: contentId,
                        isDisabled: isNetworkDisabled
                    });
                    $[100] = contentId;
                    $[101] = isNetworkDisabled;
                    $[102] = t14;
                } else t14 = $[102];
                primaryActions.push(t14);
                if (!sidebarIsExpanded) {
                    let t15;
                    if ($[103] !== contentId || $[104] !== isNetworkDisabled) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                            key: "comment-panel-button-collapsed",
                            contentId: contentId,
                            collapsed: true,
                            isDisabled: isNetworkDisabled
                        });
                        $[103] = contentId;
                        $[104] = isNetworkDisabled;
                        $[105] = t15;
                    } else t15 = $[105];
                    collapsedActions.push(t15);
                }
            }
            if (hasDetailsButton) {
                let t14;
                if ($[106] !== contentId || $[107] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                        key: "details-panel-button",
                        contentId: contentId,
                        isDisabled: isNetworkDisabled
                    });
                    $[106] = contentId;
                    $[107] = isNetworkDisabled;
                    $[108] = t14;
                } else t14 = $[108];
                primaryActions.push(t14);
                if (!sidebarIsExpanded) {
                    let t15;
                    if ($[109] !== contentId || $[110] !== isNetworkDisabled) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                            key: "details-panel-button-collapsed",
                            contentId: contentId,
                            collapsed: true,
                            isDisabled: isNetworkDisabled
                        });
                        $[109] = contentId;
                        $[110] = isNetworkDisabled;
                        $[111] = t15;
                    } else t15 = $[111];
                    collapsedActions.push(t15);
                }
            }
            if (hasAudioButton) {
                if ((0, $6mKj3.isExperimentEnabled)("confluence_audio_v3")) {
                    const t14 = contentType ?? "";
                    const t15 = spaceKey ?? "";
                    const t16 = contentTitle ?? "";
                    let t17;
                    if ($[112] !== contentId || $[113] !== disabled || $[114] !== isRovoButtonEnabled || $[115] !== t14 || $[116] !== t15 || $[117] !== t16) {
                        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
                            key: "audio-listen-button-wrapper",
                            isRovoButtonEnabled: isRovoButtonEnabled,
                            contentId: contentId,
                            contentType: t14,
                            spaceKey: t15,
                            title: t16,
                            isAutoOpenDisabled: disabled
                        });
                        $[112] = contentId;
                        $[113] = disabled;
                        $[114] = isRovoButtonEnabled;
                        $[115] = t14;
                        $[116] = t15;
                        $[117] = t16;
                        $[118] = t17;
                    } else t17 = $[118];
                    secondaryActions.push(t17);
                } else {
                    const t14 = pageMode === (0, $cD1qu.PageMode).VIEW;
                    let t15;
                    if ($[119] !== contentId || $[120] !== contentTitle || $[121] !== contentType || $[122] !== isNetworkDisabled || $[123] !== spaceKey || $[124] !== t14) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
                            key: "audio-button-loader-wrapper",
                            contentId: contentId,
                            contentType: contentType,
                            spaceKey: spaceKey,
                            contentTitle: contentTitle,
                            isDisabled: isNetworkDisabled,
                            isView: t14
                        });
                        $[119] = contentId;
                        $[120] = contentTitle;
                        $[121] = contentType;
                        $[122] = isNetworkDisabled;
                        $[123] = spaceKey;
                        $[124] = t14;
                        $[125] = t15;
                    } else t15 = $[125];
                    secondaryActions.push(t15);
                }
            }
            if (hasLoomButton && !isLoomDisabled) {
                const t14 = spaceKey ?? "";
                const t15 = contentType ?? "";
                const t16 = !isRovoButtonEnabled;
                let t17;
                if ($[126] !== contentId || $[127] !== isNetworkDisabled || $[128] !== t14 || $[129] !== t15 || $[130] !== t16) {
                    t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
                        key: "page-header-loom-entry-point",
                        contentId: contentId,
                        crossSellPopupPlacement: "left-end",
                        crossSellSpotlightPlacement: "left-start",
                        spaceKey: t14,
                        contentType: t15,
                        isCircle: t16,
                        testId: "sidebar-loom-button",
                        source: "contentWrapper",
                        isDisabled: isNetworkDisabled
                    });
                    $[126] = contentId;
                    $[127] = isNetworkDisabled;
                    $[128] = t14;
                    $[129] = t15;
                    $[130] = t16;
                    $[131] = t17;
                } else t17 = $[131];
                secondaryActions.push(t17);
            }
            if (hasFeedbackButton) {
                let t14;
                if ($[132] !== contentId || $[133] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$FeedbackCollectorButton, {
                        key: "feedback-collector-button",
                        contentId: contentId,
                        isDisabled: isNetworkDisabled
                    });
                    $[132] = contentId;
                    $[133] = isNetworkDisabled;
                    $[134] = t14;
                } else t14 = $[134];
                secondaryActions.push(t14);
            }
        }
        $[14] = aiIsStreaming;
        $[15] = contentBodyDynamic?.value;
        $[16] = contentId;
        $[17] = contentTitle;
        $[18] = contentType;
        $[19] = disabled;
        $[20] = editorAIActions;
        $[21] = getAdfDocument;
        $[22] = hasAudioButton;
        $[23] = hasCommentsButton;
        $[24] = hasDetailsButton;
        $[25] = hasFeedbackButton;
        $[26] = hasLoomButton;
        $[27] = hasRemixButton;
        $[28] = hasUndoRedoButton;
        $[29] = isDatabasesStagingArea;
        $[30] = isEditorEmpty;
        $[31] = isLiveViewMode;
        $[32] = isLoomDisabled;
        $[33] = isNetworkDisabled;
        $[34] = isRovoButtonEnabled;
        $[35] = pageMode;
        $[36] = shouldDisableUndoRedo;
        $[37] = showDiffButtonActions;
        $[38] = sidebarIsExpanded;
        $[39] = spaceKey;
        $[40] = undoRedoButtonActions;
        $[41] = collapsedActions;
        $[42] = primaryActions;
        $[43] = secondaryActions;
        $[44] = secondaryActionsTeam25;
    } else {
        collapsedActions = $[41];
        primaryActions = $[42];
        secondaryActions = $[43];
        secondaryActionsTeam25 = $[44];
    }
    let t14;
    bb0: {
        if (pageMode === (0, $cD1qu.PageMode).VIEW || pageMode === (0, $cD1qu.PageMode).LIVE && isLiveViewMode) {
            let t15;
            if ($[135] === Symbol.for("react.memo_cache_sentinel")) {
                t15 = {
                    experience: (0, $dppWL.RegisteredExperience).VIEW_PAGE,
                    provider: (0, $2b7ed8ae830eb95a$export$299010de885adda)
                };
                $[135] = t15;
            } else t15 = $[135];
            t14 = t15;
            break bb0;
        }
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode) {
            let t15;
            if ($[136] === Symbol.for("react.memo_cache_sentinel")) {
                t15 = {
                    experience: (0, $dppWL.RegisteredExperience).EDIT_PAGE,
                    provider: (0, $7e583ad86f1e8aa8$export$d95c465cd9bfae9f)
                };
                $[136] = t15;
            } else t15 = $[136];
            t14 = t15;
            break bb0;
        }
        t14 = undefined;
    }
    const rovoConfiguration = t14;
    if (isOnPDFExportPageRoute) return null;
    const previewPanelOffsetPx = pageMode === (0, $cD1qu.PageMode).VIEW && previewPanelWidth ? previewPanelWidth : 0;
    const globalSidebarMargin = pageMode === (0, $cD1qu.PageMode).VIEW && globalSidebarWidth ? globalSidebarWidth : 0;
    let t15;
    if ($[137] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
        $[137] = t15;
    } else t15 = $[137];
    const isEmbeddedConfluence = t15;
    const shouldRenderWhenEmbedded = isEmbeddedConfluence ? isDatabasesStagingArea || isFullScreenEmbedView : !isEmbeddedConfluence;
    const shouldRenderIntegratedExpandButton = !hasAiButton && !sidebarIsExpanded;
    const shouldDisplayHoverToggle = sidebarIsExpanded && actionBarIsHovered || hasAiButton && !sidebarIsExpanded;
    const shouldRenderAISmartButton = hasAiButton && shouldRenderWhenEmbedded && !isMobileApp;
    const isRovoMiniModalShown = shouldRenderAISmartButton && isRovoButtonEnabled && rovoExperienceMode === (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL;
    let t16;
    if ($[138] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = ()=>{
            setActionBarIsHovered(true);
        };
        $[138] = t16;
    } else t16 = $[138];
    const handleMouseEnter = t16;
    let t17;
    if ($[139] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = ()=>{
            setActionBarIsHovered(false);
        };
        $[139] = t17;
    } else t17 = $[139];
    const handleMouseLeave = t17;
    let t18;
    if ($[140] !== sidebarIsExpanded || $[141] !== toggleObjectSidebarControl) {
        t18 = ()=>{
            toggleObjectSidebarControl();
            setActionBarIsHovered(!sidebarIsExpanded);
        };
        $[140] = sidebarIsExpanded;
        $[141] = toggleObjectSidebarControl;
        $[142] = t18;
    } else t18 = $[142];
    const onToggleClick = t18;
    let t19;
    if ($[143] !== formatMessage || $[144] !== sidebarIsExpanded) {
        t19 = sidebarIsExpanded ? formatMessage($3265ee1fae39f7d6$var$i18n.collapseToggleLabel) : formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
        $[143] = formatMessage;
        $[144] = sidebarIsExpanded;
        $[145] = t19;
    } else t19 = $[145];
    const toggleLabel = t19;
    let t20;
    if ($[146] !== formatMessage) {
        t20 = formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
        $[146] = formatMessage;
        $[147] = t20;
    } else t20 = $[147];
    let t21;
    if ($[148] !== toggleLabel || $[149] !== toggleObjectSidebarControl) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: $3265ee1fae39f7d6$var$_temp2,
            label: toggleLabel,
            onClick: toggleObjectSidebarControl,
            shape: "circle",
            testId: "integrated-expand-button"
        });
        $[148] = toggleLabel;
        $[149] = toggleObjectSidebarControl;
        $[150] = t21;
    } else t21 = $[150];
    let t22;
    if ($[151] !== t20 || $[152] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "left",
            content: t20,
            hideTooltipOnClick: true
        }, t21);
        $[151] = t20;
        $[152] = t21;
        $[153] = t22;
    } else t22 = $[153];
    const integratedExpandButton = t22;
    const t23 = "object-sidebar-container";
    const t24 = "object-sidebar-container";
    let t25;
    if ($[154] !== globalSidebarMargin || $[155] !== pageMode || $[156] !== previewPanelOffsetPx) {
        t25 = {
            ...(0, $6mKj3.expVal)("confluence_object_sidebar_nav4_width_inset", "isEnabled", false) ? {
                right: pageMode === (0, $cD1qu.PageMode).VIEW ? `calc(var(${$3265ee1fae39f7d6$var$hoistedNav4RightSlotWidthVar}, 0px))` : "0px",
                marginRight: 0
            } : {
                right: "0px",
                marginRight: globalSidebarMargin + previewPanelOffsetPx
            }
        };
        $[154] = globalSidebarMargin;
        $[155] = pageMode;
        $[156] = previewPanelOffsetPx;
        $[157] = t25;
    } else t25 = $[157];
    const t26 = (0, $gMc0m.default)([
        "_v564ul29 _kqsw1n9t _94n5idpf _1pbyowjs _lcxvglyw _w1y61wug",
        (contentType === "page" || contentType === "blogpost" || pageMode === (0, $cD1qu.PageMode).VIEW) && "_u5f31ejb _n3tdu2gc",
        (contentType === "database" || contentType === "slide") && "_u5f3u2gc _n3tdu2gc",
        largeBottomPadding && "_n3td1ejb",
        isRovoMiniModalShown && "_1pby16oo",
        pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") && "_1pbykb7n",
        pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && "_1pbycs5v",
        !renderServerPlaceholder && sidebarControlState === "hidden" && "_1e0cglyw"
    ]);
    let t27;
    if ($[158] !== actionBarIsHovered || $[159] !== collapsedActions || $[160] !== contentId || $[161] !== integratedExpandButton || $[162] !== isMobileApp || $[163] !== isRovoButtonEnabled || $[164] !== onToggleClick || $[165] !== primaryActions || $[166] !== renderServerPlaceholder || $[167] !== secondaryActions || $[168] !== secondaryActionsTeam25 || $[169] !== shouldDisplayHoverToggle || $[170] !== shouldRenderIntegratedExpandButton || $[171] !== shouldRenderWhenEmbedded || $[172] !== sidebarIsExpanded || $[173] !== toggleLabel) {
        t27 = primaryActions.length + secondaryActions.length + secondaryActionsTeam25.length > 0 && shouldRenderWhenEmbedded && !isMobileApp && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), null, (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1bsboahv _18u01wug"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "left",
            content: toggleLabel,
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                paddingBottom: sidebarIsExpanded ? "var(--ds-space-100, 8px)" : undefined,
                visibility: shouldDisplayHoverToggle ? "visible" : "hidden"
            },
            "data-testid": "collapsible-hover-toggle",
            className: (0, $gMc0m.default)([
                "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsbxy5q"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (iconProps_0)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    ...iconProps_0,
                    size: "small"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                    ...iconProps_0,
                    size: "small"
                }),
            label: toggleLabel,
            onClick: onToggleClick,
            shape: "circle",
            testId: "collapsible-hover-button"
        })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).OBJECT_SIDEBAR_CONTROL
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1bsboahv _18u01wug"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "left",
            content: toggleLabel,
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                paddingBottom: sidebarIsExpanded ? "var(--ds-space-100, 8px)" : undefined,
                visibility: shouldDisplayHoverToggle ? "visible" : "hidden"
            },
            "data-testid": "collapsible-hover-toggle",
            className: (0, $gMc0m.default)([
                "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsbxy5q"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (iconProps_1)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    ...iconProps_1,
                    size: "small"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                    ...iconProps_1,
                    size: "small"
                }),
            label: toggleLabel,
            onClick: onToggleClick,
            shape: "circle",
            testId: "collapsible-hover-button"
        }))))), (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1bsboahv _18u01wug"
            ])
        }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AnimationWrapper, {
            actionBarIsHovered: actionBarIsHovered
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: isRovoButtonEnabled ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, primaryActions, (0, $9wGTI.fg)("aifc_create_enabled") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $3265ee1fae39f7d6$var$dividerStyle
        }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, secondaryActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $3265ee1fae39f7d6$var$dividerStyle
        }), secondaryActions))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, collapsedActions))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1bsboahv _18u01wug"
            ])
        }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AnimationWrapper, {
            actionBarIsHovered: actionBarIsHovered
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: isRovoButtonEnabled ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, primaryActions, (0, $9wGTI.fg)("aifc_create_enabled") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $3265ee1fae39f7d6$var$dividerStyle
        }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, secondaryActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $3265ee1fae39f7d6$var$dividerStyle
        }), secondaryActions))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, collapsedActions)), shouldRenderIntegratedExpandButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1bsboahv _18u01wug"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: isRovoButtonEnabled ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, integratedExpandButton)) : null, (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
            contentId: contentId
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
            contentId: contentId
        })));
        $[158] = actionBarIsHovered;
        $[159] = collapsedActions;
        $[160] = contentId;
        $[161] = integratedExpandButton;
        $[162] = isMobileApp;
        $[163] = isRovoButtonEnabled;
        $[164] = onToggleClick;
        $[165] = primaryActions;
        $[166] = renderServerPlaceholder;
        $[167] = secondaryActions;
        $[168] = secondaryActionsTeam25;
        $[169] = shouldDisplayHoverToggle;
        $[170] = shouldRenderIntegratedExpandButton;
        $[171] = shouldRenderWhenEmbedded;
        $[172] = sidebarIsExpanded;
        $[173] = toggleLabel;
        $[174] = t27;
    } else t27 = $[174];
    let t28;
    if ($[175] !== contentBodyDynamic || $[176] !== contentId || $[177] !== contentIdFromQuery || $[178] !== contentTitle || $[179] !== contentType || $[180] !== isEditorEmpty || $[181] !== isEmbeddedConfluence || $[182] !== isLivePage || $[183] !== isNetworkDisabled || $[184] !== isRovoButtonEnabled || $[185] !== isUnpublishedDraft || $[186] !== lastModifiedDate || $[187] !== pageCommentsSectionInView || $[188] !== pageMode || $[189] !== rovoConfiguration?.experience || $[190] !== rovoConfiguration?.provider || $[191] !== shouldRenderAISmartButton || $[192] !== spaceKey) {
        t28 = shouldRenderAISmartButton && (isRovoButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_ca0qu2gc _otyrpxbi _18u0t94y"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3tUdX.RovoConfigProvider), {
            experience: rovoConfiguration?.experience,
            provider: rovoConfiguration?.provider,
            contentId: contentId,
            contentType: contentType ?? "",
            spaceKey: spaceKey ?? "",
            contentTitle: contentTitle ?? "",
            lastModifiedDate: lastModifiedDate,
            isUnpublishedDraft: isUnpublishedDraft,
            isEditorEmpty: isEditorEmpty
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hU34N.AISmartButtonWrapper), {
            contentId: contentId,
            contentType: contentType ?? "",
            pageMode: pageMode,
            isDisabled: isNetworkDisabled,
            isSidebarAvailable: isEmbeddedConfluence ? false : undefined
        })) : contentType !== "database" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIQbF.AIFloatingContextMenu), {
            spaceKey: spaceKey ?? "",
            contentId: contentId,
            contentType: contentType ?? "",
            lastModifiedDate: lastModifiedDate,
            pageCommentsSectionInView: pageCommentsSectionInView,
            isLivePage: isLivePage,
            isInObjectSideBar: true,
            contentIdFromQuery: contentIdFromQuery,
            contentBodyDynamic: contentBodyDynamic
        })));
        $[175] = contentBodyDynamic;
        $[176] = contentId;
        $[177] = contentIdFromQuery;
        $[178] = contentTitle;
        $[179] = contentType;
        $[180] = isEditorEmpty;
        $[181] = isEmbeddedConfluence;
        $[182] = isLivePage;
        $[183] = isNetworkDisabled;
        $[184] = isRovoButtonEnabled;
        $[185] = isUnpublishedDraft;
        $[186] = lastModifiedDate;
        $[187] = pageCommentsSectionInView;
        $[188] = pageMode;
        $[189] = rovoConfiguration?.experience;
        $[190] = rovoConfiguration?.provider;
        $[191] = shouldRenderAISmartButton;
        $[192] = spaceKey;
        $[193] = t28;
    } else t28 = $[193];
    let t29;
    if ($[194] !== handleMouseEnter || $[195] !== handleMouseLeave || $[196] !== t25 || $[197] !== t26 || $[198] !== t27 || $[199] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": t23,
            "data-vc": t24,
            style: t25,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onFocus: handleMouseEnter,
            onBlur: handleMouseLeave,
            className: t26
        }, t27, t28);
        $[194] = handleMouseEnter;
        $[195] = handleMouseLeave;
        $[196] = t25;
        $[197] = t26;
        $[198] = t27;
        $[199] = t28;
        $[200] = t29;
    } else t29 = $[200];
    let t30;
    if ($[201] === Symbol.for("react.memo_cache_sentinel")) {
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
            metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
        });
        $[201] = t30;
    } else t30 = $[201];
    let t31;
    if ($[202] !== t29) {
        t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t29, t30);
        $[202] = t29;
        $[203] = t31;
    } else t31 = $[203];
    return t31;
} : ({ hasCommentsButton: hasCommentsButton, hasDetailsButton: hasDetailsButton, hasLoomButton: hasLoomButton, hasAiButton: hasAiButton, hasRemixButton: hasRemixButton, undoRedoButtonActions: undoRedoButtonActions, hasUndoRedoButton: hasUndoRedoButton, showDiffButtonActions: showDiffButtonActions, hasAudioButton: hasAudioButton, hasFeedbackButton: hasFeedbackButton = true, contentId: contentId, spaceKey: spaceKey, contentType: contentType, contentTitle: contentTitle, lastModifiedDate: lastModifiedDate, aiIsStreaming: aiIsStreaming = false, pageCommentsSectionInView: pageCommentsSectionInView, contentIdFromQuery: contentIdFromQuery, contentBodyDynamic: contentBodyDynamic, getAdfDocument: getAdfDocument, isUnpublishedDraft: isUnpublishedDraft, largeBottomPadding: largeBottomPadding, editorAIActions: editorAIActions, shouldDisableUndoRedo: shouldDisableUndoRedo = false, isDatabasesStagingArea: isDatabasesStagingArea = false, disabled: disabled, isEditorEmpty: isEditorEmpty })=>{
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)(); // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override');
    const { isFullScreenEmbedView: isFullScreenEmbedView } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [actionBarIsHovered, setActionBarIsHovered] = (0, $42omo.useState)(false);
    const sidebarControlState = (0, $aWwYt.useSidebarControlState)();
    const sidebarControlExpandCollapsedState = (0, $aWwYt.useSidebarControlExpandCollapsedState)();
    const { setSidebarControlState: setSidebarControlState, toggleObjectSidebarControl: toggleObjectSidebarControl, setSidebarControlExpandCollapsedState: setSidebarControlExpandCollapsedState } = (0, $aWwYt.useObjectSidebarActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const { width: previewPanelWidth } = (0, $3qFIQ.usePreviewPanelsState)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { width: globalSidebarWidth } = rightSidebarContext.getCurrent() || {};
    const { mode: rovoExperienceMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const isOnPDFExportPageRouteArgs = {
        selector: (routeName)=>{
            if (!routeName) return false;
            return routeName === (0, $1NBp8.PDF_EXPORT_PAGE).name;
        }
    };
    const isOnPDFExportPageRoute = (0, $dPJCf.useRouteName)(isOnPDFExportPageRouteArgs);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ isViewMode: isLiveViewMode }] = (0, $efvKr.useLivePageMode)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(); // whenever the contentID changes we needed to reset the action bar to be expanded
    (0, $42omo.useEffect)(()=>{
        setSidebarControlExpandCollapsedState('expanded');
    }, [
        contentId,
        setSidebarControlExpandCollapsedState
    ]);
    (0, $42omo.useEffect)(()=>{
        setSidebarControlState('shown');
        setSidebarControlExpandCollapsedState('expanded');
        return ()=>{
            setSidebarControlExpandCollapsedState('collapsed');
        };
    }, [
        setSidebarControlState,
        setSidebarControlExpandCollapsedState
    ]);
    const sidebarIsExpanded = sidebarControlExpandCollapsedState === 'expanded' || renderServerPlaceholder; // Collapsed actions are rendered when collapsed. These can be used e.g. to enable keyboard shortcuts while collapsed.
    const collapsedActions = [];
    const primaryActions = [];
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    hasUndoRedoButton && undoRedoButtonActions && !isLiveViewMode && (0, $9wGTI.fg)('aifc_create_enabled') && isDatabasesStagingArea) {
        const { canUndo: canUndo, undo: undo, canRedo: canRedo, redo: redo } = undoRedoButtonActions;
        if (undo && canUndo !== undefined) primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$UndoButton, {
            canUndo: canUndo,
            undo: undo,
            isDisabled: aiIsStreaming || shouldDisableUndoRedo
        }));
        if (redo && canRedo !== undefined) primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$RedoButton, {
            canRedo: canRedo,
            redo: redo,
            isDisabled: aiIsStreaming || shouldDisableUndoRedo
        }));
    }
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    showDiffButtonActions && !isLiveViewMode && (0, $9wGTI.fg)('aifc_create_enabled') && isDatabasesStagingArea) {
        const { onShowDiff: onShowDiff, isShowDiffEnabled: isShowDiffEnabled, isShowDiffSelected: isShowDiffSelected } = showDiffButtonActions;
        primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$ShowDiffButton, {
            isShowDiffSelected: isShowDiffSelected,
            isShowDiffEnabled: isShowDiffEnabled && !aiIsStreaming,
            onShowDiff: onShowDiff
        }));
    }
    const secondaryActions = [];
    const secondaryActionsTeam25 = [];
    if ((0, $9wGTI.fg)('aifc_create_enabled')) {
        if (hasCommentsButton) {
            secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                key: "comment-panel-button",
                contentId: contentId,
                isDisabled: isNetworkDisabled
            }));
            if (!sidebarIsExpanded) collapsedActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                key: "comment-panel-button-collapsed",
                contentId: contentId,
                collapsed: true,
                isDisabled: isNetworkDisabled
            }));
        }
        if (hasDetailsButton) {
            secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                key: "details-panel-button",
                contentId: contentId,
                isDisabled: isNetworkDisabled
            }));
            if (!sidebarIsExpanded) collapsedActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                key: "details-panel-button-collapsed",
                contentId: contentId,
                collapsed: true,
                isDisabled: isNetworkDisabled
            }));
        }
        if ((0, $6mKj3.isExperimentEnabled)('enterprise_her')) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d34346cf549a725a$export$2501aa4690daf770), {
            key: "enterprise-her-button-wrapper",
            contentId: contentId,
            contentType: contentType ?? ''
        }));
        if (hasAudioButton) {
            if ((0, $6mKj3.isExperimentEnabled)('confluence_audio_v3')) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
                key: "audio-listen-button-wrapper",
                isRovoButtonEnabled: isRovoButtonEnabled,
                contentId: contentId,
                contentType: contentType ?? '',
                spaceKey: spaceKey ?? '',
                title: contentTitle ?? '',
                isAutoOpenDisabled: disabled
            }));
            else secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
                key: "audio-button-loader-wrapper",
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey,
                contentTitle: contentTitle,
                isDisabled: isNetworkDisabled,
                isView: pageMode === (0, $cD1qu.PageMode).VIEW
            }));
        }
        if (hasLoomButton && !isLoomDisabled) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
            key: "page-header-loom-entry-point",
            contentId: contentId,
            crossSellPopupPlacement: "left-end",
            crossSellSpotlightPlacement: "left-start",
            spaceKey: spaceKey ?? '',
            contentType: contentType ?? '',
            isCircle: !isRovoButtonEnabled,
            testId: "sidebar-loom-button",
            source: "contentWrapper",
            isDisabled: isNetworkDisabled
        }));
        if (editorAIActions) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$EditorAIActions, {
            key: "editor-ai-actions",
            editorAIActions: editorAIActions,
            isDisabled: aiIsStreaming
        }));
        if (hasRemixButton && (0, $6mKj3.expValEquals)('cc-maui-object-level-remix-experiment', 'isEnabled', true)) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$RemixPanelButton, {
            key: "remix-panel-button",
            contentBodyValue: contentBodyDynamic?.value,
            getAdfDocument: getAdfDocument,
            isEditorEmpty: isEditorEmpty,
            isDisabled: isNetworkDisabled
        }));
    } else {
        if (hasCommentsButton) {
            primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                key: "comment-panel-button",
                contentId: contentId,
                isDisabled: isNetworkDisabled
            }));
            if (!sidebarIsExpanded) collapsedActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                key: "comment-panel-button-collapsed",
                contentId: contentId,
                collapsed: true,
                isDisabled: isNetworkDisabled
            }));
        }
        if (hasDetailsButton) {
            primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                key: "details-panel-button",
                contentId: contentId,
                isDisabled: isNetworkDisabled
            }));
            if (!sidebarIsExpanded) collapsedActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                key: "details-panel-button-collapsed",
                contentId: contentId,
                collapsed: true,
                isDisabled: isNetworkDisabled
            }));
        }
        if (hasAudioButton) {
            if ((0, $6mKj3.isExperimentEnabled)('confluence_audio_v3')) secondaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
                key: "audio-listen-button-wrapper",
                isRovoButtonEnabled: isRovoButtonEnabled,
                contentId: contentId,
                contentType: contentType ?? '',
                spaceKey: spaceKey ?? '',
                title: contentTitle ?? '',
                isAutoOpenDisabled: disabled
            }));
            else secondaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
                key: "audio-button-loader-wrapper",
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey,
                contentTitle: contentTitle,
                isDisabled: isNetworkDisabled,
                isView: pageMode === (0, $cD1qu.PageMode).VIEW
            }));
        }
        if (hasLoomButton && !isLoomDisabled) secondaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
            key: "page-header-loom-entry-point",
            contentId: contentId,
            crossSellPopupPlacement: "left-end",
            crossSellSpotlightPlacement: "left-start",
            spaceKey: spaceKey ?? '',
            contentType: contentType ?? '',
            isCircle: !isRovoButtonEnabled,
            testId: "sidebar-loom-button",
            source: "contentWrapper",
            isDisabled: isNetworkDisabled
        }));
        if (hasFeedbackButton) secondaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$FeedbackCollectorButton, {
            key: "feedback-collector-button",
            contentId: contentId,
            isDisabled: isNetworkDisabled
        }));
    }
    const rovoConfiguration = (0, $42omo.useMemo)(()=>{
        if (pageMode === (0, $cD1qu.PageMode).VIEW || pageMode === (0, $cD1qu.PageMode).LIVE && isLiveViewMode) return {
            experience: (0, $dppWL.RegisteredExperience).VIEW_PAGE,
            provider: (0, $2b7ed8ae830eb95a$export$299010de885adda)
        };
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode) return {
            experience: (0, $dppWL.RegisteredExperience).EDIT_PAGE,
            provider: (0, $7e583ad86f1e8aa8$export$d95c465cd9bfae9f)
        };
        return undefined;
    }, [
        pageMode,
        isLiveViewMode
    ]);
    if (isOnPDFExportPageRoute) return null;
    const previewPanelOffsetPx = pageMode === (0, $cD1qu.PageMode).VIEW && previewPanelWidth ? previewPanelWidth : 0;
    const globalSidebarMargin = pageMode === (0, $cD1qu.PageMode).VIEW && globalSidebarWidth ? globalSidebarWidth : 0;
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)(); // For databases in staging area, always allow rendering (isFullScreenEmbedView is typically undefined)
    const shouldRenderWhenEmbedded = isEmbeddedConfluence ? isDatabasesStagingArea || isFullScreenEmbedView : !isEmbeddedConfluence; // If there's no AI button, when we collapse the action bar, we need to render an expand icon within the
    // existing action bar container. If there is an AI button, hovering over it should render the expand icon
    const shouldRenderIntegratedExpandButton = !hasAiButton && !sidebarIsExpanded; // We always render the toggle component into the DOM, but we change its visibility based on:
    // If the action bar is expanded: show on hover (regardless of AI button)
    // If the action bar is collapsed: always show if AI button present, otherwise never show
    const shouldDisplayHoverToggle = sidebarIsExpanded && actionBarIsHovered || hasAiButton && !sidebarIsExpanded;
    const shouldRenderAISmartButton = hasAiButton && shouldRenderWhenEmbedded && !isMobileApp;
    const isRovoMiniModalShown = shouldRenderAISmartButton && isRovoButtonEnabled && rovoExperienceMode === (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL;
    const handleMouseEnter = ()=>{
        setActionBarIsHovered(true);
    };
    const handleMouseLeave = ()=>{
        setActionBarIsHovered(false);
    };
    const onToggleClick = ()=>{
        toggleObjectSidebarControl(); // need to make sure the hover (dis)appears after clicking it
        setActionBarIsHovered(!sidebarIsExpanded);
    };
    const toggleLabel = sidebarIsExpanded ? formatMessage($3265ee1fae39f7d6$var$i18n.collapseToggleLabel) : formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
    const integratedExpandButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                ...iconProps,
                size: "small"
            }),
        label: toggleLabel,
        onClick: toggleObjectSidebarControl,
        shape: "circle",
        testId: "integrated-expand-button"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "object-sidebar-container",
        "data-vc": "object-sidebar-container",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...(0, $6mKj3.expVal)('confluence_object_sidebar_nav4_width_inset', 'isEnabled', false) ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                right: pageMode === (0, $cD1qu.PageMode).VIEW ? `calc(var(${$3265ee1fae39f7d6$var$hoistedNav4RightSlotWidthVar}, 0px))` : '0px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                marginRight: 0
            } : {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                right: '0px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                marginRight: globalSidebarMargin + previewPanelOffsetPx
            }
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleMouseEnter,
        onBlur: handleMouseLeave,
        className: (0, $gMc0m.default)([
            "_v564ul29 _kqsw1n9t _94n5idpf _1pbyowjs _lcxvglyw _w1y61wug",
            (contentType === 'page' || contentType === 'blogpost' || pageMode === (0, $cD1qu.PageMode).VIEW) && "_u5f31ejb _n3tdu2gc",
            (contentType === 'database' || contentType === 'slide') && "_u5f3u2gc _n3tdu2gc",
            largeBottomPadding && "_n3td1ejb",
            isRovoMiniModalShown && "_1pby16oo",
            pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_1pbykb7n",
            pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_1pbycs5v",
            !renderServerPlaceholder && sidebarControlState === 'hidden' && "_1e0cglyw"
        ])
    }, primaryActions.length + secondaryActions.length + secondaryActionsTeam25.length > 0 && shouldRenderWhenEmbedded && !isMobileApp && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), null, (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsboahv _18u01wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: toggleLabel,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            paddingBottom: sidebarIsExpanded ? `${"var(--ds-space-100, 8px)"}` : undefined,
            visibility: shouldDisplayHoverToggle ? 'visible' : 'hidden'
        },
        "data-testid": "collapsible-hover-toggle",
        className: (0, $gMc0m.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsbxy5q"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps_0)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                ...iconProps_0,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                ...iconProps_0,
                size: "small"
            }),
        label: toggleLabel,
        onClick: onToggleClick,
        shape: "circle",
        testId: "collapsible-hover-button"
    })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).OBJECT_SIDEBAR_CONTROL
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsboahv _18u01wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: toggleLabel,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            paddingBottom: sidebarIsExpanded ? `${"var(--ds-space-100, 8px)"}` : undefined,
            visibility: shouldDisplayHoverToggle ? 'visible' : 'hidden'
        },
        "data-testid": "collapsible-hover-toggle",
        className: (0, $gMc0m.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsbxy5q"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps_1)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                ...iconProps_1,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                ...iconProps_1,
                size: "small"
            }),
        label: toggleLabel,
        onClick: onToggleClick,
        shape: "circle",
        testId: "collapsible-hover-button"
    }))))), (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsboahv _18u01wug"
        ])
    }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AnimationWrapper, {
        actionBarIsHovered: actionBarIsHovered
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: isRovoButtonEnabled ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, primaryActions, (0, $9wGTI.fg)('aifc_create_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3265ee1fae39f7d6$var$dividerStyle
    }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, secondaryActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3265ee1fae39f7d6$var$dividerStyle
    }), secondaryActions))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, collapsedActions))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsboahv _18u01wug"
        ])
    }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AnimationWrapper, {
        actionBarIsHovered: actionBarIsHovered
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: isRovoButtonEnabled ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, primaryActions, (0, $9wGTI.fg)('aifc_create_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3265ee1fae39f7d6$var$dividerStyle
    }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, secondaryActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3265ee1fae39f7d6$var$dividerStyle
    }), secondaryActions))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, collapsedActions)), shouldRenderIntegratedExpandButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsboahv _18u01wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: isRovoButtonEnabled ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, integratedExpandButton)) : null, (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
        contentId: contentId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
        contentId: contentId
    }))), shouldRenderAISmartButton && (isRovoButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_ca0qu2gc _otyrpxbi _18u0t94y"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3tUdX.RovoConfigProvider), {
        experience: rovoConfiguration?.experience,
        provider: rovoConfiguration?.provider,
        contentId: contentId,
        contentType: contentType ?? '',
        spaceKey: spaceKey ?? '',
        contentTitle: contentTitle ?? '',
        lastModifiedDate: lastModifiedDate,
        isUnpublishedDraft: isUnpublishedDraft,
        isEditorEmpty: isEditorEmpty
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hU34N.AISmartButtonWrapper), {
        contentId: contentId,
        contentType: contentType ?? '',
        pageMode: pageMode,
        isDisabled: isNetworkDisabled,
        isSidebarAvailable: isEmbeddedConfluence ? false : undefined
    })) : contentType !== 'database' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIQbF.AIFloatingContextMenu), {
        spaceKey: spaceKey ?? '',
        contentId: contentId,
        contentType: contentType ?? '',
        lastModifiedDate: lastModifiedDate,
        pageCommentsSectionInView: pageCommentsSectionInView,
        isLivePage: isLivePage,
        isInObjectSideBar: true,
        contentIdFromQuery: contentIdFromQuery,
        contentBodyDynamic: contentBodyDynamic
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
        metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
    }));
});
const $3265ee1fae39f7d6$var$AnimationWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, actionBarIsHovered: actionBarIsHovered } = t0;
    if ((0, $6mKj3.expValEquals)("cc-motion-survey-experiment", "cohort", "experiment")) {
        let t1;
        if ($[0] !== actionBarIsHovered || $[1] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6260267e05cdfdb2$export$2e2bcd8739ae039), {
                duration: "medium",
                enteringAnimation: "fade-in-from-bottom",
                exitingAnimation: "fade-out-from-top",
                animationTimingFunction: "ease-in-40-out"
            }, (animateProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    ...actionBarIsHovered ? animateProps : {},
                    "data-testid": "action-bar-animation-wrapper"
                }, children));
            $[0] = actionBarIsHovered;
            $[1] = children;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ children: children, actionBarIsHovered: actionBarIsHovered })=>{
    if ((0, $6mKj3.expValEquals)('cc-motion-survey-experiment', 'cohort', 'experiment')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6260267e05cdfdb2$export$2e2bcd8739ae039), {
        duration: "medium",
        enteringAnimation: "fade-in-from-bottom",
        exitingAnimation: "fade-out-from-top",
        animationTimingFunction: "ease-in-40-out"
    }, (animateProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ...actionBarIsHovered ? animateProps : {},
            "data-testid": "action-bar-animation-wrapper"
        }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
function $3265ee1fae39f7d6$var$_temp(routeName) {
    if (!routeName) return false;
    return routeName === (0, $1NBp8.PDF_EXPORT_PAGE).name;
}
function $3265ee1fae39f7d6$var$_temp2(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
        ...iconProps,
        size: "small"
    });
}
module.exports["ObjectSidebarControl"] = $3265ee1fae39f7d6$export$3fab07431350539e;

});

parcelRegister("8unJx", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $kPbXZ = parcelRequire("kPbXZ");

const $d1d2403974de0af3$var$initialState = {
    mode: undefined,
    isMiniModalAvailable: false,
    isSidebarAvailable: true,
    initialPrompt: undefined
};
const $d1d2403974de0af3$var$store = (0, $1P1Tu.createStore)({
    name: 'rovoExperienceAPIStore',
    initialState: $d1d2403974de0af3$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState($d1d2403974de0af3$var$initialState);
            },
        setMode: (mode)=>({ setState: setState })=>{
                setState({
                    mode: mode
                });
            },
        clearInitialPrompt: ()=>({ setState: setState })=>{
                setState({
                    initialPrompt: undefined
                });
            },
        toggleConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // If no target mode is provided, close any open modes
                if (!targetMode) {
                    setState({
                        mode: undefined
                    });
                    if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                    return;
                }
                // Toggle mode functionality
                if (currentMode === targetMode) switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        /* Handles the edge case where the sidebar space is taken by another panel
							which results in currentMode = 'sidebar' && sidebarApi.isSidebarOpen() = false */ if (!sidebarApi.isSidebarOpen()) {
                            sidebarApi.openSidebar();
                            return;
                        }
                        sidebarApi.closeSidebar();
                        setState({
                            mode: undefined
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        setState({
                            mode: undefined
                        });
                        return;
                    default:
                        return;
                }
                // Switch mode functionality
                switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt
                        });
                        return;
                }
            },
        setIsMiniModalAvailable: (isMiniModalAvailable)=>({ setState: setState })=>{
                setState({
                    isMiniModalAvailable: isMiniModalAvailable
                });
            },
        setIsSidebarAvailable: (isSidebarAvailable)=>({ setState: setState })=>{
                setState({
                    isSidebarAvailable: isSidebarAvailable
                });
            }
    }
});
const $d1d2403974de0af3$var$useStore = (0, $9zUhf.createHook)($d1d2403974de0af3$var$store);
const $d1d2403974de0af3$export$37440b51449f7ac6 = ()=>{
    const [{ mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, initialPrompt: initialPrompt }, { reset: reset, clearInitialPrompt: clearInitialPrompt, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable }] = $d1d2403974de0af3$var$useStore();
    return {
        mode: mode,
        initialPrompt: initialPrompt,
        reset: reset,
        clearInitialPrompt: clearInitialPrompt,
        toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
        setIsMiniModalAvailable: setIsMiniModalAvailable,
        setIsSidebarAvailable: setIsSidebarAvailable,
        isMiniModalAvailable: isMiniModalAvailable,
        isSidebarAvailable: isSidebarAvailable
    };
};
const $d1d2403974de0af3$export$66cf76b7e04da11f = (0, $9zUhf.createActionsHook)($d1d2403974de0af3$var$store);
module.exports["useRovoExperienceAPIStore"] = $d1d2403974de0af3$export$37440b51449f7ac6;

});

parcelRegister("kPbXZ", function(module, exports) {
/* Duplicates ConversationAssistantUIModes from conversation-assistant package
   to avoid circular dependencies. Any changes here should be mirrored in
	 platform/packages/ai-mate/conversation-assistant/src/types.ts
*/ const $053d47555d884138$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};
module.exports["ConversationAssistantUIModes"] = $053d47555d884138$export$bc36ebf73899a71d;

});

parcelRegister("hR4U4", function(module, exports) {
const $991dc85317754fda$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};
module.exports["ConversationAssistantUIModes"] = $991dc85317754fda$export$bc36ebf73899a71d;

});

parcelRegister("8uM2K", function(module, exports) {

var $5spQU = parcelRequire("5spQU");


var $bQm3c = parcelRequire("bQm3c");

const $214157f3efbb250b$export$dcc461521a57aee7 = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai');
    return isAIFeatureEnabled && isAdminHubAIEnabled && isRovoLLMEnabled;
};
module.exports["useAIRovoButtonEnablement"] = $214157f3efbb250b$export$dcc461521a57aee7;

});

parcelRegister("dppWL", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ var $56fbda2769629a59$export$50526ee9b1846f6c = /*#__PURE__*/ function(RegisteredExperience) {
    RegisteredExperience["VIEW_PAGE"] = "view-page";
    RegisteredExperience["EDIT_PAGE"] = "edit-page";
    RegisteredExperience["WHITEBOARD"] = "whiteboard";
    RegisteredExperience["SEARCH_PAGE"] = "search-page";
    return RegisteredExperience;
}({});
const $56fbda2769629a59$export$1e3f84bae31640f2 = (props)=>'actionsToRender' in props;
const $56fbda2769629a59$export$9fdd72360ade08c0 = (props)=>'contentType' in props;
const $56fbda2769629a59$export$b8a252bbcf90a2cb = (props)=>'getSearchQuery' in props;
module.exports["RegisteredExperience"] = $56fbda2769629a59$export$50526ee9b1846f6c;
module.exports["isWhiteboardRovoConfigProviderProps"] = $56fbda2769629a59$export$1e3f84bae31640f2;
module.exports["isPageRovoConfigProviderProps"] = $56fbda2769629a59$export$9fdd72360ade08c0;

});

parcelRegister("3tUdX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dppWL = parcelRequire("dppWL");


var $amW67 = parcelRequire("amW67");


var $8hjAS = parcelRequire("8hjAS");

const $f4bf02d66e85d52a$export$44a9046b553a8167 = (props)=>{
    if (props.experience === (0, $dppWL.RegisteredExperience).WHITEBOARD && !(0, $dppWL.isWhiteboardRovoConfigProviderProps)(props)) return null;
    if ((props.experience === (0, $dppWL.RegisteredExperience).VIEW_PAGE || props.experience === (0, $dppWL.RegisteredExperience).EDIT_PAGE) && !(0, $dppWL.isPageRovoConfigProviderProps)(props)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $amW67.RovoConfigProviderContextProvider), {
        value: props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hjAS.RovoCurrentConfigProvider), {
        provider: props.provider
    }));
};
module.exports["RovoConfigProvider"] = $f4bf02d66e85d52a$export$44a9046b553a8167;

});

parcelRegister("amW67", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $23a8183fa434531d$var$RovoConfigProviderContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $23a8183fa434531d$export$3ae1f97e9390a638 = ()=>{
    const context = (0, $42omo.useContext)($23a8183fa434531d$var$RovoConfigProviderContext);
    if (!context) throw new Error('useRovoConfigProviderProps must be used within an RovoConfigProviderContext.Provider');
    return context;
};
const $23a8183fa434531d$export$45b0916bb24b31be = ({ children: children, value: value })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($23a8183fa434531d$var$RovoConfigProviderContext.Provider, {
        value: value
    }, children);
};
module.exports["useRovoConfigProviderProps"] = $23a8183fa434531d$export$3ae1f97e9390a638;
module.exports["RovoConfigProviderContextProvider"] = $23a8183fa434531d$export$45b0916bb24b31be;

});

parcelRegister("8hjAS", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $5ruin = parcelRequire("5ruin");

const $4d3968fc98119c84$export$9ef355ca939f0be9 = ({ provider: provider })=>{
    const { resetConfiguration: resetConfiguration, setConfiguration: setConfiguration } = (0, $5ruin.useRovoCurrentConfigStoreActions)();
    (0, $42omo.useEffect)(()=>{
        if (!provider) resetConfiguration();
        return ()=>{
            resetConfiguration();
        };
    }, [
        resetConfiguration,
        provider
    ]);
    if (!provider) return null;
    const ActiveProviderComponent = provider;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "rovo-current-configuration-provider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ActiveProviderComponent, {
        setConfiguration: setConfiguration
    })));
};
module.exports["RovoCurrentConfigProvider"] = $4d3968fc98119c84$export$9ef355ca939f0be9;

});

parcelRegister("5ruin", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $2b71e6bc29f732db$var$noopConfiguration = {
    getActions: async ()=>[]
};
const $2b71e6bc29f732db$var$initialState = {
    configuration: $2b71e6bc29f732db$var$noopConfiguration
};
const $2b71e6bc29f732db$var$actions = {
    setConfiguration: (configuration)=>({ setState: setState })=>{
            setState({
                configuration: configuration
            });
        },
    resetConfiguration: ()=>({ setState: setState })=>{
            setState({
                configuration: $2b71e6bc29f732db$var$noopConfiguration
            });
        },
    updateConfiguration: (configuration)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                configuration: {
                    ...state.configuration,
                    ...configuration
                }
            });
        }
};
const $2b71e6bc29f732db$export$e0afd2e658e4f7ce = (0, $1P1Tu.createStore)({
    initialState: $2b71e6bc29f732db$var$initialState,
    actions: $2b71e6bc29f732db$var$actions,
    name: 'RovoCurrentConfigStore'
});
const $2b71e6bc29f732db$export$2cefdfe72db08be4 = (0, $9zUhf.createActionsHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce);
const $2b71e6bc29f732db$export$d7809b5c7bef1f6d = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration
});
const $2b71e6bc29f732db$export$897f16b7b08b0ac = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.getActions
});
const $2b71e6bc29f732db$export$1e0546f83460b30d = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.tags
});
const $2b71e6bc29f732db$export$2a73ca2333c94154 = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.customGreeting
});
const $2b71e6bc29f732db$export$9d0f592eafe765c0 = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.shouldShowGreeting
});
const $2b71e6bc29f732db$export$6745aa6ec6db525a = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.prioritizeCustomActionResults
});
module.exports["useRovoCurrentConfigStoreActions"] = $2b71e6bc29f732db$export$2cefdfe72db08be4;
module.exports["useRovoConfigGetActions"] = $2b71e6bc29f732db$export$897f16b7b08b0ac;
module.exports["useRovoConfigTags"] = $2b71e6bc29f732db$export$1e0546f83460b30d;
module.exports["useRovoConfigCustomGreeting"] = $2b71e6bc29f732db$export$2a73ca2333c94154;
module.exports["useRovoConfigShouldShowGreeting"] = $2b71e6bc29f732db$export$9d0f592eafe765c0;
module.exports["useRovoConfigPrioritizeCustomActionResults"] = $2b71e6bc29f732db$export$6745aa6ec6db525a;

});

parcelRegister("4acD6", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $48675c89bdefef9d$export$d4c72bab9d6cc13a = {
    nudges: []
};
const $48675c89bdefef9d$export$e324594224ef24da = {
    setNudges: (nudges)=>({ setState: setState })=>{
            setState({
                nudges: nudges
            });
        },
    setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
            setState({
                buttonClickedTimestamp: buttonClickedTimestamp
            });
        }
};
const $48675c89bdefef9d$export$72552b26ebb37b2 = (0, $1P1Tu.createStore)({
    initialState: $48675c89bdefef9d$export$d4c72bab9d6cc13a,
    actions: $48675c89bdefef9d$export$e324594224ef24da,
    name: 'AISmartButtonStore'
});
const $48675c89bdefef9d$export$af36d029992e7a8c = (0, $9zUhf.createActionsHook)($48675c89bdefef9d$export$72552b26ebb37b2);
module.exports["AISmartButtonStore"] = $48675c89bdefef9d$export$72552b26ebb37b2;
module.exports["useAISmartButtonActions"] = $48675c89bdefef9d$export$af36d029992e7a8c;

});

parcelRegister("3Am3T", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dDqLo = parcelRequire("dDqLo");

const $7428cb96b7623c11$export$cf1f48e05bf093f2 = /*#__PURE__*/ (0, $42omo.createContext)({
    footerCommentsCount: 0,
    unresolvedInlineCommentsCount: 0
});
const $7428cb96b7623c11$export$c2f6e8ee3b0be174 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { contentId: contentId, children: children } = t0;
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    let t1;
    if ($[0] !== children || $[1] !== commentCounts) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
            value: commentCounts
        }, children);
        $[0] = children;
        $[1] = commentCounts;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ contentId: contentId, children: children })=>{
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
        value: commentCounts
    }, children);
};
module.exports["CommentCountsContext"] = $7428cb96b7623c11$export$cf1f48e05bf093f2;
module.exports["CommentCountsProvider"] = $7428cb96b7623c11$export$c2f6e8ee3b0be174;

});

parcelRegister("dDqLo", function(module, exports) {
/**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $dkkKv = parcelRequire("dkkKv");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $aPT9H = parcelRequire("aPT9H");

const $c085ac79a8833850$export$453b7c79178856e5 = (contentId)=>{
    // Always call both hooks to follow React rules, but skip the queries conditionally
    // Legacy implementation using CommentsSectionQuery
    const legacyResult = (0, $aPT9H.useCommentCountsLegacy)(contentId);
    // New comments data manager - get processed data from the store
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // ActiveCommentsQuery implementation - used when cc_comments_new_comments_data_manager is disabled
    // Call without type filter to get both inline and footer comments, then filter by location.type
    const { data: allCommentsData } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId,
        // Don't pass type to get all comment types (both CommentType.INLINE and CommentType.FOOTER)
        skip: !contentId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    return (0, $42omo.useMemo)(()=>{
        // Priority 1: Use new comments data manager when enabled
        if (processedCommentsData.isDataProcessed && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            const unresolvedInlineCommentsCount = processedCommentsData.openInlineComments.length;
            const footerCommentsCount = processedCommentsData.openFooterComments.length;
            return {
                unresolvedInlineCommentsCount: unresolvedInlineCommentsCount,
                footerCommentsCount: footerCommentsCount
            };
        }
        // Priority 2: Use ActiveCommentsQuery when cc_comments_new_comments_data_manager is disabled
        if (allCommentsData?.comments?.nodes && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // New implementation using ActiveCommentsQuery
            // ActiveCommentsQuery already filters by commentState: UNRESOLVED, so all comments are unresolved
            // Filter comments by location.type to count inline vs footer separately
            const unresolvedInlineCommentsCount = allCommentsData.comments.nodes.filter((node)=>node?.location?.type === 'INLINE').length;
            const footerCommentsCount = allCommentsData.comments.nodes.filter((node)=>node?.location?.type === 'FOOTER').length;
            return {
                unresolvedInlineCommentsCount: unresolvedInlineCommentsCount,
                footerCommentsCount: footerCommentsCount
            };
        }
        // Priority 3: Legacy implementation using CommentsSectionQuery
        // Return legacy result if available, otherwise return default values
        if (legacyResult && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return legacyResult;
        // Fallback when experiment is enabled but data hasn't loaded yet
        return {
            unresolvedInlineCommentsCount: 0,
            footerCommentsCount: 0
        };
    }, [
        processedCommentsData.isDataProcessed,
        processedCommentsData.openInlineComments.length,
        processedCommentsData.openFooterComments.length,
        allCommentsData?.comments?.nodes,
        legacyResult
    ]);
};
module.exports["useCommentCounts"] = $c085ac79a8833850$export$453b7c79178856e5;

});

parcelRegister("aPT9H", function(module, exports) {

var $k8e76 = parcelRequire("k8e76");


var $ftXPY = parcelRequire("ftXPY");


var $7Sm4c = parcelRequire("7Sm4c");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $l5y3Y = parcelRequire("l5y3Y");


var $jMyy4 = parcelRequire("jMyy4");

const $a2300d29b43bb5dd$export$e32e67cfb7516912 = (contentId)=>{
    const { unresolvedInlineComments: unresolvedInlineComments } = (0, $k8e76.useInlineCommentsState)();
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    // Instead of requesting 0 comments with the 'first' param here I am reusing the query that is preloaded and fetched
    // for page comments themselves. This allows me to take advantage of the caching and updates that occur in the
    // legacy classes. I've also just marked all errors as handled as we don't particularly care about the results here
    // and the page comments component has much more robust error handling than we'd want to add here.
    const { data: footerCommentsData, error: error } = (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- This is not preloaded but there is a name collision with a preloaded query
    isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery), {
        variables: {
            contentId: contentId,
            offset: '',
            first: 100
        },
        fetchPolicy: window.__SSR_RENDERED__ && (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? 'cache-first' : undefined,
        skip: (0, $9wGTI.fg)('confluence_comment_use_active_comment_query') || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) || !contentId
    });
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    // Return undefined when feature gate or experiment is enabled
    if ((0, $9wGTI.fg)('confluence_comment_use_active_comment_query') || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return undefined;
    return {
        unresolvedInlineCommentsCount: (unresolvedInlineComments && unresolvedInlineComments.length) ?? 0,
        footerCommentsCount: (footerCommentsData && footerCommentsData.comments?.totalCount) ?? 0
    };
};
module.exports["useCommentCountsLegacy"] = $a2300d29b43bb5dd$export$e32e67cfb7516912;

});

parcelRegister("k8e76", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");


var $hE1Uz = parcelRequire("hE1Uz");

const $221ff47547c5dafc$var$initialState = {
    unresolvedInlineComments: []
};
const $221ff47547c5dafc$var$actions = {
    updateUnresolvedInlineComment: (unresolvedInlineComments)=>({ setState: setState })=>{
            setState({
                unresolvedInlineComments: unresolvedInlineComments
            });
        },
    addUnresolvedInlineComment: (unresolvedAnnotationId, pageModes)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            setState({
                unresolvedInlineComments: (0, $hE1Uz.findUnresolvedCommentIndex)(unresolvedAnnotationId, unresolvedInlineComments, pageModes)
            });
        },
    removeUnresolvedInlineComment: (unresolvedAnnotationId)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            const updatedUnresolvedInlineComments = [
                ...unresolvedInlineComments
            ];
            const unresolvedAnnotationIdx = updatedUnresolvedInlineComments.indexOf(unresolvedAnnotationId);
            // Remove the passed in comment if it exists and reset the state
            if (unresolvedAnnotationIdx > -1) {
                updatedUnresolvedInlineComments.splice(unresolvedAnnotationIdx, 1);
                setState({
                    unresolvedInlineComments: updatedUnresolvedInlineComments
                });
            }
        }
};
const $221ff47547c5dafc$var$InlineCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $221ff47547c5dafc$var$initialState,
    actions: $221ff47547c5dafc$var$actions,
    name: 'InlineCommentsStore'
});
const $221ff47547c5dafc$export$2d5fb1576e30b55e = (0, $9zUhf.createHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$84bffd53ee003f3d = (0, $9zUhf.createActionsHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$f4e420e107a562b0 = (0, $9zUhf.createStateHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$d9930cd528b1e4f5 = (0, $j1v0l.createSubscriber)($221ff47547c5dafc$var$InlineCommentsStore);
module.exports["useInlineComments"] = $221ff47547c5dafc$export$2d5fb1576e30b55e;
module.exports["useInlineCommentsActions"] = $221ff47547c5dafc$export$84bffd53ee003f3d;
module.exports["useInlineCommentsState"] = $221ff47547c5dafc$export$f4e420e107a562b0;

});

parcelRegister("hE1Uz", function(module, exports) {
var $8288f6cefaa5e2cf$var$PageMode = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}($8288f6cefaa5e2cf$var$PageMode || {});
const $8288f6cefaa5e2cf$export$556f3f3c22ea5327 = (unresolvedAnnotationId, unresolvedInlineComments, pageMode)=>{
    const isFullPageEditor = pageMode === "live" || pageMode === "edit";
    let activeAnnotationMarks;
    if (isFullPageEditor) {
        // In the full-page editor mode, collect parent spans with unique IDs for annotation boundaries
        const parentSpansSet = new Set();
        const annotations = document.querySelectorAll('.ak-editor-annotation-focus, .ak-editor-annotation-blur');
        annotations.forEach((element)=>{
            const parentSpan = element.closest('span[id]');
            if (parentSpan) parentSpansSet.add(parentSpan);
        });
        activeAnnotationMarks = Array.from(parentSpansSet);
    } else // For renderer or view mode, collect marks with active annotation state
    activeAnnotationMarks = Array.from(document.querySelectorAll("mark[data-mark-annotation-state='active']"));
    // Attempt to find the index of the new unresolved annotation by matching its element
    const newlyUnresolvedAnnotation = document.getElementById(unresolvedAnnotationId);
    const allUnresolvedAnnotations = Array.from(activeAnnotationMarks);
    const matchedIndex = newlyUnresolvedAnnotation ? allUnresolvedAnnotations.indexOf(newlyUnresolvedAnnotation) : -1;
    // Construct the new array with unresolved comments
    const newUnresolvedInlineComments = [
        ...unresolvedInlineComments
    ];
    if (matchedIndex !== -1) newUnresolvedInlineComments.splice(matchedIndex, 0, unresolvedAnnotationId);
    else newUnresolvedInlineComments.push(unresolvedAnnotationId);
    return newUnresolvedInlineComments;
};
module.exports["findUnresolvedCommentIndex"] = $8288f6cefaa5e2cf$export$556f3f3c22ea5327;

});

parcelRegister("l5y3Y", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first'
    });
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("h2uld", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $j25oo = parcelRequire("j25oo");


var $jtuBN = parcelRequire("jtuBN");


var $72md5 = parcelRequire("72md5");


var $h3vPv = parcelRequire("h3vPv");

const $8b6571c5cd7e604c$export$9a0a69714186a2dc = (0, $j25oo.default);
const $8b6571c5cd7e604c$export$bf3941b9bff5380a = (contentId, skipQuery)=>{
    const $ = (0, $frIzR.c)(20);
    let t0;
    if ($[0] !== contentId) {
        t0 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== skipQuery || $[3] !== t0) {
        t1 = {
            variables: t0,
            skip: skipQuery
        };
        $[2] = skipQuery;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    const readTimeQueryOptions = t1;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($8b6571c5cd7e604c$export$9a0a69714186a2dc, readTimeQueryOptions);
    let t2;
    if ($[5] !== contentId || $[6] !== data || $[7] !== error || $[8] !== loading) {
        bb0: {
            const adfFromData = (0, $72md5.getAdf)(data ?? undefined);
            if (!adfFromData || loading || error || !contentId) {
                let t3;
                if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = {
                        readTime: null,
                        wordCount: null,
                        features: null,
                        featuresSkipExpand: null
                    };
                    $[10] = t3;
                } else t3 = $[10];
                t2 = t3;
                break bb0;
            }
            t2 = {
                adf: adfFromData,
                readTime: (0, $72md5.calculateEstimatedReadTime)(adfFromData),
                wordCount: (0, $72md5.getWordCount)(adfFromData),
                features: (0, $h3vPv.extractContentFeatures)(adfFromData),
                featuresSkipExpand: (0, $h3vPv.extractContentFeaturesSkipExpand)(adfFromData)
            };
        }
        $[5] = contentId;
        $[6] = data;
        $[7] = error;
        $[8] = loading;
        $[9] = t2;
    } else t2 = $[9];
    const { adf: adf, readTime: readTime, wordCount: wordCount, features: features, featuresSkipExpand: featuresSkipExpand } = t2;
    const contentNode = data?.content?.nodes?.[0];
    const contentType = contentNode?.type;
    let t3;
    if ($[11] !== adf || $[12] !== contentType || $[13] !== error || $[14] !== features || $[15] !== featuresSkipExpand || $[16] !== loading || $[17] !== readTime || $[18] !== wordCount) {
        t3 = {
            loading: loading,
            error: error,
            adf: adf,
            contentType: contentType,
            readTime: readTime,
            wordCount: wordCount,
            features: features,
            featuresSkipExpand: featuresSkipExpand
        };
        $[11] = adf;
        $[12] = contentType;
        $[13] = error;
        $[14] = features;
        $[15] = featuresSkipExpand;
        $[16] = loading;
        $[17] = readTime;
        $[18] = wordCount;
        $[19] = t3;
    } else t3 = $[19];
    return t3;
};
module.exports["ReadTimeQuery"] = $8b6571c5cd7e604c$export$9a0a69714186a2dc;
module.exports["useReadTime"] = $8b6571c5cd7e604c$export$bf3941b9bff5380a;

});

parcelRegister("j25oo", function(module, exports) {
/**
 * @generated SignedSource<<08aaea74493da34011b5c879855eeef9>>
 * @relayHash 24201b9545ec89a2ece8511e9a2a8999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c
const $6b1bc0e8ad61af00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeContentBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "includeContentBody",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "dynamic",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "representation"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24201b9545ec89a2ece8511e9a2a8999",
            "id": "b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c",
            "metadata": {},
            "name": "useReadTimeQuery",
            "operationKind": "query",
            "text": "query useReadTimeQuery($contentId:ID,$status:[String],$includeContentBody:Boolean=true){content(id:$contentId,status:$status){nodes{id,type,body@include(if:$includeContentBody){dynamic{value,representation}},operations{operation,targetType}}}}"
        }
    };
}();
$6b1bc0e8ad61af00$var$node.hash = "1de89fa5a6335c6c91c524557c055ef1";
var $6b1bc0e8ad61af00$export$2e2bcd8739ae039 = $6b1bc0e8ad61af00$var$node;
module.exports["default"] = $6b1bc0e8ad61af00$export$2e2bcd8739ae039;

});

parcelRegister("72md5", function(module, exports) {

var $h3vPv = parcelRequire("h3vPv");

const $7a7682e083b4bc67$var$wpm = 265; // words per minute, inspired by Medium.com
const $7a7682e083b4bc67$var$minute = 60;
const $7a7682e083b4bc67$export$dbd433271872c208 = (imageCount)=>{
    let readTime = 0;
    for(let i = 0; i < imageCount; i++)readTime += Math.max(12 - i, 3);
    return readTime;
};
const $7a7682e083b4bc67$export$a44553c2ca45b9b3 = (adf)=>{
    if (adf) {
        const extractedFeatures = (0, $h3vPv.extractContentFeaturesSkipExpand)(adf);
        const features = extractedFeatures;
        const readTime = (features.wordCount / $7a7682e083b4bc67$var$wpm * 60 + $7a7682e083b4bc67$export$dbd433271872c208(features.imageCount)) / $7a7682e083b4bc67$var$minute;
        if (readTime > 0.5) return Math.round(readTime);
    }
    return 0;
};
const $7a7682e083b4bc67$export$da369a1128d64cc6 = (response)=>{
    const representation = response?.content?.nodes?.[0]?.body?.dynamic?.representation;
    if (representation === 'atlas_doc_format') {
        const adfString = response?.content?.nodes?.[0]?.body?.dynamic?.value;
        if (adfString) try {
            return JSON.parse(adfString);
        } catch  {
            return null;
        }
    }
    return null;
};
const $7a7682e083b4bc67$export$d7ca718a8dbe1f35 = ({ contentType: contentType, contentId: contentId, adf: adf, isInEditor: isInEditor })=>({
        type: 'sendOperationalEvent',
        data: {
            source: 'confluence-frontend',
            action: 'extracted',
            actionSubject: 'contentFeature',
            objectType: contentType,
            objectId: contentId,
            attributes: {
                ...(0, $h3vPv.extractContentFeatures)(adf),
                isInEditor: isInEditor
            }
        }
    });
const $7a7682e083b4bc67$export$dba3e2bcdbd49da4 = (adf)=>{
    if (!adf) return 0;
    const features = (0, $h3vPv.extractContentFeaturesSkipExpand)(adf);
    return features.wordCount;
};
const $7a7682e083b4bc67$export$2ac19802f4188b34 = (bodyDynamic)=>{
    if (!bodyDynamic || bodyDynamic.representation !== 'atlas_doc_format') return false;
    const adfString = bodyDynamic.value;
    if (!adfString) return false;
    let adf;
    try {
        adf = JSON.parse(adfString);
    } catch  {
        return false;
    }
    const { wordCount: wordCount, imageCount: imageCount } = (0, $h3vPv.extractContentFeaturesSkipExpand)(adf);
    return wordCount > 0 || imageCount > 0;
};
module.exports["calculateImageReadTime"] = $7a7682e083b4bc67$export$dbd433271872c208;
module.exports["calculateEstimatedReadTime"] = $7a7682e083b4bc67$export$a44553c2ca45b9b3;
module.exports["getAdf"] = $7a7682e083b4bc67$export$da369a1128d64cc6;
module.exports["getContentFeatureExtractedEventObject"] = $7a7682e083b4bc67$export$d7ca718a8dbe1f35;
module.exports["getWordCount"] = $7a7682e083b4bc67$export$dba3e2bcdbd49da4;
module.exports["docHasContent"] = $7a7682e083b4bc67$export$2ac19802f4188b34;

});

parcelRegister("h3vPv", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");

// helper function to traverse ADF tree while skipping expand nodes
const $a8469c4e0ee76bb2$var$reduceSkipExpand = (node, reducer, initialValue)=>{
    // skip if this is an expand node
    if (node.type === 'expand' || node.type === 'nestedExpand') return initialValue;
    // process current node
    let result = reducer(initialValue, node);
    // process child nodes if they exist
    if (node.content) result = node.content.reduce((acc, child)=>$a8469c4e0ee76bb2$var$reduceSkipExpand(child, reducer, acc), result);
    return result;
};
const $a8469c4e0ee76bb2$var$wordCount = (text)=>{
    if (text) {
        const matches = text.match(/\S+/g);
        if (matches) return matches.length;
    }
    return 0;
};
const $a8469c4e0ee76bb2$var$processADFNode = (currentValue, node)=>{
    switch(node.type){
        case 'text':
            return {
                ...currentValue,
                textLength: currentValue.textLength + (node.text ? node.text.length : 0),
                wordCount: currentValue.wordCount + $a8469c4e0ee76bb2$var$wordCount(node.text)
            };
        case 'media':
            return {
                ...currentValue,
                imageCount: currentValue.imageCount + 1,
                mediaFiles: node.attrs?.type === 'file' && node.attrs?.id ? currentValue.mediaFiles.concat(node.attrs.id) : currentValue.mediaFiles
            };
        case 'inlineExtension':
            return {
                ...currentValue,
                inlineMacroCount: currentValue.macroCount + 1
            };
        case 'extension':
            return {
                ...currentValue,
                macroCount: currentValue.macroCount + 1
            };
        case 'table':
            return {
                ...currentValue,
                tableCount: currentValue.tableCount + 1
            };
        case 'embedCard':
            const url = node.attrs?.url;
            if (!url.includes('loom')) return currentValue;
            const videoId = url?.split('/').pop().split('?')[0];
            return {
                ...currentValue,
                looms: videoId ? currentValue.looms.concat({
                    id: videoId,
                    url: url
                }) : currentValue.looms
            };
    }
    return currentValue;
};
const $a8469c4e0ee76bb2$export$a148305df2eb5487 = (adf)=>{
    const initialFeatures = {
        rawLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        imageCount: 0,
        inlineMacroCount: 0,
        macroCount: 0,
        tableCount: 0,
        mediaFiles: [],
        looms: []
    };
    return (0, $1A9t2.reduce)(adf, (currentValue, node)=>$a8469c4e0ee76bb2$var$processADFNode(currentValue, node), initialFeatures);
};
const $a8469c4e0ee76bb2$export$8e18062037dcc9dd = (adf)=>{
    const initialFeatures = {
        rawLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        imageCount: 0,
        inlineMacroCount: 0,
        macroCount: 0,
        tableCount: 0,
        mediaFiles: [],
        looms: []
    };
    return $a8469c4e0ee76bb2$var$reduceSkipExpand(adf, (currentValue, node)=>$a8469c4e0ee76bb2$var$processADFNode(currentValue, node), initialFeatures);
};
module.exports["extractContentFeatures"] = $a8469c4e0ee76bb2$export$a148305df2eb5487;
module.exports["extractContentFeaturesSkipExpand"] = $a8469c4e0ee76bb2$export$8e18062037dcc9dd;

});

parcelRegister("dWpd3", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $eb4732679a1ccd43$var$initialState = {
    activeContent: null,
    eligibleForChangeboarding: false
};
const $eb4732679a1ccd43$var$actions = {
    setActiveContent: (activeContent)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            return setState({
                ...state,
                activeContent: activeContent
            });
        },
    setEligibleForChangeboarding: (eligibleForChangeboarding)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            return setState({
                ...state,
                eligibleForChangeboarding: eligibleForChangeboarding
            });
        }
};
const $eb4732679a1ccd43$var$AudioButtonWrapperStore = (0, $1P1Tu.createStore)({
    name: 'AudioButtonWrapperStore',
    initialState: $eb4732679a1ccd43$var$initialState,
    actions: $eb4732679a1ccd43$var$actions
});
const $eb4732679a1ccd43$export$ab1ee966cd621cb0 = (0, $9zUhf.createStateHook)($eb4732679a1ccd43$var$AudioButtonWrapperStore, {
    selector: (state)=>({
            activeContent: state.activeContent,
            eligibleForChangeboarding: state.eligibleForChangeboarding
        })
});
const $eb4732679a1ccd43$export$9980b31ff728dec1 = (0, $9zUhf.createActionsHook)($eb4732679a1ccd43$var$AudioButtonWrapperStore);
module.exports["useAudioButtonWrapperStore"] = $eb4732679a1ccd43$export$ab1ee966cd621cb0;
module.exports["useAudioButtonWrapperActions"] = $eb4732679a1ccd43$export$9980b31ff728dec1;

});

parcelRegister("5gEqE", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $815712ef274e8115$var$initialState = {
    activeMenu: 'none',
    mounted: false,
    isAgentSelectorMenuOpen: false,
    streaming: false,
    isChatOnboardingMiniModalOpen: false,
    emptyChatLaunchGreeting: undefined,
    emptyChatLaunchProjectContext: undefined,
    emptyChatLaunchConversationActions: undefined,
    emptyChatLaunchReplaceProviderActions: false,
    emptyChatLaunchId: 0
};
const $815712ef274e8115$var$store = (0, $1P1Tu.createStore)({
    name: 'uiStore',
    initialState: $815712ef274e8115$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState({
                    ...$815712ef274e8115$var$initialState,
                    conversationHeader: null
                });
            },
        setActiveMenu: (menu)=>({ setState: setState })=>{
                setState({
                    activeMenu: menu
                });
            },
        setMounted: (mounted)=>({ setState: setState })=>{
                setState({
                    mounted: mounted
                });
            },
        setIsAgentSelectorMenuOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isAgentSelectorMenuOpen: isOpen
                });
            },
        setStreamingStatus: (status)=>({ setState: setState })=>{
                setState({
                    streaming: status
                });
            },
        setIsChatOnboardingMiniModalOpen: (status)=>({ setState: setState })=>{
                setState({
                    isChatOnboardingMiniModalOpen: status
                });
            },
        setConversationHeader: (header)=>({ setState: setState })=>{
                setState({
                    conversationHeader: header
                });
            },
        getIsMounted: ()=>({ getState: getState })=>{
                return getState().mounted;
            },
        setEmptyChatLaunch: (payload)=>({ setState: setState, getState: getState })=>{
                setState({
                    emptyChatLaunchGreeting: payload.customGreeting,
                    emptyChatLaunchConversationActions: payload.customConversationActions,
                    emptyChatLaunchProjectContext: payload.projectContext,
                    emptyChatLaunchReplaceProviderActions: payload.replaceProviderActions ?? false,
                    emptyChatLaunchId: getState().emptyChatLaunchId + 1
                });
            },
        clearEmptyChatLaunchGreeting: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchReplaceProviderActions: false
                });
            },
        clearEmptyChatLaunchAll: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchProjectContext: undefined,
                    emptyChatLaunchReplaceProviderActions: false
                });
            }
    }
});
const $815712ef274e8115$var$useStore = (0, $9zUhf.createHook)($815712ef274e8115$var$store);
const $815712ef274e8115$export$13a6c73a57f1d6a6 = (0, $9zUhf.createHook)($815712ef274e8115$var$store, {
    selector: (state)=>({
            customGreeting: state.emptyChatLaunchGreeting,
            projectContext: state.emptyChatLaunchProjectContext,
            customConversationActions: state.emptyChatLaunchConversationActions,
            replaceProviderActions: state.emptyChatLaunchReplaceProviderActions,
            launchId: state.emptyChatLaunchId
        })
});
const $815712ef274e8115$export$5b2ba9b8ea3b0771 = ()=>{
    const [{ activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, conversationHeader: conversationHeader }, { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setConversationHeader: setConversationHeader }] = $815712ef274e8115$var$useStore();
    return {
        activeMenu: activeMenu,
        mounted: mounted,
        streaming: streaming,
        isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
        conversationHeader: conversationHeader ?? null,
        reset: reset,
        setActiveMenu: setActiveMenu,
        setMounted: setMounted,
        setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
        setStreamingStatus: setStreamingStatus,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen,
        setConversationHeader: setConversationHeader
    };
};
const $815712ef274e8115$export$cd2fc25ddd3752d4 = (0, $9zUhf.createActionsHook)($815712ef274e8115$var$store);
module.exports["useEmptyChatLaunchSelector"] = $815712ef274e8115$export$13a6c73a57f1d6a6;
module.exports["useUIStore"] = $815712ef274e8115$export$5b2ba9b8ea3b0771;
module.exports["useUIStoreActions"] = $815712ef274e8115$export$cd2fc25ddd3752d4;

});

parcelRegister("6Htct", function(module, exports) {
var $4c47f75c6ef52bb8$export$87497e63e164f4b3 = /*#__PURE__*/ function(HandleActionType) {
    HandleActionType["Base"] = "Base";
    HandleActionType["Chat"] = "Chat";
    HandleActionType["Nested"] = "Nested";
    HandleActionType["Skill"] = "Skill";
    return HandleActionType;
}({});
const $4c47f75c6ef52bb8$export$c91e07269f22915a = new Set([
    'invite-users',
    'grant-app-access',
    'troubleshoot-invitation-errors',
    'troubleshoot-user-access',
    'troubleshoot-user-provisioning',
    'troubleshoot-single-sign-on',
    'review-api-security',
    'policy-assist'
]);
var $4c47f75c6ef52bb8$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_PULL_REQUEST_WITHOUT_PIPELINES_STARTERS"] = "bitbucket-pull-request-without-pipelines-starters";
    PageContextType["BITBUCKET_PIPELINES"] = "bitbucket-pipelines";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_BLOG_VIEW"] = "confluence-blog-view";
    PageContextType["CONFLUENCE_BLOG_EDIT"] = "confluence-blog-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_FOR_YOU"] = "jira-for-you";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_TMP_SPACE_SETTINGS_ACCESS"] = "jira-tmp-space-settings-access";
    PageContextType["JSM_INCIDENT_VIEW"] = "jsm-incident-view";
    PageContextType["JSM_INCIDENT_LIST_VIEW"] = "jsm-incident-list-view";
    PageContextType["JSM_ALERT_VIEW"] = "jsm-alert-view";
    PageContextType["JSM_ALERT_LIST_VIEW"] = "jsm-alert-list-view";
    PageContextType["JSM_ALERT_GROUP_DETAIL_VIEW"] = "jsm-alert-group-detail-view";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_HOME_MAIN"] = "atlas-home-main";
    PageContextType["ATLAS_HOME_DISCOVER"] = "atlas-home-discover";
    PageContextType["ATLAS_HOME_RECENTS"] = "atlas-home-recents";
    PageContextType["ATLAS_HOME_FULL_PAGE_NOTIFICATIONS"] = "atlas-home-full-page-notifications";
    PageContextType["ATLAS_HOME_PROJECT_UPDATES_LIST"] = "atlas-home-project-updates-list";
    PageContextType["ATLAS_HOME_GOAL_UPDATES_LIST"] = "atlas-home-goal-updates-list";
    PageContextType["ATLAS_HOME_TEAM_UPDATES_LIST"] = "atlas-home-team-updates-list";
    PageContextType["ATLAS_HOME_TAG_UPDATES_LIST"] = "atlas-home-tag-updates-list";
    PageContextType["FOCUS"] = "focus";
    PageContextType["FOCUS_FOR_YOU"] = "focus-for-you";
    PageContextType["FOCUS_FOCUS_AREA_PAGE"] = "focus-focus-area-page";
    PageContextType["FOCUS_FOCUS_AREA_GOAL_VIEW"] = "focus-focus-area-goal-view";
    PageContextType["FOCUS_FOCUS_AREA_WORK_VIEW"] = "focus-focus-area-work-view";
    PageContextType["SAC"] = "sac";
    PageContextType["STORE_HOME"] = "store-home";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
const $4c47f75c6ef52bb8$export$4f757e7d9540e8f9 = 'prompt-of-day';
module.exports["HandleActionType"] = $4c47f75c6ef52bb8$export$87497e63e164f4b3;
module.exports["LEGACY_DYNAMIC_SKILL_IDS"] = $4c47f75c6ef52bb8$export$c91e07269f22915a;
module.exports["PageContextType"] = $4c47f75c6ef52bb8$export$7f7a6f1c2ab5127;
module.exports["PROMPT_OF_DAY_ACTION_ID"] = $4c47f75c6ef52bb8$export$4f757e7d9540e8f9;

});

parcelRegister("1AJi3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5qqdA = parcelRequire("5qqdA");


var $hR4U4 = parcelRequire("hR4U4");


var $8unJx = parcelRequire("8unJx");


var $2bR8c = parcelRequire("2bR8c");


var $jln20 = parcelRequire("jln20");

const $ca70225f28efd254$export$a81c3fee0d63dde7 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const isConversationAssistantSidebarActive = panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID);
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const toggleConversationAssistant = (0, $42omo.useCallback)((openChatMode = 'sidebar')=>{
        toggleConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL : (0, $hR4U4.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi
        });
    }, [
        toggleConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    return (0, $42omo.useMemo)(()=>({
            mode: mode,
            toggleConversationAssistant: toggleConversationAssistant,
            isConversationAssistantSidebarActive: isConversationAssistantSidebarActive
        }), [
        mode,
        toggleConversationAssistant,
        isConversationAssistantSidebarActive
    ]);
};
module.exports["useToggleConversationAssistant"] = $ca70225f28efd254$export$a81c3fee0d63dde7;

});

parcelRegister("5qqdA", function(module, exports) {
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $76e32f06e038930c$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $76e32f06e038930c$export$64aee74ba59709e5 = 439; // px
const $76e32f06e038930c$export$1c07393c5bb1bc27 = 439; // px
const $76e32f06e038930c$export$aa3478deee7adbeb = 350; // px
const $76e32f06e038930c$export$21e515a86cd1733b = 'Chat';
const $76e32f06e038930c$export$e942bf04e23ff966 = 'Rovo';
module.exports["CONVERSATION_ASSISTANT_CONTAINER_ID"] = $76e32f06e038930c$export$dffb4ed44e20ea9a;
module.exports["CONVERSATION_ASSISTANT_CONTAINER_WIDTH"] = $76e32f06e038930c$export$64aee74ba59709e5;
module.exports["CONVERSATION_ASSISTANT_MINIMUM_HEIGHT"] = $76e32f06e038930c$export$aa3478deee7adbeb;
module.exports["CONVERSATION_ASSISTANT_BRAND_NAME"] = $76e32f06e038930c$export$21e515a86cd1733b;
module.exports["DEFAULT_PAGE_TITLE"] = $76e32f06e038930c$export$e942bf04e23ff966;

});

parcelRegister("2bR8c", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5qqdA = parcelRequire("5qqdA");


var $jln20 = parcelRequire("jln20");

const $da7293b7c8deb7d1$export$c27f18f8bab3d8b9 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const isConversationAssistantSidebarActive = panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID);
    return (0, $42omo.useMemo)(()=>{
        return {
            isSidebarOpen: ()=>{
                return isConversationAssistantSidebarActive;
            },
            openSidebar: ()=>{
                rightSidebarContext.open((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
            },
            closeSidebar: ()=>{
                if (isConversationAssistantSidebarActive) rightSidebarContext.close((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID));
            }
        };
    }, [
        isConversationAssistantSidebarActive,
        rightSidebarContext
    ]);
};
module.exports["useCreateRovoExperienceSidebarController"] = $da7293b7c8deb7d1$export$c27f18f8bab3d8b9;

});

parcelRegister("la9AC", function(module, exports) {

var $ij2FZ = parcelRequire("ij2FZ");


var $kfhjt = parcelRequire("kfhjt");

const $08b97b2e27a84eff$var$PROMPT_CATEGORIES = [
    'Analyze',
    'Brainstorm',
    'Review',
    'Summarize',
    'Create',
    'Execute',
    'Find',
    'Learn'
];
const $08b97b2e27a84eff$var$PROMPT_ROLES = [
    'General',
    'Engineering',
    'Product',
    'Program Management',
    'Design',
    'Marketing',
    'IT Ops',
    'Sales',
    'Customer Support',
    'Helpdesk Support',
    'Security'
];
const $08b97b2e27a84eff$var$createFilterOptions = (values)=>values.map((value)=>({
            id: value,
            label: value
        }));
const $08b97b2e27a84eff$export$9fa6e712ef03097f = $08b97b2e27a84eff$var$createFilterOptions($08b97b2e27a84eff$var$PROMPT_CATEGORIES);
const $08b97b2e27a84eff$export$9472c6a87dde5170 = $08b97b2e27a84eff$var$createFilterOptions($08b97b2e27a84eff$var$PROMPT_ROLES);
const $08b97b2e27a84eff$export$1ac99e1b5b1a8cfe = 'rovo-chat-prompt-gallery';
const $08b97b2e27a84eff$export$bee44b12dce7b448 = (prompt)=>{
    const slugs = [];
    const slashSkillPattern = new RegExp((0, $ij2FZ.ROVO_SKILL_TAG_PATTERN).source, 'g');
    for (const m of prompt.matchAll(slashSkillPattern))slugs.push(m[1]);
    return slugs;
};
// Prompts with multiple placeholders are commented out until they are supported by this
// PR https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/217105
const $08b97b2e27a84eff$var$staticPrompts = [
    {
        id: 'analyze-customer-feedback-trends',
        title: 'Analyze customer feedback trends',
        prompt: 'Gather and synthesize customer feedback on `product/feature` from various channels such as emails, calls, surveys, support tickets to identify key themes, pain points, opportunities such as upsell and adoption, and organize findings into actionable recommendations. If relevant, map them to stages of the customer journey.',
        useCase: 'Analyze',
        roles: [
            'Product',
            'Marketing',
            'Engineering',
            'Program Management',
            'Customer Support',
            'Sales'
        ],
        enableDeepResearch: true
    },
    // {
    // 	id: 'analyze-it-support-trends',
    // 	title: 'Analyze Trends in IT Support Requests',
    // 	prompt:
    // 		'Examine all IT support requests related to `request type` from the past `number of months` months. Break down the request type by identifying the most common sub-categories and providing counts for each. Investigate resolution notes or agent comments to uncover recurring root causes behind these issues. Identify any time-based patterns, such as spikes in requests during specific times of day, days of the week, or months. Based on your findings, recommend actionable strategies to effectively reduce the volume of this request type.',
    // 	useCase: 'Analyze',
    // 	roles: ['Helpdesk Support', 'IT Ops', 'Customer Support', 'Program Management'],
    // },
    {
        id: 'brainstorm-project-ideas',
        title: 'Brainstorm ideas for project',
        prompt: "We're running a brainstorming session on `topic/problem/goal`. Generate a diverse list of creative ideas, solutions, and/or approaches. For each idea, include a brief description, potential benefits, and any risks or challenges. Organize the ideas by theme or category if possible.",
        useCase: 'Brainstorm',
        roles: [
            'General'
        ]
    },
    {
        id: 'send-slack-weekly-progress',
        title: 'Send Slack message of weekly progress',
        prompt: 'Draft a summary of the key updates and additions I made over the past week. Send this summary in Slack to `Teams channel link`. Confirm the draft with me before sending.',
        useCase: 'Execute',
        roles: [
            'General'
        ]
    },
    {
        id: 'compare-jira-support-article',
        title: 'Compare Jira work item to support article',
        prompt: 'Review the summary, description, and comments of the current request `work item ID`. Based on this information and considering common themes from recently resolved requests, determine if this issue points to a recurring problem that currently lacks a dedicated knowledge base article. If so, propose a concise title for a new knowledge base article and 2-3 key topics or resolution steps it should cover. This should be a distinct problem, not a minor variation of an existing knowledge base article.',
        useCase: 'Review',
        roles: [
            'Helpdesk Support',
            'Customer Support',
            'IT Ops',
            'Program Management'
        ]
    },
    // {
    // 	id: 'conduct-competitive-research',
    // 	title: 'Conduct competitive research',
    // 	prompt:
    // 		'Analyze the competitive landscape for `product` against `Competitor A, B, C, and D` by comparing features, pricing, market positioning, and strengths. Identify market gaps for `product` to explore. Summarize findings in a narrative, including a comparison matrix.',
    // 	useCase: 'Analyze',
    // 	roles: ['Product', 'Program Management', 'Marketing', 'Sales'],
    // },
    {
        id: 'convert-request-jql-query',
        title: 'Convert request into JQL query',
        prompt: 'Write a JQL query to find all unresolved bugs assigned to my team in the last 30 days.',
        useCase: 'Execute',
        roles: [
            'Engineering',
            'Product',
            'IT Ops'
        ]
    },
    // {
    // 	id: 'create-jira-work-item-summaries',
    // 	title: 'Create a document of Jira work item summaries',
    // 	prompt:
    // 		'Generate a Confluence page summarizing information in these work items: `work item ID(s)`.',
    // 	useCase: 'Summarize',
    // 	roles: ['Product', 'Program Management', 'Engineering', 'Customer Support'],
    // },
    // {
    // 	id: 'create-new-sprint',
    // 	title: 'Create a new sprint',
    // 	prompt:
    // 		'Create a new sprint named `sprint name` on the board: `board key`. Set the sprint goal to `sprint goal`, start date to `YYYY-MM-DD`, and end date to `YYYY-MM-DD`.',
    // 	useCase: 'Execute',
    // 	roles: ['Engineering', 'Product', 'Program Management'],
    // },
    {
        id: 'create-ab-testing-plan',
        title: 'Create A/B testing plan',
        prompt: 'Create a detailed A/B testing plan for `project/feature`. Start by defining the hypothesis and primary goal, specifying the variants to be tested, and identifying the key metric(s) for success. Outline the target audience and sample size, describe how users will be randomly assigned to each group, and set the test duration and timeline. Include steps for implementation, data collection, and analysis, and note any tools or platforms to be used. Finally, add placeholders for documenting results, learnings, and next steps, ensuring the plan is clear, actionable, and easy to adapt for different experiments, with space for users to add or modify details as needed.',
        useCase: 'Create',
        roles: [
            'Product',
            'Marketing',
            'Engineering',
            'Design'
        ]
    },
    // {
    // 	id: 'create-effective-okr',
    // 	title: 'Create an effective OKR',
    // 	prompt: 'Help me create an effective OKR for my team.',
    // 	useCase: 'Create',
    // 	roles: ['General', 'Product', 'Program Management'],
    // },
    {
        id: 'create-background-research-plan',
        title: 'Create background research plan',
        prompt: 'Create a first draft or conduct background research on `topic/work item`. Summarise key points, relevant history, and provide links to supporting documents.',
        useCase: 'Summarize',
        roles: [
            'Product',
            'Program Management',
            'Engineering',
            'Design'
        ]
    },
    {
        id: 'create-customer-onboarding-strategy',
        title: 'Create customer onboarding strategy',
        prompt: 'As a customer success lead, outline a clear customer onboarding strategy for `product or service`, including key objectives, main onboarding steps, communication touchpoints, and success metrics; highlight best practices for activation and engagement, and provide space for users to add project-specific details or adapt the strategy for different customer segments, ensuring the plan is concise, actionable, and easy to share with stakeholders.',
        useCase: 'Create',
        roles: [
            'Customer Support',
            'Sales',
            'Product',
            'Program Management'
        ]
    },
    // {
    // 	id: 'create-jira-work-item',
    // 	title: 'Create Jira work item',
    // 	prompt:
    // 		'Create a Jira work item in project `project key` with work type as `bug/task/story/epic`, status as TO DO, classification level as project default, and the summary "`summary`."',
    // 	useCase: 'Execute',
    // 	roles: ['Engineering', 'Product', 'IT Ops', 'Customer Support'],
    // },
    // {
    // 	id: 'create-meeting-agenda',
    // 	title: 'Create meeting agenda',
    // 	prompt:
    // 		'Create a `number of minutes/hours` meeting agenda with `person/team/department` on `meeting topic` to discuss `objectives for the meeting`. Based on these objectives, suggest key topics, allocate appropriate time for each, and list any supporting materials needed.',
    // 	useCase: 'Create',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'create-personalized-onboarding-plan',
    // 	title: 'Create personalized onboarding plan',
    // 	prompt:
    // 		'Create a 30-day plan to help me get up to speed. I am onboarding onto `team` as a `role`. Include learning resources, team priorities, key contacts, and engagement strategies.',
    // 	useCase: 'Create',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'create-presentation-outline',
    // 	title: 'Create presentation outline',
    // 	prompt:
    // 		'Outline a talk track for a presentation targeting `company/product` clients in the `sector` to educate them on the `solution`. Ensure the talk track is clear, informative, and formatted with timestamps in a table.',
    // 	useCase: 'Create',
    // 	roles: ['Product', 'Marketing', 'Sales'],
    // },
    // {
    // 	id: 'create-pricing-model-customers',
    // 	title: 'Create pricing model for customers',
    // 	prompt:
    // 		'Generate a pricing model for `customer/product` using the latest customer data. Include scenario analysis and pricing plan comparisons.',
    // 	useCase: 'Create',
    // 	roles: ['Sales', 'Product', 'Marketing'],
    // },
    {
        id: 'create-product-requirements-document',
        title: 'Create product requirements document',
        prompt: 'Draft a PRD for `project/feature`. Depending on context such as OKRs, PRD, A/B test, retrospective, include objectives, hypotheses, requirements, metrics, learnings, and next steps.',
        useCase: 'Create',
        roles: [
            'Program Management',
            'Design',
            'Product',
            'Engineering'
        ]
    },
    // {
    // 	id: 'create-recurring-calendar-meeting',
    // 	title: 'Create recurring calendar meeting',
    // 	prompt:
    // 		'Create a `number of minutes` recurring calendar meeting every `day` at `HH:MM am/pm` `timezone` for `project` with `person`.',
    // 	useCase: 'Execute',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'create-release-notes',
    // 	title: 'Create release notes',
    // 	prompt:
    // 		'Create clear release documentation for `project/product`. Include release date, features, fixes, known issues, and Jira work items/references if found. Provide output in multiple formats such as Confluence, PDF, Markdown as needed.',
    // 	useCase: 'Create',
    // 	roles: ['Engineering', 'Program Management', 'Product', 'Customer Support'],
    // },
    // {
    // 	id: 'create-resolution-notes',
    // 	title: 'Create resolution notes',
    // 	prompt:
    // 		'Create resolution notes for future reference suitable for other agents and team leads to quickly understand the following work item and its resolution: `work item link`. Include a brief and clear description of the problem, the identified root cause, and a summary of the diagnostic steps and actions performed. Clearly state the exact resolution that was implemented. Specify the total time from ticket creation to resolution using HH:MM format, or days/hours if longer.',
    // 	useCase: 'Create',
    // 	roles: ['Helpdesk Support', 'Customer Support', 'IT Ops'],
    // },
    // {
    // 	id: 'draft-blog-post',
    // 	title: 'Draft a blog post',
    // 	prompt:
    // 		'Draft a blog post or marketing collateral for `product/feature`. Highlight key benefits, use cases, and include customer testimonials if available.',
    // 	useCase: 'Create',
    // 	roles: ['Marketing', 'Product', 'Sales'],
    // },
    // {
    // 	id: 'draft-usability-testing-script',
    // 	title: 'Draft a usability testing script',
    // 	prompt:
    // 		'Draft a detailed usability testing script for the following feature/product `Confluence page link`. The script should be suitable for a moderated session and include the following sections: Introduction for the participant (Reassure the participant that the focus is on the product, not their performance), Warm-up/background questions, Scenario setup, Task instructions, and Wrap-up questions. For each task, specify what a successful outcome looks like and, if appropriate, include a rating scale for ease of use. Throughout, use accessible, concise, and clear language, avoid jargon and directional UI language, keep instructions and questions short and focused, and ensure the script is easy to follow for both moderator and participant, formatting it as a template that can be easily adapted for different products or features',
    // 	useCase: 'Create',
    // 	roles: ['Design', 'Product'],
    // },
    // {
    // 	id: 'draft-and-send-email',
    // 	title: 'Draft and send email',
    // 	prompt:
    // 		"Draft an email to `email address` with the subject `Subject` with a message regarding `topic/purpose`. Once I've confirmed, send this email.",
    // 	useCase: 'Execute',
    // 	roles: ['General'],
    // },
    {
        id: 'edit-confluence-page-status',
        title: 'Edit Confluence page status',
        prompt: "Update this page's status to Ready for Review: `Confluence page link`",
        useCase: 'Execute',
        roles: [
            'General',
            'Engineering',
            'Product',
            'Program Management'
        ]
    },
    // {
    // 	id: 'explain-acronym',
    // 	title: 'Explain an acronym',
    // 	prompt:
    // 		"Explain the meaning of the acronym '`acronym`' in this context: `context`. Provide its full form and a brief definition.",
    // 	useCase: 'Learn',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'explain-end-to-end-service-flow',
    // 	title: 'Explain End-to-End Service Flow',
    // 	prompt:
    // 		'Explain the `process/system flow` for `feature` as experienced by `end-user/customer`. Include each step from `start event` to `end event`. Highlight any system interactions, notifications, and common issues or exceptions. Provide diagrams or documentation links if available.',
    // 	useCase: 'Learn',
    // 	roles: [
    // 		'Sales',
    // 		'IT Ops',
    // 		'Program Management',
    // 		'Customer Support',
    // 		'Product',
    // 		'Security',
    // 		'Helpdesk Support',
    // 		'Engineering',
    // 	],
    // },
    {
        id: 'explain-code',
        title: 'Explain this code',
        prompt: 'Explain what the code below does, describing its purpose, how it works, and any important details or logic involved. Use clear, concise language suitable for someone with basic programming knowledge. `Insert code snippet`.',
        useCase: 'Learn',
        roles: [
            'Engineering'
        ]
    },
    {
        id: 'extract-key-insights-datasets',
        title: 'Extract key insights from datasets',
        prompt: '`Upload dataset file(s)` Based on the provided dataset, please analyze and present the top 5 most interesting observations, highlights, or trends, identifying segments that were more likely to respond in a certain way, significant patterns, or unexpected insights from the data.',
        useCase: 'Analyze',
        roles: [
            'Product',
            'Marketing',
            'Engineering'
        ]
    },
    // {
    // 	id: 'find-analyze-customer-contracts',
    // 	title: 'Find and analyze information from customer contracts',
    // 	prompt:
    // 		'Analyze all existing contracts for `project/customer segment/time period` and extract information on response times, maintenance obligations, and product rates. Present findings in a comparative table, highlighting any variations between customers. If available, include contract names (`Contract name/ID`), customer names (`Customer A, Customer B]), and any relevant contract dates (`Effective Date, Expiry Date`).',
    // 	useCase: 'Analyze',
    // 	roles: ['Product', 'Program Management'],
    // },
    {
        id: 'find-prioritize-open-pull-requests',
        title: 'Find and prioritize open pull requests',
        prompt: "Summarize all my open pull requests in across all repositories I have access to in Bitbucket, as well as all pull requests where I'm assigned as a reviewer. Clearly indicate the number of pull requests pending my review and the total number of open PRs involving me. Group the results by repository and include key details such as PR title, status, author, and last updated date.",
        useCase: 'Summarize',
        roles: [
            'Engineering'
        ]
    },
    // {
    // 	id: 'find-hr-policies',
    // 	title: 'Find HR policies',
    // 	prompt:
    // 		'Find all the HR policies that a new hire joining the `location` office would need during onboarding. Reference the latest HR policy resources. Organize results in a table and check if all required policies and contacts are included.',
    // 	useCase: 'Find',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'find-information-3p-sources',
    // 	title: 'Find information from 3P sources',
    // 	prompt: 'Find the latest `topic` presentation in our Google Drive or other 3rd party sources.',
    // 	useCase: 'Find',
    // 	roles: ['Product', 'Marketing', 'Sales'],
    // },
    {
        id: 'find-overdue-jira-work-items',
        title: 'Find overdue Jira work items for my team',
        prompt: 'Show all overdue work items for my team, including links to them and how long they have been overdue.',
        useCase: 'Find',
        roles: [
            'Engineering',
            'IT Ops',
            'Helpdesk Support',
            'Program Management'
        ]
    },
    // {
    // 	id: 'find-potential-security-vulnerabilities',
    // 	title: 'Find potential security vulnerabilities',
    // 	prompt:
    // 		'For this pull request `pull request ID`, identify and summarize any changes that were made that have potential security vulnerabilities.',
    // 	useCase: 'Find',
    // 	roles: ['Security', 'IT Ops'],
    // },
    // {
    // 	id: 'find-related-jira-projects',
    // 	title: 'Find related Jira projects',
    // 	prompt: 'What Jira projects have ongoing work that relates to this decision: `description`?',
    // 	useCase: 'Find',
    // 	roles: ['Program Management', 'Product', 'Engineering'],
    // },
    {
        id: 'find-relevant-confluence-pages',
        title: 'Find relevant Confluence pages',
        prompt: 'For `work item ID/project/feature`, find and list any related Confluence pages or reference work items. Include links and a brief summary of how each is relevant.',
        useCase: 'Find',
        roles: [
            'Program Management',
            'Product',
            'Engineering'
        ]
    },
    // {
    // 	id: 'find-requirements-jira-work-item',
    // 	title: 'Find requirements for a Jira work item',
    // 	prompt:
    // 		'Identify and document the requirements for work item `work item ID`. Ensure all necessary details are captured, including dependencies and acceptance criteria.',
    // 	useCase: 'Find',
    // 	roles: ['Engineering', 'Product', 'Program Management'],
    // },
    // {
    // 	id: 'find-subject-matter-expertise',
    // 	title: 'Find subject-matter expertise',
    // 	prompt:
    // 		'Find the subject matter expert for `topic`. I need to contact them for `purpose, e.g., advice, review, collaboration`. Confirm the recommended person is the most relevant and available expert.',
    // 	useCase: 'Find',
    // 	roles: ['General', 'Engineering', 'Product', 'Program Management'],
    // },
    // {
    // 	id: 'draft-it-support-response',
    // 	title: 'Draft IT Support response',
    // 	prompt:
    // 		'Draft a reply to a user who is experiencing `topic` issues. Provide clear, empathetic guidance and suggest next steps for resolving the problem using this guide/playbook [Confluence page link]. Here is the user request: `User request`.',
    // 	useCase: 'Create',
    // 	roles: ['Customer Support', 'Helpdesk Support'],
    // },
    {
        id: 'find-latest-company-policies',
        title: 'Find the latest company policies',
        prompt: 'How do I request reimbursements for my travels?',
        useCase: 'Learn',
        roles: [
            'General'
        ]
    },
    {
        id: 'generate-faq',
        title: 'Generate an FAQ',
        prompt: "Map out the typical customer journey for `product/service`, from initial discovery through onboarding, usage, and support. Then, generate top FAQs that customers most frequently ask at each stage\u2014covering how to get started, feature usage, troubleshooting, billing, and best practices\u2014with concise, step-by-step answers formatted for a chatbot.",
        useCase: 'Create',
        roles: [
            'Customer Support',
            'Program Management',
            'Product',
            'Marketing'
        ]
    },
    {
        id: 'generate-post-project-surveys',
        title: 'Generate post-project surveys',
        prompt: "Create a comprehensive evaluation survey for `project` to assess the project's performance, including successes, challenges, areas for improvement, and lessons learned. Include questions such as scale, multiple choice, and open answer covering: objectives and outcomes, budget and resources, team performance and collaboration, challenges and problem-solving, stakeholder satisfaction, and recommendations for future projects.",
        useCase: 'Create',
        roles: [
            'Program Management',
            'Product',
            'General'
        ]
    },
    // {
    // 	id: 'identify-upsell-opportunities',
    // 	title: 'Identify upsell opportunities',
    // 	prompt:
    // 		"Analyze the provided call transcript `link to call transcript` with the customer `customer name` and identify all instances where the customer expresses interest in additional features or services. For each instance, include relevant background context, the exact customer quote indicating interest, and a brief explanation of why it represents a potential upsell opportunity. Additionally, recommend the most suitable upsell product or service based on the customer's expressed needs or goals.",
    // 	useCase: 'Analyze',
    // 	roles: ['Sales', 'Product', 'Customer Support', 'Marketing'],
    // },
    {
        id: 'learn-company-procedure-information',
        title: 'Learn about company procedure information',
        prompt: 'Summarize the standard procedures for `process/activity` across the company. Include step-by-step instructions and reference documents.',
        useCase: 'Summarize',
        roles: [
            'General',
            'IT Ops',
            'Program Management'
        ]
    },
    // {
    // 	id: 'plan-sprint-tasks',
    // 	title: 'Plan sprint tasks',
    // 	prompt:
    // 		'Generate a detailed task list for our upcoming sprint using the information provided in `project poster`. For each task, include the task name, a brief description, the responsible team member, and estimated completion time. Organize the tasks by priority level and group them according to their related user stories to ensure clarity and alignment with sprint goals. Flag any missing details needed to finalize sprint planning.',
    // 	useCase: 'Create',
    // 	roles: ['Engineering', 'Program Management', 'Product', 'IT Ops'],
    // },
    // {
    // 	id: 'prepare-performance-review',
    // 	title: 'Prepare for your performance review',
    // 	prompt:
    // 		'Prepare talking points for an upcoming growth conversation with my manager, summarizing my work between `dates`, organized by key projects. The points should facilitate a productive discussion about my performance, achievements, and areas for improvement. They should be clear, concise, and backed by specific examples and evidence. Organize into sections for each major project, including: project overview, my specific contributions, and relevant links.',
    // 	useCase: 'Summarize',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'retrieve-pull-request-insights-jira',
    // 	title: 'Retrieve pull request insights from Jira',
    // 	prompt:
    // 		'For the given Jira work item Jira work item `link to Jira work item`, retrieve all linked pull requests across repositories. Include each pull request number, title, current review status such as Draft, Open, Approved, Merged, or Rejected, the associated reviewers, and the merge date if applicable. Output a structured table with the columns PR Number, Title, Status, Reviewers, and Merge Date.',
    // 	useCase: 'Find',
    // 	roles: ['Engineering'],
    // },
    // {
    // 	id: 'review-improve-presentation',
    // 	title: 'Review and improve presentation',
    // 	prompt:
    // 		'Review this presentation `upload or link presentation slides/script` and provide me with suggestions on how to improve it. Please consider the following context: the audience consists of [audience, e.g., senior executives, students, clients], the primary goal is [goal, e.g., to persuade, to inform, to inspire], and the desired outcome is `outcome, e.g., increased engagement, clear understanding, actionable next steps`. Focus your feedback on the overall structure, flow, clarity, and impact, and tailor your suggestions to maximize effectiveness for this specific audience and goal.',
    // 	useCase: 'Review',
    // 	roles: ['General'],
    // },
    {
        id: 'review-improve-writing',
        title: 'Review and improve writing',
        prompt: 'Rewrite the following message to make it more clear, concise, and professional while retaining all key details: `Insert message here`.',
        useCase: 'Review',
        roles: [
            'General',
            'Sales',
            'Customer Support'
        ]
    },
    {
        id: 'search-policies-questionnaires',
        title: 'Search policies related to questionnaires',
        prompt: 'Search all internal security and compliance policies and provide answers to the following questionnaire. Reference policy documents and highlight relevant sections for each answer.',
        useCase: 'Find',
        roles: [
            'Security',
            'IT Ops'
        ]
    },
    // {
    // 	id: 'send-ms-teams-weekly-progress',
    // 	title: 'Send MS Teams message of weekly progress',
    // 	prompt:
    // 		'Draft a summary of the key updates and additions I made over the past week. Send this summary in MS Teams to `Teams channel link`. Confirm the draft with me before sending.',
    // 	useCase: 'Execute',
    // 	roles: ['General'],
    // },
    {
        id: 'suggest-process-streamlining',
        title: 'Suggest process streamlining',
        prompt: 'Suggest ways to streamline the process for `process/task`. Identify steps that can be automated or simplified to reduce manual work and produce more succinct outputs.',
        useCase: 'Learn',
        roles: [
            'Program Management',
            'IT Ops',
            'Engineering'
        ]
    },
    {
        id: 'summarize-track-project-updates',
        title: 'Summarize and track project updates',
        prompt: 'Summarize the status and history of `project/topic/feature`. Include key initiatives, progress made, stakeholders, decisions, timelines, and relevant documents. Highlight upcoming milestones or blockers.',
        useCase: 'Summarize',
        roles: [
            'General',
            'Engineering',
            'Product',
            'Program Management'
        ]
    },
    // {
    // 	id: 'summarize-confluence-page-google-doc',
    // 	title: 'Summarize Confluence page and add to Google doc',
    // 	prompt:
    // 		'Summarize key points and any action items/next steps in this Confluence page: `Confluence page link` and add this summary to a new Google doc titled "`title`" under the folder "`folder`."',
    // 	useCase: 'Summarize',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'summarize-engineering-requests',
    // 	title: 'Summarize engineering requests',
    // 	prompt: 'Review and summarize recent Engineering Requests (ERs) for my team.',
    // 	useCase: 'Review',
    // 	roles: ['Engineering', 'Product', 'Program Management'],
    // },
    {
        id: 'summarize-meeting-notes',
        title: 'Summarize meeting notes',
        prompt: 'Summarize the meeting with the transcript `attach file or paste transcript`, including main topics discussed, key decisions, and action items.',
        useCase: 'Summarize',
        roles: [
            'General'
        ]
    },
    {
        id: 'synthesize-user-testing-findings',
        title: 'Synthesize findings from user testing',
        prompt: 'Synthesize key insights from my user testing: `Confluence page link/transcript`. Identify the top pain points or issues that users faced during the testing. Categorize these issues by severity and impact on user experience.',
        useCase: 'Analyze',
        roles: [
            'Design'
        ]
    },
    {
        id: 'visualize-data-charts',
        title: 'Visualize your data into charts',
        prompt: '`Upload your dataset file(s)` Based on the uploaded dataset file, determine the most effective way to visualize the data. Identify the key structure and variables within the dataset and the most likely user goals for this data, to suggest and describe the most appropriate type of visualization.',
        useCase: 'Analyze',
        roles: [
            'Product',
            'Engineering',
            'Marketing'
        ]
    }
];
const $08b97b2e27a84eff$export$802094cfe9873dbe = [
    // Salesforce
    {
        id: '3p-salesforce-recommend-next-steps-deals',
        title: 'Recommend next steps for my deals',
        prompt: 'Recommend next steps for my deals',
        useCase: 'Execute',
        roles: [
            'Sales'
        ],
        appIds: [
            'salesforce'
        ]
    },
    // SharePoint & One Drive & Google Drive
    {
        id: '3p-onboarding-guide',
        title: 'Create onboarding guide',
        prompt: 'Create an onboarding guide for new hires using documents in `product` folder',
        useCase: 'Create',
        roles: [
            'General',
            'Product',
            'Program Management'
        ],
        appIds: [
            'google_drive',
            'microsoft_sharepoint',
            'microsoft_onedrive'
        ]
    },
    {
        id: '3p-find-product-specs-last-month',
        title: 'Find product specs from last month',
        prompt: 'Find product specs in `Google Drive/Sharepoint/Onedrive` that were created in the last month',
        useCase: 'Find',
        roles: [
            'Product',
            'Engineering',
            'Program Management'
        ],
        appIds: [
            'google_drive',
            'microsoft_sharepoint',
            'microsoft_onedrive'
        ]
    },
    {
        id: '3p-callout-risks-fy27',
        title: 'Callout the risks in Strategy doc',
        prompt: 'Callout the risks you see in the FY27 Strategy doc shared with me.',
        useCase: 'Review',
        roles: [
            'General',
            'Product',
            'Program Management'
        ],
        appIds: [
            'google_drive',
            'microsoft_sharepoint',
            'microsoft_onedrive'
        ]
    }
];
const $08b97b2e27a84eff$var$staticPromptsWithSkill = [
    // {
    // 	id: 'summarize-release',
    // 	title: 'Summarize release',
    // 	prompt:
    // 		"/summarize-release this `Jira release` for `product` to generate an executive snapshot. Include: 1) key changes grouped by epic or component, 2) risks and blockers with owners and dates, 3) quality signals (open bugs, regressions, flaky tests), 4) planned rollout and key dates, and 5) clear next steps for stakeholders.",
    // 	useCase: 'Summarize',
    // 	roles: ['Product', 'Engineering'],
    // 	enableDeepResearch: true,
    // },
    {
        id: 'create-release',
        title: 'Create release',
        prompt: "/create-release in this `Jira space` to create a new release with start and release dates. Include completed work items and summarize what's included by epic or team.",
        useCase: 'Create',
        roles: [
            'Program Management',
            'Engineering'
        ],
        tags: [
            'jira-releases'
        ]
    },
    // {
    // 	id: 'draft-release-notes',
    // 	title: 'Draft release notes',
    // 	prompt:
    // 		"/draft-release-notes for this `Jira release` and related `Confluence page` to generate customer-facing release notes. Organize into \"What's new\", \"Improvements\", \"Fixes\", and \"Known issues\" with clear, non-technical language.",
    // 	useCase: 'Create',
    // 	roles: ['Marketing', 'Engineering'],
    // 	enableDeepResearch: true,
    // },
    // {
    // 	id: 'create-work-items',
    // 	title: 'Create work items',
    // 	prompt:
    // 		"/create-work-items from this `Confluence page` (feature spec) in this `Jira space`. Break the feature into epics, stories, and tasks with summaries, descriptions, and estimates. List everything created, grouped by epic.",
    // 	useCase: 'Create',
    // 	roles: ['Product', 'Engineering'],
    // 	enableDeepResearch: true,
    // },
    // {
    // 	id: 'write-status-update',
    // 	title: 'Write status update',
    // 	prompt:
    // 		"/write-status-update with this `Jira space` and these `Confluence pages` to draft a status update for `project/initiative` over the last `time period`. Include overall RAG, key achievements, major risks/blockers with owners, and next steps.",
    // 	useCase: 'Create',
    // 	roles: ['Program Management', 'Product'],
    // 	enableDeepResearch: true,
    // },
    // {
    // 	id: 'page-catchup',
    // 	title: 'Page catchup',
    // 	prompt:
    // 		"/page-catchup this `Confluence page` to summarize what changed in the last `time period`. Highlight new sections, major edits, important comments, and open tasks or questions.",
    // 	useCase: 'Summarize',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'update-work-items',
    // 	title: 'Update work items',
    // 	prompt:
    // 		"/update-work-items for these `Jira work items` in this `Jira space` to bulk update: set assignee, add label, and move items to a new status if no blockers. Show a summary of planned changes first.",
    // 	useCase: 'Execute',
    // 	roles: ['Program Management', 'Engineering'],
    // },
    // {
    // 	id: 'manage-jira-permissions',
    // 	title: 'Manage Jira permissions',
    // 	prompt:
    // 		"/manage-jira-permissions for this `Jira work item` or `Jira space` to diagnose permission issues, explain missing permissions, and provide admin guidance to resolve.",
    // 	useCase: 'Execute',
    // 	roles: ['IT Ops', 'Security'],
    // },
    // {
    // 	id: 'find-jira-settings',
    // 	title: 'Find Jira settings',
    // 	prompt:
    // 		"/find-jira-settings for this `Jira space` and my goal \"`desired behavior`\". Tell me which settings to change, where to find them, and any trade-offs.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops'],
    // },
    {
        id: 'manage-jira-workflows',
        title: 'Manage Jira workflows',
        prompt: '/manage-jira-workflows for this `Jira space` to analyze its workflow: explain statuses, transitions, top workflow rules, and propose simplifications.',
        useCase: 'Execute',
        roles: [
            'IT Ops',
            'Program Management'
        ],
        tags: [
            'jira-workflows'
        ]
    },
    // {
    // 	id: 'search-assets',
    // 	title: 'Search Assets',
    // 	prompt:
    // 		"/search-assets in this `JSM project` for \"`asset search criteria`\" and highlight any related to this `JSM incident` or `Jira work item`. Return a table of matching assets.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops'],
    // },
    // {
    // 	id: 'create-pir',
    // 	title: 'Create PIR',
    // 	prompt:
    // 		"/create-pir for this `JSM incident` and related `Confluence pages` to draft a complete Post Incident Review with all standard sections.",
    // 	useCase: 'Create',
    // 	roles: ['IT Ops'],
    // 	enableDeepResearch: true,
    // },
    {
        id: 'analyze-incident-root-cause',
        title: 'Find root cause of an incident (RCA)',
        prompt: '/analyze-incident-root-cause for this `JSM incident` to analyze details, linked alerts, changes, assets, and similar incidents. Propose likely root cause and investigation steps.',
        useCase: 'Analyze',
        roles: [
            'IT Ops'
        ],
        enableDeepResearch: true
    },
    {
        id: 'find-incident-root-cause',
        title: 'Find incident root cause',
        prompt: '/find-incident-root-cause for this `JSM incident` to infer the most likely root cause and provide a stakeholder-friendly summary.',
        useCase: 'Find',
        roles: [
            'IT Ops',
            'General'
        ],
        enableDeepResearch: true
    },
    // {
    // 	id: 'find-incidents',
    // 	title: 'Find incidents',
    // 	prompt:
    // 		"/find-incidents in this `JSM project` for incidents from the last `time period` matching \"`criteria`\". Group by status or service, show counts, and surface the most impactful incidents.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops'],
    // },
    {
        id: 'find-similar-incidents',
        title: 'Find similar incidents',
        prompt: '/find-similar-incidents for this `JSM incident` to find the most similar historical incidents, how they were resolved, and any recurring patterns.',
        useCase: 'Find',
        roles: [
            'IT Ops'
        ],
        enableDeepResearch: true
    },
    {
        id: 'suggest-problem-ticket',
        title: 'Suggest problem ticket',
        prompt: '/suggest-problem-ticket for this `JSM incident` to check for similar incidents and, if recurring, propose a problem ticket with all key details and links.',
        useCase: 'Create',
        roles: [
            'IT Ops'
        ]
    },
    {
        id: 'suggest-incident-fields',
        title: 'Suggest incident fields',
        prompt: '/suggest-incident-fields for this `JSM incident` to propose values for service, component, priority, impact, urgency, and major incident flag, with justifications.',
        useCase: 'Execute',
        roles: [
            'Helpdesk Support',
            'IT Ops'
        ]
    },
    {
        id: 'suggest-incident-sme',
        title: 'Suggest incident SME',
        prompt: '/suggest-incident-expert for this `JSM incident` to recommend the best people or teams to involve, with reasons and suggested actions.',
        useCase: 'Find',
        roles: [
            'IT Ops'
        ]
    },
    {
        id: 'summarize-incident',
        title: 'Summarize incident',
        prompt: '/summarize-incident for this `JSM incident` to create an executive summary with impact, timeline, root cause, mitigation, and next steps.',
        useCase: 'Summarize',
        roles: [
            'IT Ops',
            'General'
        ]
    },
    // {
    // 	id: 'find-alerts',
    // 	title: 'Find alerts',
    // 	prompt:
    // 		"/find-alerts in this `JSM project` for alerts from the last `time period`. Group by service and severity, highlight recurring alerts, and relate to incidents or changes.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops', 'Engineering'],
    // },
    // {
    // 	id: 'recommend-playbook',
    // 	title: 'Recommend playbook',
    // 	prompt:
    // 		"/recommend-playbook for this `alert` or `JSM incident` to suggest the best runbooks or playbooks, with links and first steps.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops', 'Engineering'],
    // },
    {
        id: 'assess-change-risk-insights',
        title: 'Assess change risk insights',
        prompt: '/assess-change-risk for this `JSM change request` to assess risk, explain drivers, and suggest safeguards like canary deployments or extra approvals.',
        useCase: 'Analyze',
        roles: [
            'IT Ops'
        ]
    },
    {
        id: 'get-data-insights',
        title: 'Get data insights',
        prompt: '/get-data-insights for this `Jira space` to create charts (throughput, cycle time, WIP) and interpret trends, bottlenecks, and recommendations.',
        useCase: 'Analyze',
        roles: [
            'Engineering',
            'Program Management'
        ],
        enableDeepResearch: true
    }
];
// Filters out prompt cards that reference skills but have no skill metadata.
// This will also act as an entitlement check for the user.
const $08b97b2e27a84eff$var$filterCardsBySkillMetadata = (cards, skillMetadataMap)=>{
    if (skillMetadataMap === undefined) return cards;
    return cards.filter((card)=>{
        const slugs = $08b97b2e27a84eff$export$bee44b12dce7b448(card.prompt);
        if (slugs.length === 0) return true;
        return slugs.every((slug)=>slug in skillMetadataMap);
    });
};
const $08b97b2e27a84eff$export$47aa2ee75b720c2e = ()=>{
    const skillMetadata = (0, $kfhjt.useSkillMetadata)();
    // First 3 curated prompts, then skills prompts, then the rest
    const first3Prompts = $08b97b2e27a84eff$var$staticPrompts.slice(0, 3);
    const remainingPrompts = $08b97b2e27a84eff$var$staticPrompts.slice(3);
    const skillsPrompts = $08b97b2e27a84eff$var$filterCardsBySkillMetadata($08b97b2e27a84eff$var$staticPromptsWithSkill, skillMetadata?.skillMetadataMap);
    const promptCards = [
        ...first3Prompts,
        ...skillsPrompts,
        ...remainingPrompts
    ];
    return {
        promptCards: promptCards
    };
};
module.exports["useCaseOptions"] = $08b97b2e27a84eff$export$9fa6e712ef03097f;
module.exports["roleOptions"] = $08b97b2e27a84eff$export$9472c6a87dde5170;
module.exports["PROMPT_LIBRARY_SKILL_TAG"] = $08b97b2e27a84eff$export$1ac99e1b5b1a8cfe;
module.exports["usePromptCards"] = $08b97b2e27a84eff$export$47aa2ee75b720c2e;

});

parcelRegister("kfhjt", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $6xKWc = parcelRequire("6xKWc");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $lGVHb = parcelRequire("lGVHb");


var $1kZ3m = parcelRequire("1kZ3m");

function $fe4b28aa79dd69be$export$70de0c6012582ca5(skillsResponse) {
    if (!skillsResponse?.edges) return {};
    const metadataMap = {};
    skillsResponse.edges.forEach((edge)=>{
        const node = edge?.node;
        if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return;
        const skill = (0, $lGVHb.parseSkillNode)(node);
        if (!skill || !skill.slug) return;
        metadataMap[skill.slug] = {
            id: skill.id,
            name: skill.name,
            description: skill.description ?? '',
            iconName: skill.iconName,
            product: skill.product,
            productIconUrl: skill.productIconUrl,
            color: skill.color
        };
    });
    return metadataMap;
}
/**
 * Context for skill metadata
 */ const $fe4b28aa79dd69be$var$SkillMetadataContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
function $fe4b28aa79dd69be$export$6c7e4f3dd3ea4213() {
    return (0, $42omo.useContext)($fe4b28aa79dd69be$var$SkillMetadataContext);
}
function $fe4b28aa79dd69be$export$54587e1184069f96({ children: children, siteId: siteId, tags: tagsProp, fetchWithoutTags: fetchWithoutTags = false }) {
    const config = (0, $1kZ3m.useRovoSkillsConfig)();
    // Use tags from prop if provided, otherwise fallback to context
    const tags = tagsProp ?? config?.tags;
    const shouldFetch = !!tags?.skillRegistryTags && tags.skillRegistryTags.length > 0 || fetchWithoutTags;
    const skillsResponse = (0, $irOoi.useLazyLoadQuery)(/* eslint-disable @atlassian/relay/unused-fields -- fields consumed by transformSkillMetadataResponse in this file */ (0, $6xKWc.default), /* eslint-enable @atlassian/relay/unused-fields */ {
        first: 100,
        relevantFor: [
            'SKILL'
        ],
        cloudId: siteId,
        surface: 'ROVO',
        shouldSkip: !shouldFetch,
        tags: fetchWithoutTags ? undefined : tags?.skillRegistryTags ?? []
    })?.graphIntegration_componentDirectoryItems;
    const skillMetadataMap = (0, $42omo.useMemo)(()=>{
        if (!shouldFetch) return {};
        return $fe4b28aa79dd69be$export$70de0c6012582ca5(skillsResponse);
    }, [
        shouldFetch,
        skillsResponse
    ]);
    const value = (0, $42omo.useMemo)(()=>({
            skillMetadataMap: skillMetadataMap
        }), [
        skillMetadataMap
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($fe4b28aa79dd69be$var$SkillMetadataContext.Provider, {
        value: value,
        children: children
    });
}
module.exports["useSkillMetadata"] = $fe4b28aa79dd69be$export$6c7e4f3dd3ea4213;
module.exports["SkillMetadataProvider"] = $fe4b28aa79dd69be$export$54587e1184069f96;

});

parcelRegister("6xKWc", function(module, exports) {
/**
 * @generated SignedSource<<27cc1c9cdcb3817740dae9a94a60bc45>>
 * @relayHash 2b65d1bc6af8a5b24528e315a236250f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c5175af020c79b26302d5ffa3ae68ee40c220659f9948b0647fe7e453403671f
const $a3ea0bffc3c88cb6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "relevantFor"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkip"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "surface"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tags"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "relevantFor",
            "variableName": "relevantFor"
        },
        {
            "kind": "Variable",
            "name": "surface",
            "variableName": "surface"
        },
        {
            "kind": "Variable",
            "name": "tags",
            "variableName": "tags"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "slashCommand"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "kind": "ScalarField",
        "name": "description"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "color"
    }, v15 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            },
            {
                "kind": "ScalarField",
                "name": "startCursor"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v16 = [
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "skillMetadataProviderQuery",
            "selections": [
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "GraphIntegrationDirectoryItemConnection",
                            "kind": "LinkedField",
                            "name": "graphIntegration_componentDirectoryItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphIntegrationDirectoryItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                            "kind": "LinkedField",
                                                            "name": "integrationKey",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v12 /*: any*/ 
                                                            ]
                                                        },
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "GraphIntegrationSkillDirectoryItem"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v15 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "skillMetadataProviderQuery",
            "selections": [
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "GraphIntegrationDirectoryItemConnection",
                            "kind": "LinkedField",
                            "name": "graphIntegration_componentDirectoryItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphIntegrationDirectoryItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                            "kind": "LinkedField",
                                                            "name": "integrationKey",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "GraphIntegrationSkillDirectoryItem"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v16 /*: any*/ ,
                                                    "type": "GraphIntegrationActionDirectoryItem"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v16 /*: any*/ ,
                                                    "type": "GraphIntegrationMcpServer"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v16 /*: any*/ ,
                                                    "type": "GraphIntegrationMcpTool"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v16 /*: any*/ ,
                                                    "type": "GraphIntegrationSkillItem"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v15 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c5175af020c79b26302d5ffa3ae68ee40c220659f9948b0647fe7e453403671f",
            "metadata": {},
            "name": "skillMetadataProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a3ea0bffc3c88cb6$var$node.hash = "a886cc1a7f4cca0c76a7569f4eaae42e";
var $a3ea0bffc3c88cb6$export$2e2bcd8739ae039 = $a3ea0bffc3c88cb6$var$node;
module.exports["default"] = $a3ea0bffc3c88cb6$export$2e2bcd8739ae039;

});

parcelRegister("lGVHb", function(module, exports) {
function $b4b40a49047a27cf$export$74ea09dd5afceb60(node) {
    if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return null;
    const displayName = node.integrationKey?.displayName ?? '';
    const tagDisplayNames = node.tags?.map((t)=>t.displayName) ?? [];
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.name ?? '',
        description: node.description ?? '',
        iconName: node.iconUrl?.split('name/')?.[1],
        product: displayName ? displayName.charAt(0).toUpperCase() + displayName.slice(1) : '',
        productIconUrl: node.integrationKey?.iconUrl ?? '',
        ...node.color ? {
            color: node.color
        } : {},
        ...tagDisplayNames.length > 0 ? {
            tags: [
                ...tagDisplayNames
            ]
        } : {}
    };
}
function $b4b40a49047a27cf$export$2cffb029ea623d71(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$b4b40a49047a27cf$export$74ea09dd5afceb60(edge?.node)).filter((skill)=>skill !== null);
}
module.exports["parseSkillNode"] = $b4b40a49047a27cf$export$74ea09dd5afceb60;
module.exports["parseSkillEdges"] = $b4b40a49047a27cf$export$2cffb029ea623d71;

});

parcelRegister("1kZ3m", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

/**
 * Context for Rovo Skills configuration.
 */ const $5f6b1082b7930892$var$RovoSkillsConfigContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
function $5f6b1082b7930892$export$8f887a582517d0da() {
    return (0, $42omo.useContext)($5f6b1082b7930892$var$RovoSkillsConfigContext);
}
function $5f6b1082b7930892$export$4967709cc8a6f044({ config: config, children: children }) {
    const value = (0, $42omo.useMemo)(()=>config, [
        config
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($5f6b1082b7930892$var$RovoSkillsConfigContext.Provider, {
        value: value,
        children: children
    });
}
module.exports["useRovoSkillsConfig"] = $5f6b1082b7930892$export$8f887a582517d0da;
module.exports["RovoSkillsConfigProvider"] = $5f6b1082b7930892$export$4967709cc8a6f044;

});

parcelRegister("02cx8", function(module, exports) {
/* eslint-disable object-shorthand */ 
var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4c5988c837301b49$export$d4c72bab9d6cc13a = {
    actions: []
};
const $4c5988c837301b49$export$e324594224ef24da = {
    setActions: (actions)=>({ setState: setState })=>{
            setState({
                actions: actions
            });
        },
    setContext: (context)=>({ setState: setState })=>{
            setState({
                context: context
            });
        },
    removeContext: ()=>({ setState: setState })=>{
            setState({
                context: undefined
            });
        },
    removeActions: ()=>({ setState: setState })=>{
            setState({
                actions: []
            });
        }
};
const $4c5988c837301b49$export$e72cf4a64160987e = (0, $1P1Tu.createStore)({
    initialState: $4c5988c837301b49$export$d4c72bab9d6cc13a,
    actions: $4c5988c837301b49$export$e324594224ef24da,
    name: 'EditorRovoButtonActionsStore'
});
const $4c5988c837301b49$export$b95031893a3d9d63 = (0, $9zUhf.createActionsHook)($4c5988c837301b49$export$e72cf4a64160987e);
const $4c5988c837301b49$export$c693678b9cc11679 = (0, $9zUhf.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.actions
});
const $4c5988c837301b49$export$59213a5c9f9d59b8 = (0, $9zUhf.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.context
});
module.exports["useEditorRovoButtonActions"] = $4c5988c837301b49$export$b95031893a3d9d63;
module.exports["useEditorRovoButtonActionsActions"] = $4c5988c837301b49$export$c693678b9cc11679;
module.exports["useEditorRovoButtonActionsContext"] = $4c5988c837301b49$export$59213a5c9f9d59b8;

});

parcelRegister("boRaI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gj7hi = parcelRequire("gj7hi");


var $b0ri0 = parcelRequire("b0ri0");


var $dAyNE = parcelRequire("dAyNE");


var $1nYBG = parcelRequire("1nYBG");


var $7vkPX = parcelRequire("7vkPX");


var $70S4K = parcelRequire("70S4K");


var $i3kbP = parcelRequire("i3kbP");


var $2ONP7 = parcelRequire("2ONP7");


var $jvJxv = parcelRequire("jvJxv");


var $e9z1z = parcelRequire("e9z1z");

const $90920980e2243e44$var$createIcon = (src)=>()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: src,
            alt: ''
        });
const $90920980e2243e44$var$defaultIcon = $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($i3kbP))));
const $90920980e2243e44$export$cbe04d535daede57 = {
    Analyze: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($b0ri0)))),
    Brainstorm: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($dAyNE)))),
    Review: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($jvJxv)))),
    Summarize: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($e9z1z)))),
    Create: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($1nYBG)))),
    Execute: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($7vkPX)))),
    Find: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($70S4K)))),
    Learn: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($2ONP7))))
};
const $90920980e2243e44$export$8581fc8a588fa6e0 = $90920980e2243e44$var$defaultIcon;
const $90920980e2243e44$export$9b54dda66a3b3d54 = (useCase)=>{
    if (useCase === undefined || !(useCase in $90920980e2243e44$export$cbe04d535daede57)) return $90920980e2243e44$var$defaultIcon;
    return $90920980e2243e44$export$cbe04d535daede57[useCase];
};
module.exports["promptUseCaseIconMap"] = $90920980e2243e44$export$cbe04d535daede57;
module.exports["defaultPromptUseCaseIcon"] = $90920980e2243e44$export$8581fc8a588fa6e0;
module.exports["getUseCaseIcon"] = $90920980e2243e44$export$9b54dda66a3b3d54;

});

parcelRegister("b0ri0", function(module, exports) {
module.exports = new URL("analyze-icon.5c4c7ecb.svg", import.meta.url).toString();

});

parcelRegister("dAyNE", function(module, exports) {
module.exports = new URL("brainstorm-icon.f24d96f2.svg", import.meta.url).toString();

});

parcelRegister("1nYBG", function(module, exports) {
module.exports = new URL("create-icon.59c93a6c.svg", import.meta.url).toString();

});

parcelRegister("7vkPX", function(module, exports) {
module.exports = new URL("execute-icon.d7c359b6.svg", import.meta.url).toString();

});

parcelRegister("70S4K", function(module, exports) {
module.exports = new URL("find-icon.63225fe6.svg", import.meta.url).toString();

});

parcelRegister("i3kbP", function(module, exports) {
module.exports = new URL("general-prompt-icon.5618909f.svg", import.meta.url).toString();

});

parcelRegister("2ONP7", function(module, exports) {
module.exports = new URL("learn-icon.7e0ca0d6.svg", import.meta.url).toString();

});

parcelRegister("jvJxv", function(module, exports) {
module.exports = new URL("review-icon.7da7ded4.svg", import.meta.url).toString();

});

parcelRegister("e9z1z", function(module, exports) {
module.exports = new URL("summarize-icon.5a91c5af.svg", import.meta.url).toString();

});

parcelRegister("17128", function(module, exports) {

let $0cf73f1b90018a70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0cf73f1b90018a70$var$load("7t5Ax"),
    $0cf73f1b90018a70$var$load("lVBal"),
    $0cf73f1b90018a70$var$load("3ZAtx"),
    $0cf73f1b90018a70$var$load("2Gceu"),
    $0cf73f1b90018a70$var$load("lLK0D"),
    $0cf73f1b90018a70$var$load("7EorR"),
    $0cf73f1b90018a70$var$load("fisfU"),
    $0cf73f1b90018a70$var$load("hhss7"),
    $0cf73f1b90018a70$var$load("Wowvf"),
    $0cf73f1b90018a70$var$load("dek7I"),
    $0cf73f1b90018a70$var$load("dYtBN"),
    $0cf73f1b90018a70$var$load("kNV5Y"),
    $0cf73f1b90018a70$var$load("6wr18"),
    $0cf73f1b90018a70$var$load("kjZZD"),
    $0cf73f1b90018a70$var$load("99Ppz"),
    $0cf73f1b90018a70$var$load("5v2fx"),
    $0cf73f1b90018a70$var$load("ffEVr"),
    $0cf73f1b90018a70$var$load("aEk9k")
]).then(()=>parcelRequire('e1z3L'));

});

parcelRegister("h8ZMZ", function(module, exports) {

var $lbhE8 = parcelRequire("lbhE8");


var $iSfaF = parcelRequire("iSfaF");

const $53a95f2f1e6fae13$export$9b1c009846eb666 = ()=>{
    const state = (0, $lbhE8.useAtom)((0, $iSfaF.herState));
    return {
        // State
        isHerActive: state.isHerActive,
        isExpanded: state.isExpanded,
        isAnimating: state.isAnimating,
        contentId: state.contentId,
        contentType: state.contentType,
        cloudID: state.cloudID,
        textPreview: state.textPreview,
        toggleHer: // Actions
        $iSfaF.toggleHer,
        openHer: $iSfaF.openHer,
        closeHer: $iSfaF.closeHer,
        setExpanded: $iSfaF.setExpanded,
        setAnimating: $iSfaF.setAnimating,
        appendTextPreview: $iSfaF.appendTextPreview,
        clearTextPreview: $iSfaF.clearTextPreview
    };
};
module.exports["useHerStore"] = $53a95f2f1e6fae13$export$9b1c009846eb666;

});

parcelRegister("iSfaF", function(module, exports) {

var $9TRAA = parcelRequire("9TRAA");

const $6f93404dd586c0f7$var$initialState = {
    isHerActive: false,
    isExpanded: true,
    isAnimating: true,
    contentId: null,
    contentType: 'page',
    cloudID: '',
    textPreview: ''
};
const $6f93404dd586c0f7$export$b1d93e626697721f = (0, $9TRAA.e)($6f93404dd586c0f7$var$initialState);
const $6f93404dd586c0f7$export$780673425ffb59a7 = (contentId, cloudID, contentType)=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isHerActive: !prevState.isHerActive,
            // Reset to expanded when opening
            isExpanded: !prevState.isHerActive ? true : prevState.isExpanded,
            isAnimating: !prevState.isHerActive ? true : prevState.isAnimating,
            contentId: !prevState.isHerActive ? contentId ?? null : null,
            contentType: !prevState.isHerActive ? contentType ?? 'page' : 'page',
            cloudID: !prevState.isHerActive ? cloudID ?? prevState.cloudID : prevState.cloudID,
            textPreview: !prevState.isHerActive ? '' : prevState.textPreview
        }));
};
const $6f93404dd586c0f7$export$cc30aca21148df52 = (contentId, cloudID, contentType)=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isHerActive: true,
            isExpanded: true,
            isAnimating: true,
            contentId: contentId ?? null,
            contentType: contentType ?? 'page',
            cloudID: cloudID ?? prevState.cloudID
        }));
};
const $6f93404dd586c0f7$export$d1dd051dd158cf2a = ()=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isHerActive: false,
            contentId: null,
            contentType: 'page',
            textPreview: ''
        }));
};
const $6f93404dd586c0f7$export$daffe9b53f21fd39 = (expanded)=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isExpanded: expanded
        }));
};
const $6f93404dd586c0f7$export$3a38c3c547ba462b = (animating)=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isAnimating: animating
        }));
};
const $6f93404dd586c0f7$export$52a0cc4030ebe376 = (text)=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            textPreview: prevState.textPreview + text
        }));
};
const $6f93404dd586c0f7$export$cd85393335c99d14 = ()=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            textPreview: ''
        }));
};
module.exports["herState"] = $6f93404dd586c0f7$export$b1d93e626697721f;
module.exports["toggleHer"] = $6f93404dd586c0f7$export$780673425ffb59a7;
module.exports["openHer"] = $6f93404dd586c0f7$export$cc30aca21148df52;
module.exports["closeHer"] = $6f93404dd586c0f7$export$d1dd051dd158cf2a;
module.exports["setExpanded"] = $6f93404dd586c0f7$export$daffe9b53f21fd39;
module.exports["setAnimating"] = $6f93404dd586c0f7$export$3a38c3c547ba462b;
module.exports["appendTextPreview"] = $6f93404dd586c0f7$export$52a0cc4030ebe376;
module.exports["clearTextPreview"] = $6f93404dd586c0f7$export$cd85393335c99d14;

});

parcelRegister("4ZXww", function(module, exports) {
const $6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $6699361aa30cfc48$export$461ea60ca403d592 = {
    MORE_ACTIONS_ITEMS: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}more-actions-items`,
    OBJECT_SIDEBAR_CONTROL: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}object-sidebar-control`,
    SIDEBAR_DETAILS_BUTTON: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
module.exports["OBJECT_SIDEBAR_TOUR_TARGETS"] = $6699361aa30cfc48$export$461ea60ca403d592;

});

parcelRegister("k7UhM", function(module, exports) {

let $ea701f4cea092b19$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ea701f4cea092b19$var$load("6wr18"),
    $ea701f4cea092b19$var$load("ffEVr"),
    $ea701f4cea092b19$var$load("1jVx9")
]).then(()=>parcelRequire('3D12W'));

});

parcelRegister("9Ima4", function(module, exports) {

let $712969ee490642ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $712969ee490642ea$var$load("k3amn").then(()=>parcelRequire('5A18u'));

});

parcelRegister("7rWz7", function(module, exports) {

let $56c87be7be078a90$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $56c87be7be078a90$var$load("1dIEH").then(()=>parcelRequire('1hCz7'));

});

parcelRegister("7K4N2", function(module, exports) {

let $5a308b7718b214de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5a308b7718b214de$var$load("6wr18"),
    $5a308b7718b214de$var$load("ffEVr"),
    $5a308b7718b214de$var$load("lX2ZR")
]).then(()=>parcelRequire('bl7WT'));

});

parcelRegister("3abxA", function(module, exports) {

let $24db420245279b37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $24db420245279b37$var$load("4wPZ7").then(()=>parcelRequire('eQF4d'));

});

parcelRegister("6HPDw", function(module, exports) {

let $4e1ed0214d2ddd70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e1ed0214d2ddd70$var$load("6wr18"),
    $4e1ed0214d2ddd70$var$load("ffEVr"),
    $4e1ed0214d2ddd70$var$load("3aT4s")
]).then(()=>parcelRequire('ce71E'));

});

parcelRegister("6hYoU", function(module, exports) {

let $49432eed888110e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $49432eed888110e4$var$load("fjSG8").then(()=>parcelRequire('gMGbk'));

});

parcelRegister("f9r3q", function(module, exports) {

let $b07caeae379b82ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b07caeae379b82ce$var$load("3R2Cd"),
    $b07caeae379b82ce$var$load("b7OPx"),
    $b07caeae379b82ce$var$load("31msE")
]).then(()=>parcelRequire('9POeP'));

});

parcelRegister("7mgQ0", function(module, exports) {

let $55b7a61ff96f40e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55b7a61ff96f40e0$var$load("KSMZE").then(()=>parcelRequire('jFrMf'));

});

parcelRegister("1KHQh", function(module, exports) {
// eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure

var $6mKj3 = parcelRequire("6mKj3");

const $47ca1d22622dd352$export$9aeee5d7687bf679 = ()=>{
    // eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
    const [expConfig] = (0, $6mKj3.UNSAFE_noExposureExp)('cfind_5565_creation_focused_nav_xflow'); // Experiment exposure is fired elsewhere
    const rawValue = expConfig.get('experimentStartDate', null);
    if (!rawValue) return null;
    const date = new Date(rawValue);
    return isNaN(date.getTime()) ? null : date;
};
module.exports["getXflowExperimentStartDate"] = $47ca1d22622dd352$export$9aeee5d7687bf679;

});

parcelRegister("6Dfc9", function(module, exports) {

var $8uR5k = parcelRequire("8uR5k");

var $cFEpk = parcelRequire("cFEpk");

var $da71s = parcelRequire("da71s");

function $e250b9cfd6dd2931$export$46cbbdfdd4d2fcb(isoTimestamp) {
    if (!isoTimestamp) return false;
    const parsed = (0, $da71s.default)(isoTimestamp);
    return (0, $cFEpk.default)(parsed) && (0, $8uR5k.default)(new Date(), parsed) < 24;
}
function $e250b9cfd6dd2931$export$193a557a4d23c9aa(epochMs) {
    const date = new Date(epochMs);
    return (0, $cFEpk.default)(date) && (0, $8uR5k.default)(new Date(), date) < 24;
}
module.exports["isWithinD0Window"] = $e250b9cfd6dd2931$export$46cbbdfdd4d2fcb;

});

parcelRegister("8uR5k", function(module, exports) {
$parcel$export(module.exports, "default", () => $62fa4da7b1bddd96$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $62fa4da7b1bddd96$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInHour);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("62guz", function(module, exports) {
$parcel$export(module.exports, "default", () => $464fb8f83176ac12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $464fb8f83176ac12$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $b5utg.default)(2, arguments);
    return (0, $egXhZ.default)(dateLeft).getTime() - (0, $egXhZ.default)(dateRight).getTime();
}

});

parcelRegister("fls5L", function(module, exports) {
var $b2be9bac2e487919$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $b2be9bac2e487919$var$defaultRoundingMethod = 'trunc';
function $b2be9bac2e487919$export$b6474a47258c1211(method) {
    return method ? $b2be9bac2e487919$var$roundingMap[method] : $b2be9bac2e487919$var$roundingMap[$b2be9bac2e487919$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $b2be9bac2e487919$export$b6474a47258c1211;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("41KFX", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");


var $6Dfc9 = parcelRequire("6Dfc9");


var $879OR = parcelRequire("879OR");

const $73d6907ec9f8e642$export$fce5991a3cbd7c5a = new Set([
    'default-templates',
    'pin-templates'
]);
const $73d6907ec9f8e642$var$DEFAULT_RESULT = {
    navStyle: 'control',
    isWithinD0: false,
    source: null
};
function $73d6907ec9f8e642$export$9e39472fc9788dd0() {
    if ((0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')) return [
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS),
        (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT
    ];
    return [
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS)
    ];
}
const $73d6907ec9f8e642$export$aed714501b2c585 = ()=>{
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)($73d6907ec9f8e642$export$9e39472fc9788dd0(), !(0, $9wGTI.fg)('cc_activation_simplify_nav_preloader_enabled'));
    const { isEligible: isEligibleForSimplifyNavXflow, isLoading: isLoadingIsEligibleForSimplifyNavXflow, hasError: hasEligibleForSimplifyNavXflowError, isWithinD0Window: isWithinD0WindowForSimplifyNavXflow } = (0, $879OR.useIsEligibleForSimplifyNavXflow)({
        onboardingStateData: onboardingStateData,
        onboardingStateLoading: onboardingStateLoading,
        onboardingStateError: onboardingStateError,
        skip: !(0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_eligibility')
    });
    if (onboardingStateLoading) {
        if ((0, $9wGTI.fg)('cc_activation_simplify_nav_preloader_enabled')) return {
            navStyle: 'loading',
            isWithinD0: false,
            source: null
        };
        return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    }
    if (onboardingStateError) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const entries = onboardingStateData?.onboardingState;
    if (!entries) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const eligibleEntry = entries.find((s)=>s.key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE);
    if (eligibleEntry?.value !== 'true') {
        // Not eligible for new user experiment, but might be for xflow.
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload') && (0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_eligibility')) {
            if (isLoadingIsEligibleForSimplifyNavXflow) // This may happen if TAP traits are loading, although they should generally be preloaded.
            // Case of onboarding state loading is handled in previous conditionals.
            return {
                navStyle: 'loading',
                isWithinD0: false,
                source: null
            };
            if (hasEligibleForSimplifyNavXflowError) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
            if (isEligibleForSimplifyNavXflow) {
                const navStyle = (0, $6mKj3.expVal)('cfind_5565_creation_focused_nav_xflow', 'cohort', 'control');
                if ($73d6907ec9f8e642$export$fce5991a3cbd7c5a.has(navStyle)) return {
                    navStyle: navStyle,
                    isWithinD0: isWithinD0WindowForSimplifyNavXflow,
                    source: 'xflow'
                };
            }
        }
        return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    }
    const navStyle = (0, $6mKj3.expVal)('cc_activation_simplify_nav_new_user', 'cohort', 'control');
    if (!$73d6907ec9f8e642$export$fce5991a3cbd7c5a.has(navStyle)) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const startAtEntry = entries.find((s)=>s.key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_START_AT);
    return {
        navStyle: navStyle,
        isWithinD0: (0, $6Dfc9.isWithinD0Window)(startAtEntry?.value),
        source: 'new-user'
    };
};
module.exports["TREATMENT_COHORTS"] = $73d6907ec9f8e642$export$fce5991a3cbd7c5a;
module.exports["useSimplifiedNavNewUsers"] = $73d6907ec9f8e642$export$aed714501b2c585;

});

parcelRegister("879OR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8uR5k = parcelRequire("8uR5k");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $f7MuR = parcelRequire("f7MuR");


var $kOUwv = parcelRequire("kOUwv");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");


var $1KHQh = parcelRequire("1KHQh");


var $6Dfc9 = parcelRequire("6Dfc9");

const $1f55678574e67c8a$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $1f55678574e67c8a$var$FIRST_ACTIVATION_DATE_TRAIT = 'firstActivationDate';
const $1f55678574e67c8a$export$bbe7d46982302b03 = ({ onboardingStateData: onboardingStateData, onboardingStateLoading: onboardingStateLoading, onboardingStateError: onboardingStateError, skip: skip })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    const { data: siteUserTraitsData, loading: siteUserTraitsLoading, error: siteUserTraitsError } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const { data: siteTraitsData, loading: siteTraitsDataLoading, error: siteTraitsDataError } = (0, $kOUwv.useSiteTraits)({
        skipBootstrap: skip
    });
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const entries = onboardingStateData?.onboardingState;
    const isInCfindLandCreationFocusedNavExperiment = !!entries?.find((s)=>s.key === (0, $dBcar.CREATION_FOCUSED_NAV_START_TIME))?.value;
    const isInActivationExperiment = entries?.find(({ key: key })=>key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE)?.value === 'true';
    const xflowStartAt = entries?.find(({ key: key })=>key === (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT)?.value;
    const isReturningEnrolledUser = !!xflowStartAt;
    const firstActiveTrait = siteUserTraitsData?.attributes?.find(({ name: name })=>name === $1f55678574e67c8a$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const siteActivationDateTrait = siteTraitsData?.attributes?.find(({ name: name })=>name === $1f55678574e67c8a$var$FIRST_ACTIVATION_DATE_TRAIT)?.value;
    let hoursSinceFirstActiveTrait, hoursSinceSiteActivationDate;
    try {
        hoursSinceFirstActiveTrait = firstActiveTrait ? (0, $8uR5k.default)(Date.now(), new Date(firstActiveTrait)) : -1;
        hoursSinceSiteActivationDate = siteActivationDateTrait ? (0, $8uR5k.default)(Date.now(), new Date(siteActivationDateTrait)) : -1;
    } catch  {
        hoursSinceFirstActiveTrait = -2;
        hoursSinceSiteActivationDate = -2;
    }
    const isLoading = !!(onboardingStateLoading || siteUserTraitsLoading || siteTraitsDataLoading);
    const hasError = !!(onboardingStateError || siteUserTraitsError || siteTraitsDataError);
    // A new user is eligible if their site's firstActivationDate is non-null and
    // after the experiment start date. Returning enrolled users are always eligible.
    const isSiteActivationAfterExperimentStart = ()=>{
        if (!siteActivationDateTrait) return false;
        const experimentStartDate = (0, $1KHQh.getXflowExperimentStartDate)();
        if (!experimentStartDate) return false;
        try {
            return new Date(siteActivationDateTrait) >= experimentStartDate;
        } catch  {
            return false;
        }
    };
    const isEligible = !skip && !isLoading && !hasError && hasLicensedAccess && !isInCfindLandCreationFocusedNavExperiment && !isInActivationExperiment && (isReturningEnrolledUser || isSiteActivationAfterExperimentStart());
    const hasWrittenStartAt = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (isEligible && !isReturningEnrolledUser && !hasWrittenStartAt.current && (0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')) {
            hasWrittenStartAt.current = true;
            setOnboardingState({
                key: (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT,
                value: new Date().toISOString()
            });
        }
    }, [
        isEligible,
        isReturningEnrolledUser,
        setOnboardingState
    ]);
    const hasFiredAnalytic = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!isLoading && !hasError && !isInCfindLandCreationFocusedNavExperiment && !isInActivationExperiment && !hasFiredAnalytic.current && !skip && hasLicensedAccess) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'eligible',
                    actionSubject: 'cfind-5565-simplify-nav-xflow',
                    actionSubjectId: 'cfind-5565-simplify-nav-xflow',
                    source: 'cfind-5565-simplify-nav-xflow',
                    attributes: {
                        firstActive: firstActiveTrait,
                        hoursSinceFirstActiveTrait: hoursSinceFirstActiveTrait,
                        siteActivationDate: siteActivationDateTrait,
                        hoursSinceSiteActivationDate: hoursSinceSiteActivationDate
                    }
                }
            }).fire();
            hasFiredAnalytic.current = true;
        }
    }, [
        createAnalyticsEvent,
        hasLicensedAccess,
        isLoading,
        isInCfindLandCreationFocusedNavExperiment,
        isInActivationExperiment,
        firstActiveTrait,
        hasError,
        hoursSinceFirstActiveTrait,
        hoursSinceSiteActivationDate,
        siteActivationDateTrait,
        skip
    ]);
    return {
        isLoading: isLoading,
        hasError: hasError,
        isEligible: isEligible,
        // For returning enrolled users, use their START_AT timestamp to determine if they're
        // within the D0 window. For first-time users (no START_AT yet), they're implicitly
        // within their D0 window if and only if they're eligible.
        isWithinD0Window: xflowStartAt ? (0, $6Dfc9.isWithinD0Window)(xflowStartAt) : isEligible
    };
};
module.exports["useIsEligibleForSimplifyNavXflow"] = $1f55678574e67c8a$export$bbe7d46982302b03;

});

parcelRegister("f7MuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $1P1Tu.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $9zUhf.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $9zUhf.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($26d702ce000cc6e9$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId || !userId) return;
        $26d702ce000cc6e9$var$hasFetched = true;
        storeActions.start();
        $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("kOUwv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $d684465712516a35$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $d684465712516a35$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $d684465712516a35$export$2d97e7bb018b0cfb = (0, $1P1Tu.createStore)({
    initialState: $d684465712516a35$var$initialState,
    actions: $d684465712516a35$var$actions,
    name: 'siteTraitsStore'
});
const $d684465712516a35$export$c84f691b170cbee3 = (0, $9zUhf.createHook)($d684465712516a35$export$2d97e7bb018b0cfb);
const $d684465712516a35$export$2aca02eeb1d46515 = (0, $9zUhf.createActionsHook)($d684465712516a35$export$2d97e7bb018b0cfb);
async function $d684465712516a35$var$fetchSiteTraitsData(cloudId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $d684465712516a35$var$hasFetched = false;
function $d684465712516a35$export$f1fbc6ad89f91b89() {
    $d684465712516a35$var$hasFetched = false;
}
function $d684465712516a35$var$getSiteTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.site);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.site);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $d684465712516a35$export$fcebe75065597a98({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$d684465712516a35$var$getSiteTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $d684465712516a35$export$c84f691b170cbee3();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($d684465712516a35$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId) return;
        $d684465712516a35$var$hasFetched = true;
        storeActions.start();
        $d684465712516a35$var$fetchSiteTraitsData(cloudId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteTraits"] = $d684465712516a35$export$fcebe75065597a98;

});

parcelRegister("5CUwy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cbc8g = parcelRequire("cbc8g");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");



var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default)
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $cbc8g.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $1P1Tu.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $9zUhf.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $9zUhf.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserPermissionStatus"] = $9633e2f0bea217d1$export$85de6c803181afa9;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<7bddefba16e0e3fb2655c6e8a82785c2>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
            "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "21c387cdafea215b61e4183319580a69";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<ce6a8bce73876f32a04d2f7fd2550f0b>>
 * @relayHash 255e1eee858b61b7fb061e8b9eb8fbc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceLoomEntryPoints",
            "kind": "LinkedField",
            "name": "confluence_loomEntryPoints",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLoomEntryPointsEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "255e1eee858b61b7fb061e8b9eb8fbc9",
            "id": "52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "767e6480b08dd1cf6643fe7ca065c357";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("8G3G6", function(module, exports) {
/**
 * @generated SignedSource<<4efd7d9e8d315675bb805e09816dec16>>
 * @relayHash 4454a52ea4ab532f76ee4e80586f3a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87
const $3a0ab9c788e793cd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4454a52ea4ab532f76ee4e80586f3a56",
            "id": "1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87",
            "metadata": {},
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonCatchupLastViewedTimeQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$3a0ab9c788e793cd$var$node.hash = "4580906c8b823122d6a7f5ad8c2e2c6c";
var $3a0ab9c788e793cd$export$2e2bcd8739ae039 = $3a0ab9c788e793cd$var$node;
module.exports["default"] = $3a0ab9c788e793cd$export$2e2bcd8739ae039;

});

parcelRegister("aXjWU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $6d6c82fa2f331bd2$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $6d6c82fa2f331bd2$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6d6c82fa2f331bd2$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialActiveTriggerState);
const $6d6c82fa2f331bd2$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialTriggerDispatchState);
const $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $42omo.useState)($6d6c82fa2f331bd2$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $42omo.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $42omo.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $42omo.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $6d6c82fa2f331bd2$export$454c1d7c35958f5e = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
const $6d6c82fa2f331bd2$export$23cbf084e08bdb93 = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
const $6d6c82fa2f331bd2$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $6d6c82fa2f331bd2$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    const fireTrigger = (0, $42omo.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $6d6c82fa2f331bd2$export$e45375ff75169f = (messageId)=>{
    const enableEpExternalMessageCleanup = (0, $dh538.fg)('post-office_enable-ep-external-message-cleanup');
    const { activeTriggerState: { activeTriggerId: activeTriggerId } } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    const hasMessageAlreadyStarted = enableEpExternalMessageCleanup && activeTriggerId?.endsWith('-started');
    // listeners
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $42omo.useCallback)(()=>{
        if (hasMessageAlreadyStarted) return;
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger,
        hasMessageAlreadyStarted
    ]);
    const dismissMessage = (0, $42omo.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $42omo.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $6d6c82fa2f331bd2$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $6d6c82fa2f331bd2$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $6d6c82fa2f331bd2$export$e45375ff75169f;

});

parcelRegister("fVTNs", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e7URT = parcelRequire("e7URT");


var $1j3sF = parcelRequire("1j3sF");


var $bYRk6 = parcelRequire("bYRk6");

const $c32683c3f1554789$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))));
};
const $c32683c3f1554789$export$34282a1f95511a11 = (props)=>{
    const data = $c32683c3f1554789$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: data,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: props.children
        })
    });
};
module.exports["ContextWrapper"] = $c32683c3f1554789$export$34282a1f95511a11;

});

parcelRegister("7tXrp", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $d9tcB = parcelRequire("d9tcB");

const $f4962613d517e76c$var$FREE_TOUCHPOINTS = {
    pageInsights: {
        requestedEdition: 'standard',
        requestedFeature: 'pageInsights'
    },
    archiveUpsellDialog: {
        requestedEdition: 'standard',
        requestedFeature: 'archive'
    },
    generalAccessLevelSelector: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    shareAndRestrictDialogUpsell: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    quickSummaryUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'rovo'
    },
    teamCalendarUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'calendars'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    }
};
// When cleaning up twcg-1169_ceurs2p_createspacedrawer_fix add in createSpaceDrawer
const $f4962613d517e76c$var$STANDARD_TOUCHPOINTS = {
    viewSpacePerms: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    },
    contentManagerUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'contentManager'
    },
    adminCenter: {
        requestedEdition: 'premium',
        requestedFeature: 'adminCenter'
    },
    userAccessUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    shareAndRestrictDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    restrictionsDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    companyHubUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'companyHub'
    },
    premiumCardsInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCardsConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    whiteboardsUpsellCtaScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboardInsert'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    'whiteboardCreationPaywall-unsetDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    'whiteboardCreationPaywall-viewOnlyButton': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    }
};
// When cleaning up twcg-1169_ceurs2p_createspacedrawer_fix this can be removed and createSpaceDrawer added to STANDARD_TOUCHPOINTS
const $f4962613d517e76c$var$STANDARD_TOUCHPOINTS_WITH_CREATE_SPACE_DRAWER = {
    ...$f4962613d517e76c$var$STANDARD_TOUCHPOINTS,
    createSpaceDrawer: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    }
};
const $f4962613d517e76c$export$354adb22437506d7 = (source, edition)=>{
    switch(edition){
        case (0, $d9tcB.ConfluenceEdition).FREE:
            return $f4962613d517e76c$var$FREE_TOUCHPOINTS[source];
        case (0, $d9tcB.ConfluenceEdition).STANDARD:
            return (0, $9wGTI.fg)('twcg-1169_ceurs2p_createspacedrawer_fix') ? $f4962613d517e76c$var$STANDARD_TOUCHPOINTS_WITH_CREATE_SPACE_DRAWER[source] : $f4962613d517e76c$var$STANDARD_TOUCHPOINTS[source];
        default:
            return undefined;
    }
};
module.exports["getEligibleTouchpointForEdition"] = $f4962613d517e76c$export$354adb22437506d7;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $frIzR.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("2O3ot", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $abb9e481ac8f38e8$var$initialState = {
    messageIdSelectedForPreview: null,
    invocationIdSelectedForPreview: null,
    stagingAreaMode: undefined,
    stagingAreaEntryPoint: '',
    prompt: '',
    dynamicUiType: undefined,
    dynamicUiSource: undefined,
    isRemixUpdating: false,
    forceSkipAutoConversationSelection: false,
    currentDisplayMessageId: undefined
};
const $abb9e481ac8f38e8$var$actions = {
    setMessageIdSelectedForPreview: (messageId)=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: messageId
            });
        },
    getMessageIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().messageIdSelectedForPreview;
        },
    setStagingAreaMode: (mode, entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaMode: mode,
                stagingAreaEntryPoint: entryPoint
            });
        },
    setPrompt: (prompt)=>({ setState: setState })=>{
            setState({
                prompt: prompt
            });
        },
    setInvocationIdSelectedForPreview: (invocationId)=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId
            });
        },
    getInvocationIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().invocationIdSelectedForPreview;
        },
    setIsRemixUpdating: (isUpdating)=>({ setState: setState })=>{
            setState({
                isRemixUpdating: isUpdating
            });
        },
    setDynamicUiContext: (dynamicUiType, dynamicUiSource)=>({ setState: setState })=>{
            setState({
                dynamicUiType: dynamicUiType,
                dynamicUiSource: dynamicUiSource
            });
        },
    resetStagingArea: ()=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: null,
                invocationIdSelectedForPreview: null,
                isRemixUpdating: false,
                stagingAreaMode: undefined,
                stagingAreaEntryPoint: undefined,
                dynamicUiType: undefined,
                dynamicUiSource: undefined,
                forceSkipAutoConversationSelection: false,
                currentDisplayMessageId: undefined
            });
        },
    setForceSkipAutoConversationSelection: (forceSkip)=>({ setState: setState })=>{
            setState({
                forceSkipAutoConversationSelection: forceSkip
            });
        },
    setCurrentDisplayMessageId: (messageId)=>({ setState: setState })=>{
            setState({
                currentDisplayMessageId: messageId
            });
        }
};
const $abb9e481ac8f38e8$var$store = (0, $1P1Tu.createStore)({
    initialState: $abb9e481ac8f38e8$var$initialState,
    actions: $abb9e481ac8f38e8$var$actions
});
const $abb9e481ac8f38e8$export$a2795b51ce92008f = (0, $9zUhf.createHook)($abb9e481ac8f38e8$var$store, {
    selector: (state)=>state.messageIdSelectedForPreview
});
const $abb9e481ac8f38e8$export$916334da9df8d04 = (0, $9zUhf.createHook)($abb9e481ac8f38e8$var$store);
const $abb9e481ac8f38e8$export$8f9a13b17bec42d5 = (0, $9zUhf.createActionsHook)($abb9e481ac8f38e8$var$store);
const $abb9e481ac8f38e8$export$5a57f796673aabea = (0, $9zUhf.createStateHook)($abb9e481ac8f38e8$var$store);
module.exports["useMessageIdSelectedForPreview"] = $abb9e481ac8f38e8$export$a2795b51ce92008f;
module.exports["useStagingArea"] = $abb9e481ac8f38e8$export$916334da9df8d04;
module.exports["useStagingAreaActions"] = $abb9e481ac8f38e8$export$8f9a13b17bec42d5;
module.exports["useStagingAreaState"] = $abb9e481ac8f38e8$export$5a57f796673aabea;

});

parcelRegister("9cZ1w", function(module, exports) {

var $epLE5 = parcelRequire("epLE5");


const $486bada329940e5a$export$f6e059b56d9aeb26 = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("cV6Ij"))).showCreateWithRovoModalCloseFeedbackFlagThunk);
module.exports["useLazyShowFeedbackFlag"] = $486bada329940e5a$export$f6e059b56d9aeb26;

});

parcelRegister("epLE5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $42omo.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("cV6Ij", function(module, exports) {

let $9680041a11bd85cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9680041a11bd85cb$var$load("hhBQG"),
    $9680041a11bd85cb$var$load("6GYDO"),
    $9680041a11bd85cb$var$load("hhss7"),
    $9680041a11bd85cb$var$load("cyGuT"),
    $9680041a11bd85cb$var$load("k7MRD")
]).then(()=>parcelRequire('hlCkz'));

});

parcelRegister("aMqwg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9d4cc27d6faf7a6e$var$rovoEntitlementStore = (0, $1P1Tu.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $9d4cc27d6faf7a6e$var$useStateHook = (0, $9zUhf.createStateHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$66d5dd4be64dea43 = ()=>{
    const result = $9d4cc27d6faf7a6e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $9d4cc27d6faf7a6e$export$8004893135276275 = (0, $9zUhf.createActionsHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $9d4cc27d6faf7a6e$export$8004893135276275();
    (0, $42omo.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $9d4cc27d6faf7a6e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $9d4cc27d6faf7a6e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $9d4cc27d6faf7a6e$export$d03a05ad8547472c;

});

parcelRegister("9eLw5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $9zUhf = parcelRequire("9zUhf");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");


var $flpNp = parcelRequire("flpNp");

const $2c362c1c58e43242$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        cache: {}
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            }
    }
});
const $2c362c1c58e43242$var$selector = (0, $cclHy.createSelector)((state)=>state.cache, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
	 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
	 * and it will determine whether to rerender the component
	 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
	 *
	 * e.g. for `enabled` true condition:
	 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
	 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
	 *
	 * To test this, run the unit test, and then force this function to return new stuff on every call
	 * e.g. `return { ...result, random: Math.random() };`
	 * it will result in increase renderCount in the unit test
	 */ (cache, key, initialQueryEnabled)=>cache[key] ?? {
        data: null,
        error: null,
        isFetching: initialQueryEnabled
    });
const $2c362c1c58e43242$var$useCacheEntry = (0, $9zUhf.createHook)($2c362c1c58e43242$var$store, {
    selector: $2c362c1c58e43242$var$selector
});
const $2c362c1c58e43242$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $42omo.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $42omo.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $42omo.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $2c362c1c58e43242$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            updateCacheEntry(queryKey, {
                data: response,
                error: null
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $flpNp.mapErrorToApiError)(error);
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    const updateCache = (0, $42omo.useCallback)((data)=>{
        updateCacheEntry(queryKey, {
            data: data
        });
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $42omo.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $fFa3V.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData,
        updateCache: updateCache
    };
};
module.exports["useQuery"] = $2c362c1c58e43242$export$dd0a697e1782aedd;

});

parcelRegister("jO3S6", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


const $5eff64246cff89b2$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("23ga2"))); /**
             * @deprecated please use LazyAnimatedRovoIcon from @atlassian/rovo-platform-ui-components/primitives/rovo-animated-icon/LazyAnimatedRovoIcon instead
             */ 
const $5eff64246cff89b2$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($5eff64246cff89b2$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        })
    });
});
module.exports["LazyAnimatedRovoIcon"] = $5eff64246cff89b2$export$7ea4e54699cd5224;

});

parcelRegister("23ga2", function(module, exports) {

let $17e865d2382724b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17e865d2382724b6$var$load("frhR0").then(()=>parcelRequire('5O8EX'));

});

parcelRegister("i08Mr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $e459ef83dafb04f4$var$initialState = {
    fullScreen: false,
    externalEmbed: false,
    customHandlers: {
        handleDeepLinkClick: undefined,
        handleSubmitSmartCreate: ()=>{}
    },
    isBitbucketBetaEnabled: false,
    customFeedbackCategories: undefined,
    stagingAreaRef: undefined,
    promptInputDroppableUrls: undefined,
    enableBrowserContextBanner: false,
    browserContextSanitizer: undefined,
    elements: {
        closeButton: true,
        newChatButton: true,
        fullscreenButton: true,
        createAgentButton: true,
        browseAgentsButton: true,
        agentsMenu: true,
        navbar: true,
        mainChatHeader: true,
        stagingAreaEnabled: false,
        voiceDictationButton: false,
        fileUploadButton: true,
        chatModeMenuButton: true
    }
};
const $e459ef83dafb04f4$export$ab340e857ee89c62 = $e459ef83dafb04f4$var$initialState;
const $e459ef83dafb04f4$var$uiConfig = /*#__PURE__*/ (0, $42omo.createContext)($e459ef83dafb04f4$var$initialState);
const $e459ef83dafb04f4$export$3063519296e335bf = $e459ef83dafb04f4$var$uiConfig.Provider;
const $e459ef83dafb04f4$export$e83755c3ab7a4493 = ()=>(0, $42omo.useContext)($e459ef83dafb04f4$var$uiConfig);
const $e459ef83dafb04f4$export$3e623b13d2da727a = (config)=>{
    // Allow fullscreen override for branch deploy testing purposes
    const processedConfig = localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && (0, $dh538.fg)('rovo_chat_show_local_frontend_components') ? {
        ...config,
        fullScreen: true
    } : config;
    return {
        ...{
            ...$e459ef83dafb04f4$var$initialState,
            ...processedConfig,
            enableBrowserContextBanner: processedConfig?.enableBrowserContextBanner ?? $e459ef83dafb04f4$var$initialState.enableBrowserContextBanner,
            browserContextSanitizer: processedConfig?.browserContextSanitizer,
            elements: {
                ...$e459ef83dafb04f4$var$initialState.elements,
                ...processedConfig?.elements
            },
            promptInputDroppableUrls: processedConfig?.promptInputDroppableUrls
        }
    };
};
module.exports["UIConfigProvider"] = $e459ef83dafb04f4$export$3063519296e335bf;
module.exports["useUIConfig"] = $e459ef83dafb04f4$export$e83755c3ab7a4493;
module.exports["createUIConfig"] = $e459ef83dafb04f4$export$3e623b13d2da727a;

});

parcelRegister("lHQAj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4WmbV = parcelRequire("4WmbV");

const $5558feba06e8dbf9$export$60332b2344f7fe41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            ...props,
            withTasteAndToneStyling: true,
            buttonGroupAlignment: "right"
        }));
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true,
        buttonGroupAlignment: "right"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardLayout = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardSectionMessageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardContentsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ])
    });
});
$5558feba06e8dbf9$var$CardContentsContainer.displayName = 'CardContentsContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardWithBorderAndBox = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$export$8a23e74e5cf3ca41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
module.exports["Card"] = $5558feba06e8dbf9$export$60332b2344f7fe41;
module.exports["CardContainer"] = $5558feba06e8dbf9$export$8a23e74e5cf3ca41;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("2pBiX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");

const $e5ba90f4b97bd7c1$var$i18n = (0, $aXWIB.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    }
});
const $e5ba90f4b97bd7c1$export$b8f10a3122c10d73 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { flags: flags } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== flags || $[1] !== intl) {
        t1 = ()=>{
            flags.showInfoFlag({
                title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
                description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
            });
        };
        $[0] = flags;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ flags: flags })=>{
    const intl = (0, $aXWIB.useIntl)();
    return (0, $42omo.useCallback)(()=>{
        flags.showInfoFlag({
            title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
            description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
        });
    }, [
        flags,
        intl
    ]);
};
module.exports["useLoomEntryPointErrorCallback"] = $e5ba90f4b97bd7c1$export$b8f10a3122c10d73;

});

parcelRegister("cAdj8", function(module, exports) {

var $69Jl3 = parcelRequire("69Jl3");


var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $1uFM6 = parcelRequire("1uFM6");


var $flE5X = parcelRequire("flE5X");


var $jMyy4 = parcelRequire("jMyy4");

const $a1394411ec7881e4$var$usePageInfoPageInfoQuery = (0, $69Jl3.default);
const $a1394411ec7881e4$export$e1b9843c9a40eb2 = {
    id: '',
    type: '',
    status: '',
    space: {
        id: '',
        operations: []
    },
    operations: [],
    version: {
        number: -1
    }
};
const $a1394411ec7881e4$export$7b2dac1793a2824 = ({ fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted, onError: onError } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($a1394411ec7881e4$var$usePageInfoPageInfoQuery, {
        variables: {
            pageId: contentId
        },
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
    });
    return (0, $42omo.useMemo)(()=>{
        // Handle error case first
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || error instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
            return {
                pageInfo: null,
                loading: false,
                error: error,
                refetch: null
            };
        }
        // If we have data, use it even during loading
        if (data) {
            const pageInfoNode = data.content?.nodes?.[0] ?? null;
            if (pageInfoNode) return {
                pageInfo: pageInfoNode,
                loading: loading,
                error: undefined,
                refetch: refetch
            };
            return {
                pageInfo: {
                    ...$a1394411ec7881e4$export$e1b9843c9a40eb2
                },
                loading: loading,
                error: undefined,
                refetch: refetch
            };
        }
        // Only return null pageInfo if we have no data at all
        return {
            pageInfo: null,
            loading: loading,
            error: undefined,
            refetch: null
        };
    }, [
        data,
        loading,
        error,
        onError,
        refetch
    ]);
};
module.exports["usePageInfo"] = $a1394411ec7881e4$export$7b2dac1793a2824;

});

parcelRegister("69Jl3", function(module, exports) {
/**
 * @generated SignedSource<<acb8ba2772f142dd719427fed7f658a6>>
 * @relayHash ece963db192ceabc724d67f753bee503
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4
const $c7d0a8215908754e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "archived",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ece963db192ceabc724d67f753bee503",
            "id": "2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4",
            "metadata": {},
            "name": "usePageInfoPageInfoQuery",
            "operationKind": "query",
            "text": "query usePageInfoPageInfoQuery($pageId:ID){content(id:$pageId,status:[\"current\",\"archived\",\"draft\"]){nodes{id,type,status,space{id,operations{operation,targetType}},operations{operation,targetType},version{number}}}}"
        }
    };
}();
$c7d0a8215908754e$var$node.hash = "a5580c0bc26236652ac23ad7c3f4bf51";
var $c7d0a8215908754e$export$2e2bcd8739ae039 = $c7d0a8215908754e$var$node;
module.exports["default"] = $c7d0a8215908754e$export$2e2bcd8739ae039;

});

parcelRegister("d3UlG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5NXxU = parcelRequire("5NXxU");


var $iIEgX = parcelRequire("iIEgX");

var $6yCLg = parcelRequire("6yCLg");


var $cPtvM = parcelRequire("cPtvM");


var $kAaxz = parcelRequire("kAaxz");

function $d7c3e272b37735b1$export$d6e2ae1e990d7e71(request, config, onStateChange) {
    const refetchId = (0, $42omo.useRef)(crypto.randomUUID());
    const [state, setState] = (0, $6yCLg.useStatefulObservableEffect)((0, $cPtvM.convoAIStreamingEffect), (0, $kAaxz.getDefaultConvoAIStreamingState)(), [
        request,
        config,
        refetchId.current
    ]);
    (0, $iIEgX.useObservableEffect)((input$)=>input$.pipe((0, $5NXxU.tap)(([nextState, onStateChangeCalback])=>onStateChangeCalback?.(nextState))), [
        state,
        onStateChange
    ]);
    const refetch = (0, $42omo.useCallback)(()=>{
        refetchId.current = crypto.randomUUID();
        setState({
            inputs: [
                request,
                config,
                refetchId.current
            ],
            state: (0, $kAaxz.getDefaultConvoAIStreamingState)()
        });
    }, [
        request,
        config,
        setState
    ]);
    return [
        state,
        refetch
    ];
}
module.exports["useConvoAIStreaming"] = $d7c3e272b37735b1$export$d6e2ae1e990d7e71;

});

parcelRegister("6yCLg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXpOY = parcelRequire("aXpOY");

function $725c584c19c66c44$export$916f6bbdfa1987d0(onObservableInit, initialState, inputs) {
    const [state, callback] = (0, $aXpOY.useStatefulObservableLazyEffect)(onObservableInit, initialState);
    (0, $42omo.useEffect)(()=>{
        callback({
            inputs: inputs,
            state: initialState
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return [
        state,
        callback
    ];
}
module.exports["useStatefulObservableEffect"] = $725c584c19c66c44$export$916f6bbdfa1987d0;

});

parcelRegister("dchHi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bQm3c = parcelRequire("bQm3c");

const $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $e12d220a6c6e853e$export$5b0d1a23cf38988 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $e12d220a6c6e853e$export$eecedbc46bd36460 = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { displayName: sessionDisplayName, userId: sessionUserId } = (0, $bQm3c.useSessionData)();
    const { locale: intlLocale } = (0, $aXWIB.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $42omo.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId || sessionUserId || undefined,
            displayName: displayName || sessionDisplayName || undefined
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        sessionUserId,
        displayName,
        sessionDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e12d220a6c6e853e$export$5b0d1a23cf38988.Provider, {
        value: contextValue
    }, children);
};
const $e12d220a6c6e853e$export$e8f7cf9dc2b23528 = ()=>{
    const context = (0, $42omo.useContext)($e12d220a6c6e853e$export$5b0d1a23cf38988);
    if (context === undefined) throw new Error('useFeedbackCollectorProperties must be used within a FeedbackCollectorPropertiesProvider');
    return context;
};
module.exports["FeedbackCollectorPropertiesProvider"] = $e12d220a6c6e853e$export$eecedbc46bd36460;
module.exports["useFeedbackCollectorProperties"] = $e12d220a6c6e853e$export$e8f7cf9dc2b23528;

});

parcelRegister("dOOm2", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $7hpmn = parcelRequire("7hpmn");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f64c374ed616824e$var$GradientPropertyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _kqswh2mm _c71l1kw7",
            __cmplp.className
        ])
    });
});
const $f64c374ed616824e$var$outerContainerStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    position: 'relative',
    background: `conic-gradient(
    from var(--gradient-angle, 45deg),
    #0065FF 10%,
    #0469FF 30%,
    #BF63F3 50%,
    #FFA900 70%,
    #0065FF 90%
  )`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...(0, $7hpmn.reduceMotionAsPerUserPreference),
    maxHeight: 'inherit'
});
const $f64c374ed616824e$var$animationStyles = (0, $ecnYn.xcss)({
    animation: 'rotationAnimation linear 2s infinite'
});
const $f64c374ed616824e$var$baseGlowStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    filter: 'blur(25px)',
    opacity: '0.5',
    height: '100%',
    width: '100%'
});
const $f64c374ed616824e$var$defaultBorderRadiusStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.large'
});
const $f64c374ed616824e$var$modalBorderRadiusStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small'
});
const $f64c374ed616824e$var$innerContainerStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    maxHeight: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    backgroundClip: 'content-box'
});
const $f64c374ed616824e$export$6ed1e39f4dbe0bbf = ({ loading: loading = false, children: children, useModalStyles: useModalStyles, hideGlow: hideGlow, customInnerContainerStyles: customInnerContainerStyles, customGlowStyles: customGlowStyles, ...props })=>{
    const isReducedMotion = (0, $7hpmn.useIsReducedMotion)();
    const shouldRotate = loading && !isReducedMotion;
    const containerStyles = shouldRotate ? [
        $f64c374ed616824e$var$outerContainerStyles,
        $f64c374ed616824e$var$animationStyles
    ] : [
        $f64c374ed616824e$var$outerContainerStyles
    ];
    const glowStyles = customGlowStyles ? [
        $f64c374ed616824e$var$baseGlowStyles,
        customGlowStyles
    ] : [
        $f64c374ed616824e$var$baseGlowStyles
    ];
    const borderRadiusStyles = useModalStyles ? $f64c374ed616824e$var$modalBorderRadiusStyles : $f64c374ed616824e$var$defaultBorderRadiusStyles;
    return /*#__PURE__*/ (0, $l998X.jsxs)($f64c374ed616824e$var$GradientPropertyContainer, {
        "data-testid": "ai-border-container",
        ...props,
        children: [
            shouldRotate && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    ...containerStyles,
                    borderRadiusStyles,
                    ...hideGlow ? [] : glowStyles
                ],
                testId: "loading-glow"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    ...containerStyles,
                    borderRadiusStyles
                ],
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    padding: "space.025",
                    xcss: [
                        $f64c374ed616824e$var$innerContainerStyles,
                        borderRadiusStyles,
                        customInnerContainerStyles
                    ],
                    children: children
                })
            })
        ]
    });
};
module.exports["AIBorder"] = $f64c374ed616824e$export$6ed1e39f4dbe0bbf;

});

parcelRegister("fNJG8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c02a973e1b80a41efb48b80326ffc315>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b80edd69ce46ac6c$var$_react = $b80edd69ce46ac6c$var$_interopRequireDefault((parcelRequire("42omo")));

var $b80edd69ce46ac6c$var$_baseNew = $b80edd69ce46ac6c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b80edd69ce46ac6c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b80edd69ce46ac6c$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $b80edd69ce46ac6c$var$_react.default.createElement($b80edd69ce46ac6c$var$_baseNew.default, Object.assign({
        name: "CloudArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$b80edd69ce46ac6c$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $b80edd69ce46ac6c$var$_default = module.exports.default = $b80edd69ce46ac6c$var$CloudArrowUpIcon;

});

parcelRegister("8jTDW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17e542faf6fbe5ebc711b672478100d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60eb42a7b08ac844$var$_react = $60eb42a7b08ac844$var$_interopRequireDefault((parcelRequire("42omo")));

var $60eb42a7b08ac844$var$_baseNew = $60eb42a7b08ac844$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $60eb42a7b08ac844$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudOffline".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for showing when a connection can't be established to the cloud.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60eb42a7b08ac844$var$CloudOfflineIcon = (props)=>/*#__PURE__*/ $60eb42a7b08ac844$var$_react.default.createElement($60eb42a7b08ac844$var$_baseNew.default, Object.assign({
        name: "CloudOfflineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zM8.82 12l1.5 1.5H3.75a3.75 3.75 0 0 1-1.42-7.22q.06-.32.14-.62l1.29 1.28a.75.75 0 0 1-.56.63A2.25 2.25 0 0 0 3.75 12zM8 1.5c-.96 0-1.87.24-2.66.65l1.13 1.13a4.25 4.25 0 0 1 5.72 3.23.75.75 0 0 0 .53.59 2.5 2.5 0 0 1 1.36 3.79l1.07 1.07a4 4 0 0 0-1.58-6.15A5.75 5.75 0 0 0 8 1.5"/>`
    }, props));
$60eb42a7b08ac844$var$CloudOfflineIcon.displayName = 'CloudOfflineIcon';
var $60eb42a7b08ac844$var$_default = module.exports.default = $60eb42a7b08ac844$var$CloudOfflineIcon;

});

parcelRegister("aYZaZ", function(module, exports) {
$parcel$export(module.exports, "Buttons", () => (parcelRequire("iQb1R")).Buttons);

var $jmjWc = parcelRequire("jmjWc");


var $6tSjb = parcelRequire("6tSjb");


var $iQb1R = parcelRequire("iQb1R");


const $ecc7cc41466863e8$export$82d507aca0e648e3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZRz6B",
    name: "EllipsisDropdownComponent",
    loader: async ()=>(await (parcelRequire("1r4vl"))).EllipsisDropdownComponent,
    loading: (0, $6tSjb.EllipsisPlaceholder)
});
module.exports["EllipsisDropdownComponent"] = $ecc7cc41466863e8$export$82d507aca0e648e3;

});

parcelRegister("6tSjb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $4KS7f = parcelRequire("4KS7f");


var $9VJDA = parcelRequire("9VJDA");

const $565f8db62106cdff$var$i18n = (0, $aXWIB.defineMessages)({
    more: {
        id: "editor-ellipsis-dropdown.placeholder.ellipsis.more",
        defaultMessage: "More"
    }
});
const $565f8db62106cdff$export$2edf2f3658d4e349 = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const label = intl.formatMessage($565f8db62106cdff$var$i18n.more);
    const moreIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        color: "currentColor",
        spacing: "spacious",
        label: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        testId: "ellipsis-placeholder",
        isDisabled: true,
        iconBefore: moreIcon,
        appearance: "subtle"
    });
};
module.exports["EllipsisPlaceholder"] = $565f8db62106cdff$export$2edf2f3658d4e349;

});

parcelRegister("1r4vl", function(module, exports) {

let $10bbce98e45bc65d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $10bbce98e45bc65d$var$load("9GDly"),
    $10bbce98e45bc65d$var$load("6wr18"),
    $10bbce98e45bc65d$var$load("ffEVr"),
    $10bbce98e45bc65d$var$load("lUs3J"),
    $10bbce98e45bc65d$var$load("Wowvf"),
    $10bbce98e45bc65d$var$load("iY5MP")
]).then(()=>parcelRequire('3d2EW'));

});

parcelRegister("iQb1R", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $f15550a75cff81e6$export$665d5a662b7213f3 = /*#__PURE__*/ function(Buttons) {
    Buttons["DELETE_DRAFT"] = "delete-draft";
    Buttons["EDIT_LABELS"] = "edit-labels";
    Buttons["MOVE_PAGE"] = "move-page";
    Buttons["PREVIEW"] = "preview";
    Buttons["PUBLISH_WITHOUT_NOTIFY"] = "publish-without-notify";
    Buttons["RESOLVED_COMMENTS"] = "resolved-comments";
    Buttons["TEMPLATE_BROWSER"] = "template-browser";
    Buttons["VIEW_CHANGES"] = "view-changes";
    Buttons["EXPORT"] = "export";
    Buttons["ADVANCED"] = "advanced";
    Buttons["ARCHIVE"] = "archive";
    Buttons["ATTACHMENTS"] = "attachments";
    Buttons["SWITCH_TO_LIVE_EDIT"] = "switch-to-live-edit";
    Buttons["CLASSIFY_CONTENT"] = "classify-content";
    Buttons["MANAGE"] = "manage";
    Buttons["PRESENT"] = "presentation-mode";
    return Buttons;
}({});
module.exports["Buttons"] = $f15550a75cff81e6$export$665d5a662b7213f3;

});

parcelRegister("70LTe", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $da99c994e33d3600$export$6654a9a4dc3a2802 = ()=>{
    return (0, $42omo.useCallback)((payload, type)=>{
        window.parent.postMessage({
            type: type,
            payload: payload
        }, '*');
    }, []);
};
module.exports["useEmbeddedConfluenceEventMarkers"] = $da99c994e33d3600$export$6654a9a4dc3a2802;

});

parcelRegister("cVfpT", function(module, exports) {
$parcel$export(module.exports, "PAGE_MODE", () => (parcelRequire("fuYhW")).PAGE_MODE);

var $jmjWc = parcelRequire("jmjWc");


var $h5hpR = parcelRequire("h5hpR");


var $fuYhW = parcelRequire("fuYhW");


const $77a17cdb2708e975$export$9d30156e45c09e81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qHKXp",
    name: "CopyLinkButtonLoader",
    loader: async ()=>{
        return (await (parcelRequire("Ss9SD"))).CopyLink;
    },
    loading: (0, $h5hpR.CopyLinkButtonPlaceholder)
});
module.exports["CopyLinkButtonLoader"] = $77a17cdb2708e975$export$9d30156e45c09e81;

});

parcelRegister("h5hpR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1bY7o = parcelRequire("1bY7o");


var $eEA8O = parcelRequire("eEA8O");

const $585272eb5e339a55$var$i18n = (0, $aXWIB.defineMessages)({
    copyLinkLabel: {
        id: "share.copylink.icon.label",
        defaultMessage: "Copy link"
    }
});
const $585272eb5e339a55$export$1f3200a5b8d4d8e1 = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "copy-link-button-placeholder",
        "data-test-id": "copy-link-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: intl.formatMessage($585272eb5e339a55$var$i18n.copyLinkLabel),
            spacing: "spacious"
        }),
        isDisabled: true
    });
};
module.exports["CopyLinkButtonPlaceholder"] = $585272eb5e339a55$export$1f3200a5b8d4d8e1;

});

parcelRegister("Ss9SD", function(module, exports) {

let $0a3ae2ec859d1164$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0a3ae2ec859d1164$var$load("lUs3J"),
    $0a3ae2ec859d1164$var$load("nrKDI")
]).then(()=>parcelRequire('9WYR7'));

});

parcelRegister("6KaG6", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ce38ba3becf24406$export$877a45ed8043e865 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K9Gzp",
    name: "ObjectSidebarPanel",
    loader: async ()=>(await (parcelRequire("kVuRZ"))).ObjectSidebarPanelWrapper
});
module.exports["ObjectSidebarPanel"] = $ce38ba3becf24406$export$877a45ed8043e865;

});

parcelRegister("kVuRZ", function(module, exports) {

let $f3c113a3cc30c721$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f3c113a3cc30c721$var$load("cXoAq"),
    $f3c113a3cc30c721$var$load("geNwN"),
    $f3c113a3cc30c721$var$load("gr9Xf")
]).then(()=>parcelRequire('iFpSu'));

});

parcelRegister("dpqzw", function(module, exports) {
const $e10f62297c04a73f$export$51c8f3f20bd49804 = 'fabric-editor-popup-scroll-parent';
const $e10f62297c04a73f$export$547bf96576574b25 = '.ProseMirror > *';
const $e10f62297c04a73f$export$f76b40820c13783a = '.ak-renderer-document';
const $e10f62297c04a73f$export$7718f42d39a9217b = 'content';
module.exports["EDITOR_PARENT_CLASS"] = $e10f62297c04a73f$export$51c8f3f20bd49804;
module.exports["EDITOR_CHILDREN_SELECTOR"] = $e10f62297c04a73f$export$547bf96576574b25;
module.exports["RENDERED_CONTENT_SELECTOR"] = $e10f62297c04a73f$export$f76b40820c13783a;
module.exports["FABRIC_PAGE_CONTENT_ID"] = $e10f62297c04a73f$export$7718f42d39a9217b;

});

parcelRegister("gkIgp", function(module, exports) {
var $44e99c386783fe05$export$ea1a2a449eaeaa2d = /*#__PURE__*/ function(CollabServiceProperty) {
    CollabServiceProperty["NCS"] = "ncs";
    CollabServiceProperty["SYNCHRONY"] = "synchrony";
    return CollabServiceProperty;
}({});
module.exports["CollabServiceProperty"] = $44e99c386783fe05$export$ea1a2a449eaeaa2d;

});

parcelRegister("briGH", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $7W8i8 = parcelRequire("7W8i8");

const $8540b650e122e686$var$RETRY_STATUS_CODE = [
    409,
    412
];
const $8540b650e122e686$export$8e3b4758c0e0a83 = (response)=>response?.data?.experimentalMigratePages?.status;
const $8540b650e122e686$var$logger = (0, $7W8i8.getLogger)('PageMigration');
const $8540b650e122e686$export$9369b12211e1fce4 = (refetchContentHash, migratePages, retriesLeft = 3, interval = 1000, statusCodes = [])=>{
    return new Promise((resolve, reject)=>{
        // b/c contentHash is variable and could changed when user in preview
        // perform refetch to grab the latest contentHash (to avoid 412 and 409 error when performing migration)
        return refetchContentHash().then((contentHash)=>{
            migratePages(contentHash).then((response)=>{
                const status = $8540b650e122e686$export$8e3b4758c0e0a83(response);
                setTimeout(()=>{
                    if (retriesLeft === 1) {
                        const message = 'Number of retrying attempt reach maximum number of retries';
                        $8540b650e122e686$var$logger.debug`${message}`;
                        return reject(message, statusCodes);
                    }
                    // only retry when status code is 409, 412
                    if ($8540b650e122e686$var$RETRY_STATUS_CODE.indexOf(Number.parseInt(status)) !== -1) {
                        statusCodes.push(Number.parseInt(status));
                        $8540b650e122e686$export$9369b12211e1fce4(refetchContentHash, migratePages, retriesLeft - 1, interval, statusCodes).then(resolve, reject);
                    } else return resolve(response, statusCodes);
                }, interval);
            }).catch((error)=>{
                return reject(error, statusCodes);
            });
        });
    });
};
module.exports["getStatusFromResponse"] = $8540b650e122e686$export$8e3b4758c0e0a83;
module.exports["retry"] = $8540b650e122e686$export$9369b12211e1fce4;

});

parcelRegister("5qUgM", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");


var $14SPd = parcelRequire("14SPd");


var $7d41Y = parcelRequire("7d41Y");


var $15M40 = parcelRequire("15M40");

const $325dcacdd45838d0$export$fd9c234c55ebf87b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS = [
    $325dcacdd45838d0$export$fd9c234c55ebf87b,
    (0, $7d41Y.FAVOURITE_BUTTON_METRIC),
    (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
];
const $325dcacdd45838d0$export$31dafa10be5579b1 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$export$13d0f4f758cb96f = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS
];
const $325dcacdd45838d0$export$2afecd1facfcf464 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.DATABASE_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$13d0f4f758cb96f
});
const $325dcacdd45838d0$export$48a0148c0fcdf96 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $15M40.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$a8f0e1718c3ba46b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$48a0148c0fcdf96
});
const $325dcacdd45838d0$export$585906e42509a641 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $15M40.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$de21700de0084df7 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WHITEBOARD_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$585906e42509a641
});
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT"] = $325dcacdd45838d0$export$fd9c234c55ebf87b;
module.exports["OBJECT_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$31dafa10be5579b1;
module.exports["DATABASE_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$13d0f4f758cb96f;
module.exports["DATABASE_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$2afecd1facfcf464;
module.exports["SMART_LINK_EMBED_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$48a0148c0fcdf96;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$a8f0e1718c3ba46b;
module.exports["WHITEBOARD_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$585906e42509a641;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$de21700de0084df7;

});

parcelRegister("7fw2E", function(module, exports) {

var $6VdZc = parcelRequire("6VdZc");

const $4bc3b2e76c18c48c$export$94f26401757ac8e7 = (metric)=>{
    let params;
    try {
        if ((0, $6VdZc.isInitial)()) {
            if (metric) {
                const data = metric.getData?.();
                const start = data?.start || 0;
                const stop = data?.stop || 0;
                params = [
                    {
                        duration: stop - start,
                        end: 'browser-metric.end'
                    }
                ];
            } else params = [
                undefined,
                'browser-metric.end'
            ];
        } else params = [
            'browser-metric.start',
            'browser-metric.end'
        ];
        performance.mark('browser-metric.end');
        performance.measure('browser-metric:tti', ...params);
    } catch (e) {
    // Suppress error when performance API failed.
    // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
    // That's why wrap with try catch statement.
    }
};
module.exports["markBrowserMetricEnd"] = $4bc3b2e76c18c48c$export$94f26401757ac8e7;

});

parcelRegister("kfIha", function(module, exports) {
const $3551cf4db632cbd5$var$isClipboardApiSupported = ()=>Boolean(navigator.clipboard && typeof navigator.clipboard.writeText === 'function');
const $3551cf4db632cbd5$export$b2199c37e85de4a7 = ()=>{
    const copyToClipboard = async (value)=>{
        if (value && $3551cf4db632cbd5$var$isClipboardApiSupported()) await navigator.clipboard.writeText(value);
    };
    return {
        copyToClipboard: copyToClipboard
    };
};
module.exports["useCopyToClipboard"] = $3551cf4db632cbd5$export$b2199c37e85de4a7;

});

parcelRegister("cBi7Q", function(module, exports) {
const $a428bcb8f1a15d17$export$4b225aae27e9366b = '45c9c029-3180-4960-ab0d-db7cdeaf5f54';
const $a428bcb8f1a15d17$export$c87b1e2e3344192f = 1000;
const $a428bcb8f1a15d17$export$c4e7b6208a0b853e = 60;
const $a428bcb8f1a15d17$export$cd6b7e688e614eeb = $a428bcb8f1a15d17$export$c4e7b6208a0b853e * 60;
const $a428bcb8f1a15d17$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $a428bcb8f1a15d17$export$a0d33d6e93abfb90 = 'aiMateChatLoadPreference';
const $a428bcb8f1a15d17$export$e5a3af287978673c = (siteId)=>siteId ? `${$a428bcb8f1a15d17$export$a0d33d6e93abfb90}_${siteId}` : $a428bcb8f1a15d17$export$a0d33d6e93abfb90;
const $a428bcb8f1a15d17$export$e8114853eca81277 = 'ai-mate';
const $a428bcb8f1a15d17$export$45d167a0ef5aef8d = '/gateway/api/directory/graphql';
const $a428bcb8f1a15d17$export$1ea9613e3e37d315 = 30 * $a428bcb8f1a15d17$export$c4e7b6208a0b853e * $a428bcb8f1a15d17$export$c87b1e2e3344192f;
const $a428bcb8f1a15d17$export$501af059da333e01 = 5 * $a428bcb8f1a15d17$export$c4e7b6208a0b853e * $a428bcb8f1a15d17$export$c87b1e2e3344192f;
const $a428bcb8f1a15d17$export$f8d883b8f9181b19 = 'rovoChatLastMessageSentAt';
const $a428bcb8f1a15d17$export$85d90d98449e85fd = 140;
const $a428bcb8f1a15d17$export$cad0f6e78cd99203 = '600px';
const $a428bcb8f1a15d17$export$900371d5fadf47e7 = {
    NEW_CHAT_BUTTON: 'rovo-chat-new-chat-button',
    THUMBS_UP_BUTTON: 'rovo-chat-thumbs-up-button'
};
module.exports["FEEDBACK_COLLECTOR_ENTRYPOINT_ID"] = $a428bcb8f1a15d17$export$4b225aae27e9366b;
module.exports["MS_IN_SECOND"] = $a428bcb8f1a15d17$export$c87b1e2e3344192f;
module.exports["SECONDS_IN_HR"] = $a428bcb8f1a15d17$export$cd6b7e688e614eeb;
module.exports["getChatLoadPreferenceKey"] = $a428bcb8f1a15d17$export$e5a3af287978673c;
module.exports["AI_MATE_EXPERIENCE_ID"] = $a428bcb8f1a15d17$export$e8114853eca81277;
module.exports["SHORTER_TIMEOUT_BEFORE_NEW_CHAT"] = $a428bcb8f1a15d17$export$501af059da333e01;
module.exports["LS_LAST_MESSAGE_SENT_AT"] = $a428bcb8f1a15d17$export$f8d883b8f9181b19;
module.exports["MINI_MODAL_GREETING_HEIGHT"] = $a428bcb8f1a15d17$export$85d90d98449e85fd;
module.exports["MINI_MODAL_EXPANDED_HEIGHT"] = $a428bcb8f1a15d17$export$cad0f6e78cd99203;
module.exports["POLLINATOR_TEST_IDS"] = $a428bcb8f1a15d17$export$900371d5fadf47e7;

});

parcelRegister("2YmgJ", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $a63d9f06b3e123f3$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        actionFilter: undefined,
        actions: [],
        jiraIssueViewActions: undefined,
        input: '',
        activeAction: undefined,
        buttonClickedTimestamp: undefined
    },
    actions: {
        setConversationActions: (actions)=>({ setState: setState })=>{
                setState({
                    actions: actions
                });
            },
        /*
		 * Jira Issue View does not use the provider pattern yet, so we need to skip the provider action fetching.
		 * When Jira Issue View is migrated to set actions using provider pattern, we can remove this setter.
		 */ setJiraIssueViewActions: (actions)=>({ setState: setState })=>{
                setState({
                    jiraIssueViewActions: actions
                });
            },
        setInput: (input)=>({ setState: setState })=>{
                setState({
                    input: input
                });
            },
        setActionFilter: (actionFilter)=>({ setState: setState })=>{
                setState({
                    actionFilter: actionFilter
                });
            },
        /*
		 * Do not use this setter directly. Use setActiveAction from useActiveAction hook in conversation-assistant instead.
		 */ setActiveAction_UNSAFE: (activeAction)=>({ setState: setState })=>{
                setState({
                    activeAction: activeAction
                });
            },
        setActiveActionFollowUpContext: (customFollowUpContext)=>({ getState: getState, setState: setState })=>{
                const activeAction = getState().activeAction;
                if (!activeAction || !('customFollowUpContext' in activeAction)) return;
                setState({
                    activeAction: {
                        ...activeAction,
                        customFollowUpContext: customFollowUpContext
                    }
                });
            },
        setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
                setState({
                    buttonClickedTimestamp: buttonClickedTimestamp
                });
            },
        getConversationActions: ()=>({ getState: getState })=>{
                return getState().actions;
            },
        getActionFilter: ()=>({ getState: getState })=>{
                return getState().actionFilter;
            },
        getInput: ()=>({ getState: getState })=>{
                return getState().input;
            },
        getActiveAction: ()=>({ getState: getState })=>{
                return getState().activeAction;
            },
        getButtonClickedTimestamp: ()=>({ getState: getState })=>{
                return getState().buttonClickedTimestamp;
            }
    }
});
const $a63d9f06b3e123f3$export$83a8985e8d377ba1 = (0, $9zUhf.createHook)($a63d9f06b3e123f3$var$store);
const $a63d9f06b3e123f3$export$74d7aed167e24a67 = (0, $9zUhf.createActionsHook)($a63d9f06b3e123f3$var$store);
const $a63d9f06b3e123f3$export$d6ed3fb83640b335 = (0, $9zUhf.createStateHook)($a63d9f06b3e123f3$var$store);
module.exports["useConversationActionsStore"] = $a63d9f06b3e123f3$export$83a8985e8d377ba1;
module.exports["useConversationActionsStoreActions"] = $a63d9f06b3e123f3$export$74d7aed167e24a67;
module.exports["useConversationActionsStoreState"] = $a63d9f06b3e123f3$export$d6ed3fb83640b335;

});

parcelRegister("6TWiP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f828166ff0e4b26e4ba3197fe41c41b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50651ad665c1db79$var$_react = $50651ad665c1db79$var$_interopRequireDefault((parcelRequire("42omo")));

var $50651ad665c1db79$var$_baseNew = $50651ad665c1db79$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $50651ad665c1db79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Atom".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50651ad665c1db79$var$AtomIcon = (props)=>/*#__PURE__*/ $50651ad665c1db79$var$_react.default.createElement($50651ad665c1db79$var$_baseNew.default, Object.assign({
        name: "AtomIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.87 1.42c1.566-.567 3.258-.667 4.318.393 1.059 1.059.959 2.75.392 4.317A11 11 0 0 1 13.683 8c.376.635.678 1.265.897 1.87.567 1.566.667 3.258-.393 4.318-1.059 1.059-2.75.959-4.317.392A11 11 0 0 1 8 13.683a11 11 0 0 1-1.87.897c-1.566.567-3.258.667-4.317-.393-1.06-1.059-.96-2.75-.393-4.317.219-.605.52-1.235.896-1.87a11 11 0 0 1-.896-1.87c-.567-1.566-.667-3.258.393-4.317C2.872.753 4.563.853 6.13 1.42c.605.219 1.235.52 1.87.896a11 11 0 0 1 1.87-.896M3.26 9.397a9 9 0 0 0-.43.983c-.521 1.44-.362 2.342.043 2.747s1.306.564 2.747.043a9 9 0 0 0 .983-.43 17 17 0 0 1-1.785-1.558A17 17 0 0 1 3.26 9.397m9.48 0a17.4 17.4 0 0 1-3.343 3.342q.507.258.983.431c1.44.521 2.342.362 2.747-.043s.564-1.306.043-2.747a9 9 0 0 0-.43-.983M8 4.099a15.5 15.5 0 0 0-2.121 1.78A15.5 15.5 0 0 0 4.099 8a15.4 15.4 0 0 0 1.78 2.121A15.5 15.5 0 0 0 8 11.901a15.5 15.5 0 0 0 2.121-1.78A15.5 15.5 0 0 0 11.901 8a15.5 15.5 0 0 0-1.78-2.121A15.5 15.5 0 0 0 8 4.099M5.62 2.83c-1.44-.521-2.342-.362-2.747.043S2.31 4.18 2.83 5.62q.173.475.43.983c.46-.607.981-1.207 1.558-1.785A17 17 0 0 1 6.603 3.26a9 9 0 0 0-.983-.43m7.507.043c-.405-.405-1.306-.564-2.747-.043a9 9 0 0 0-.983.43c.607.46 1.207.981 1.785 1.558a17 17 0 0 1 1.557 1.785 9 9 0 0 0 .431-.983c.521-1.44.362-2.342-.043-2.747"/><path fill="currentcolor" d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$50651ad665c1db79$var$AtomIcon.displayName = 'AtomIcon';
var $50651ad665c1db79$var$_default = module.exports.default = $50651ad665c1db79$var$AtomIcon;

});

parcelRegister("4sbrV", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/markdownPlus-to-adf.ts and slightly modified to work in the browser.
 */ 
var $iyDxB = parcelRequire("iyDxB");


var $h9yJL = parcelRequire("h9yJL");


var $hAuc5 = parcelRequire("hAuc5");

const $c4325a25ee151966$var$serializer = new (0, $h9yJL.JSONTransformer)();
function $c4325a25ee151966$export$dfca419434f7e5a8({ markdown: markdown, idMap: idMap = {}, editorSchema: editorSchema, featureToggles: featureToggles = {
    markdownPlus: true
} }) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    // Convert markdown-plus to ProseMirrorNode
    const proseMirrorNode = (0, $hAuc5.backendConvertMarkdownToProsemirrorNode)({
        markdown: markdown,
        schema: editorSchema || (0, $iyDxB.defaultSchema),
        idMap: idMap,
        featureToggles: featureToggles
    });
    // Convert ProseMirrorNode to ADF
    return $c4325a25ee151966$var$serializer.encode(proseMirrorNode);
}
module.exports["markdownPlusToAdf"] = $c4325a25ee151966$export$dfca419434f7e5a8;

});

parcelRegister("zCcSI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $ibzAc = parcelRequire("ibzAc");


var $32x2E = parcelRequire("32x2E");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $8aF6s = parcelRequire("8aF6s");


var $c96tF = parcelRequire("c96tF");


var $9cZ1w = parcelRequire("9cZ1w");

const $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY = 500;
const $e34c3f63766da5b3$export$a9c99c9d804e8c41 = ({ assistanceServiceConfigHeaders: assistanceServiceConfigHeaders = {}, preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose = false, preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose = false })=>{
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const emojiProvider = (0, $42omo.useMemo)(()=>{
        return (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
            cloudId: cloudId,
            userId: userId
        });
    }, [
        userId,
        cloudId
    ]);
    return {
        displaySubmitFlag: true,
        siteId: cloudId,
        product: 'confluence',
        orgId: orgId,
        assistanceServiceConfig: {
            headers: assistanceServiceConfigHeaders,
            baseUrl: '/gateway/api/assist'
        },
        emojiProvider: emojiProvider,
        userId: userId ?? undefined,
        preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose
    };
};
const $e34c3f63766da5b3$export$577864d1e6735f1b = ({ flags: flags, customGreeting: customGreeting, shouldShowGreeting: shouldShowGreeting, shouldHideFeedback: shouldHideFeedback })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const intl = (0, $aXWIB.useIntl)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const navigateToObject = (0, $42omo.useCallback)(async ({ baseUrl: baseUrlNav, path: path })=>{
        (0, $c96tF.createNavigateToObject)(push)({
            baseUrl: baseUrlNav,
            path: path
        });
        // artifical delay before closing the modal gives the app a moment to transition to the created object while the modal is still open, this creates a smoother transition from modal to new object.
        // For non-SPA transitions, a full page reload will happen so this delay will be ignored
        await new Promise((r)=>setTimeout(r, $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY));
    }, [
        push
    ]);
    const showCreateWithRovoModalCloseFeedbackFlag = (0, $9cZ1w.useLazyShowFeedbackFlag)(flags, intl, showModal, createAnalyticsEvent);
    const handleCloseSmartCreate = (0, $42omo.useCallback)(({ feedbackVariant: feedbackVariant, currentConversationId: currentConversationId, remixMetadata: remixMetadata, contentType: contentType, contentMode: contentMode })=>{
        if (shouldHideFeedback) return;
        if (feedbackVariant === undefined) return;
        showCreateWithRovoModalCloseFeedbackFlag({
            feedbackVariant: feedbackVariant,
            contentType: contentType,
            contentMode: contentMode,
            cloudId: cloudId,
            currentConversationId: currentConversationId ?? undefined,
            remixMetadata: remixMetadata
        });
    }, [
        showCreateWithRovoModalCloseFeedbackFlag,
        shouldHideFeedback,
        cloudId
    ]);
    return {
        customHandlers: {
            handleSubmitSmartCreate: navigateToObject,
            handleCloseSmartCreate: handleCloseSmartCreate
        },
        elements: {
            shouldShowGreeting: shouldShowGreeting ?? undefined
        },
        customGreeting: customGreeting ?? undefined
    };
};
module.exports["useConversationAssistantConfig"] = $e34c3f63766da5b3$export$a9c99c9d804e8c41;
module.exports["useConversationAssistantUiConfig"] = $e34c3f63766da5b3$export$577864d1e6735f1b;

});

parcelRegister("c96tF", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $8f856ee350559225$export$b2e60ce4b3907e57 = (baseUrl)=>{
    const host = window.location.host;
    return baseUrl.includes(host) && baseUrl.includes((0, $jlIaF.CONTEXT_PATH));
};
// database need flow query param for special case handling
const $8f856ee350559225$var$addFlowParam = (baseUrl, path)=>{
    const url = new URL(path, baseUrl);
    url.searchParams.set('flow', 'aiCreate');
    return url.pathname + url.search;
};
const $8f856ee350559225$export$38454a8d1321e65a = (push)=>({ baseUrl: baseUrl, path: path })=>{
        const isDatabase = Boolean((0, $1NBp8.DATABASE_VIEW).match(`${baseUrl}${path}`));
        let finalPath = path;
        if (isDatabase) finalPath = $8f856ee350559225$var$addFlowParam(baseUrl, path);
        if ($8f856ee350559225$export$b2e60ce4b3907e57(baseUrl)) push((0, $jlIaF.CONTEXT_PATH) + finalPath);
        else window.location.href = `${baseUrl}${finalPath}`;
    };
module.exports["createNavigateToObject"] = $8f856ee350559225$export$38454a8d1321e65a;

});

parcelRegister("ai7NK", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $30dd91193859fc54$export$4f97fa3245bb0e31 = {
    isSidePanelOpen: false
};
const $30dd91193859fc54$export$e324594224ef24da = {
    showSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: true
            });
        },
    hideSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: false
            });
        }
};
const $30dd91193859fc54$var$Store = (0, $1P1Tu.createStore)({
    initialState: $30dd91193859fc54$export$4f97fa3245bb0e31,
    actions: $30dd91193859fc54$export$e324594224ef24da,
    name: 'SidePanelState'
});
const $30dd91193859fc54$export$d4bcf572fecd48f5 = (0, $9zUhf.createActionsHook)($30dd91193859fc54$var$Store);
const $30dd91193859fc54$export$f3f6191f6fee6235 = (0, $9zUhf.createStateHook)($30dd91193859fc54$var$Store, {
    selector: (state)=>state.isSidePanelOpen
});
module.exports["useSidePanelStateActions"] = $30dd91193859fc54$export$d4bcf572fecd48f5;
module.exports["useIsSidePanelOpen"] = $30dd91193859fc54$export$f3f6191f6fee6235;

});

parcelRegister("4GDP8", function(module, exports) {
function $d27310b4a47ce627$var$keepTrying(fn, times, interval) {
    if (!fn() && times) setTimeout(()=>$d27310b4a47ce627$var$keepTrying(fn, times - 1, interval), interval);
}
function $d27310b4a47ce627$var$waitForDom(itemId) {
    return new Promise((resolve)=>{
        function lookForItem() {
            const targetItem = document.querySelector(itemId);
            if (targetItem) {
                clearInterval(checkInterval);
                resolve(true);
            }
        }
        // Start an interval to check for the item every 10ms
        const checkInterval = setInterval(lookForItem, 10);
        // Fail silently if the item isn't found after 5000ms
        setTimeout(()=>{
            clearInterval(checkInterval);
            resolve(false);
        }, 5000);
    });
}
function $d27310b4a47ce627$var$isForgeModule(itemId) {
    return itemId.startsWith('ari:cloud:ecosystem::extension');
}
function $d27310b4a47ce627$var$escapeForgeModuleKey(itemId) {
    return itemId.replace(/\//g, '\\/').replace(/:/g, '\\:');
}
function $d27310b4a47ce627$var$getItemSelector(itemId) {
    if (!itemId || !itemId.length) return;
    let itemSelector = itemId[0] === '#' ? itemId : `#${itemId}`;
    if ($d27310b4a47ce627$var$isForgeModule(itemId)) itemSelector = $d27310b4a47ce627$var$escapeForgeModuleKey(itemSelector);
    return itemSelector;
}
async function $d27310b4a47ce627$export$6bd4cdcdf3940391({ parentmenuId: parentmenuId, submenuId: submenuId, forgeItemId: forgeItemId }) {
    // Make sure the forge item has a valid id
    const forgeItemSelector = $d27310b4a47ce627$var$getItemSelector(forgeItemId);
    if (!forgeItemSelector) return;
    $d27310b4a47ce627$var$openMenu(parentmenuId);
    const foundSubmenu = await $d27310b4a47ce627$var$waitForDom(submenuId);
    if (!foundSubmenu) return;
    $d27310b4a47ce627$var$openMenu(submenuId);
    const foundForgeItem = await $d27310b4a47ce627$var$waitForDom(forgeItemSelector);
    if (!foundForgeItem) return;
    const forgeItem = document.querySelector(forgeItemSelector);
    forgeItem?.click();
}
function $d27310b4a47ce627$var$openMenu(menuId) {
    const triggerButton = document.querySelector(menuId);
    if (!triggerButton) return;
    const isOpen = triggerButton.getAttribute('aria-expanded') === 'true';
    //only care about closed case, otherwise let legacy event listener handle
    if (!isOpen) triggerButton.click();
}
function $d27310b4a47ce627$export$73ebde48694f32cd(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    $d27310b4a47ce627$var$keepTrying(()=>{
        const item = document.querySelector(itemSelector);
        if (item) {
            item.click();
            return true;
        }
    }, 100, 5);
}
function $d27310b4a47ce627$export$96aa6f6c7286ecb4(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    const event = new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true
    });
    document.querySelector(itemSelector)?.dispatchEvent(event);
}
function $d27310b4a47ce627$export$1d6f959e29b7f60d() {
    $d27310b4a47ce627$var$openMenu('#tools-menu-trigger');
}
function $d27310b4a47ce627$export$3d4ff948da3c7dd3() {
    $d27310b4a47ce627$var$openMenu('#context-menu-other-apps');
}
function $d27310b4a47ce627$export$94323a98da3bb62c() {
    $d27310b4a47ce627$var$openMenu('#more-actions-trigger');
}
module.exports["openForgeAppFromSubmenu"] = $d27310b4a47ce627$export$6bd4cdcdf3940391;
module.exports["simulateItemClick"] = $d27310b4a47ce627$export$73ebde48694f32cd;
module.exports["simulateItemMouseOver"] = $d27310b4a47ce627$export$96aa6f6c7286ecb4;
module.exports["openMenuClick"] = $d27310b4a47ce627$export$1d6f959e29b7f60d;
module.exports["openContextMenuClick"] = $d27310b4a47ce627$export$3d4ff948da3c7dd3;
module.exports["openMoreActionsMenuClick"] = $d27310b4a47ce627$export$94323a98da3bb62c;

});

parcelRegister("kmWRd", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $g9Srd = parcelRequire("g9Srd");

var $h3cbw = parcelRequire("h3cbw");

const $7a88b175622d580e$var$sidePanelContentStyling = (0, $ecnYn.xcss)({
    position: 'absolute',
    width: '100%',
    backgroundColor: 'elevation.surface',
    height: '100%',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'column'
});
const $7a88b175622d580e$export$8689d3888980b1f3 = (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { headerHeight: t1, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: t2, isOpen: t3, width: t4 } = t0;
    const headerHeight = t1 === undefined ? 0 : t1;
    const panelTop = t2 === undefined ? 0 : t2;
    const isOpen = t3 === undefined ? true : t3;
    const width = t4 === undefined ? 320 : t4;
    let t5;
    if ($[0] !== children || $[1] !== displayTopBorder || $[2] !== headerHeight || $[3] !== isFixed || $[4] !== isOpen || $[5] !== panelTop || $[6] !== width) {
        t5 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h3cbw.default), {
            enterFrom: "right",
            fade: "inout"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                ...props,
                style: {
                    backgroundColor: "elevation.surface",
                    position: isFixed ? "fixed" : "absolute",
                    right: "0",
                    top: `${panelTop}px`,
                    width: `${width}px`,
                    padding: "space.300",
                    borderLeft: "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)",
                    height: `calc(100vh - ${headerHeight}px)`,
                    borderTop: displayTopBorder ? "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)" : "none"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $7a88b175622d580e$var$sidePanelContentStyling
            }, children)));
        $[0] = children;
        $[1] = displayTopBorder;
        $[2] = headerHeight;
        $[3] = isFixed;
        $[4] = isOpen;
        $[5] = panelTop;
        $[6] = width;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
            appear: true
        }, t5);
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
};
module.exports["SidePanel"] = $7a88b175622d580e$export$8689d3888980b1f3;

});

parcelRegister("4WZFP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $72d7920b18bf3596$export$70e0922268f2e08b = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlock: "space.100",
            paddingInlineStart: "space.300",
            paddingInlineEnd: "space.150"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
module.exports["SidePanelHeader"] = $72d7920b18bf3596$export$70e0922268f2e08b;

});

parcelRegister("8jP1I", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $fc609ae5f11b40a5$export$409c83e49353f3fb = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "0IK46",
    name: "AISummaryFooter",
    loader: async ()=>(await (parcelRequire("gMXoC"))).AISummaryFooter
});
module.exports["AISummaryFooter"] = $fc609ae5f11b40a5$export$409c83e49353f3fb;

});

parcelRegister("gMXoC", function(module, exports) {

let $c38f33dcd5f9475c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c38f33dcd5f9475c$var$load("6wr18"),
    $c38f33dcd5f9475c$var$load("i3R6S"),
    $c38f33dcd5f9475c$var$load("ffEVr"),
    $c38f33dcd5f9475c$var$load("hhss7"),
    $c38f33dcd5f9475c$var$load("kUbT8")
]).then(()=>parcelRequire('4KbgO'));

});

parcelRegister("bbNJt", function(module, exports) {
/* SummaryPopupScrollableBody.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $d3be62f9dcca5536$export$8fdeb1797011aead = 358;
const $d3be62f9dcca5536$export$3b687fa050c6eb18 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { useMaxHeight: useMaxHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81d4k _18m91wug _1i4q1hna _o5724jg8 _1suq1j28 _1ke81kwk _155a1mok _aayni8nm _1oglplhp",
            __cmplp.useMaxHeight ? "_c71lgbqg" : "_c71ln7od",
            __cmplp.className
        ])
    });
});
module.exports["MAX_SUMMARY_HEIGHT"] = $d3be62f9dcca5536$export$8fdeb1797011aead;
module.exports["SummaryPopupScrollableBody"] = $d3be62f9dcca5536$export$3b687fa050c6eb18;

});

parcelRegister("dL3KX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $93WqG = parcelRequire("93WqG");


var $1kHsc = parcelRequire("1kHsc");


var $7Sm4c = parcelRequire("7Sm4c");

const $926c216e16fb1b0c$export$64cc6b1b62510d3 = "Atlassian Intelligence can\u2019t generate a summary for you right now, as there is too much content to summarize.";
const $926c216e16fb1b0c$export$1403052b2e306597 = "Atlassian Intelligence can\u2019t generate a summary for you right now, as there is not enough content to summarize. You can try again later if more is added!";
var $926c216e16fb1b0c$export$6841b1da468d3071 = /*#__PURE__*/ function(HandledErrorType) {
    HandledErrorType["TooMuchContent"] = "tooMuchContent";
    HandledErrorType["NotEnoughContent"] = "notEnoughContent";
    HandledErrorType["RateLimit"] = "rateLimit";
    HandledErrorType["AUPViolation"] = "aupViolation";
    HandledErrorType["GeneralError"] = "generalError";
    return HandledErrorType;
}({});
const $926c216e16fb1b0c$var$ERROR_MAP = {
    [$926c216e16fb1b0c$export$64cc6b1b62510d3]: "tooMuchContent",
    [$926c216e16fb1b0c$export$1403052b2e306597]: "notEnoughContent",
    TOO_MANY_REQUEST: "rateLimit",
    AUP_VIOLATION: "aupViolation"
};
const $926c216e16fb1b0c$var$STREAM_ERROR_MAP = {
    [(0, $93WqG.ConvoAIErrorMessage).ANSWER_UNAVAILABLE_FOR_CONTENT]: "notEnoughContent",
    [(0, $93WqG.ConvoAIErrorMessage).NOT_ENOUGH_CONTENT_ERROR]: "notEnoughContent",
    [(0, $93WqG.ConvoAIErrorMessage).RATE_LIMIT]: "rateLimit",
    [(0, $93WqG.ConvoAIErrorMessage).ACCEPTABLE_USE_VIOLATIONS]: "aupViolation"
};
const $926c216e16fb1b0c$var$expectedErrorTypes = [
    "tooMuchContent",
    "notEnoughContent",
    "aupViolation"
];
const $926c216e16fb1b0c$export$628a9b3d5b2b9729 = (experienceName, errorFromApolloOrStream)=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { errorType: errorType, isExpectedError: isExpectedError, error: error } = (0, $42omo.useMemo)(()=>{
        if (!errorFromApolloOrStream) return {
            isExpectedError: false,
            stopExperienceTracking: ()=>{},
            errorType: undefined,
            error: new Error('[useSummaryErrorHelper]: error instance is missing')
        };
        let errorMessageFromGQLorStream = '';
        let errorTypeFromGQLorStream = '';
        if ('graphQLErrors' in errorFromApolloOrStream) {
            // The BE only returns one error (the first that it encounters).
            // Therefore, we don't need to loop through the array, and can just rely on index 0
            errorMessageFromGQLorStream = errorFromApolloOrStream.graphQLErrors[0].message;
            errorTypeFromGQLorStream = $926c216e16fb1b0c$var$ERROR_MAP[errorMessageFromGQLorStream];
            return {
                isExpectedError: $926c216e16fb1b0c$var$expectedErrorTypes.includes(errorTypeFromGQLorStream),
                error: errorFromApolloOrStream,
                errorType: errorTypeFromGQLorStream
            };
        } else {
            errorMessageFromGQLorStream = errorFromApolloOrStream.message.message_template;
            errorTypeFromGQLorStream = $926c216e16fb1b0c$var$STREAM_ERROR_MAP[errorMessageFromGQLorStream];
            return {
                isExpectedError: $926c216e16fb1b0c$var$expectedErrorTypes.includes(errorTypeFromGQLorStream),
                error: new Error(errorFromApolloOrStream.message.content),
                errorType: errorTypeFromGQLorStream
            };
        }
    }, [
        errorFromApolloOrStream
    ]);
    const stopExperienceTracking = ()=>{
        if (isExpectedError) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            experienceTracker.abort({
                name: experienceName,
                reason: `Can not generate summary due to ${errorType}`
            });
        } else experienceTracker.fail({
            name: experienceName,
            error: error
        });
    };
    return {
        isExpectedError: isExpectedError,
        stopExperienceTracking: stopExperienceTracking,
        error: error,
        errorType: errorType
    };
};
module.exports["HandledErrorType"] = $926c216e16fb1b0c$export$6841b1da468d3071;
module.exports["useSummaryErrorHelper"] = $926c216e16fb1b0c$export$628a9b3d5b2b9729;

});

parcelRegister("53ZHq", function(module, exports) {
const $ddccf0ae2c3101d9$export$6c1f59b2f89fe4f1 = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $ddccf0ae2c3101d9$export$b4fefae0b724683f = 'https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/';
const $ddccf0ae2c3101d9$export$2876254020381b5e = 'https://www.atlassian.com/legal/acceptable-use-policy';
module.exports["TROUBLE_SHOOTING_DOCS_URL"] = $ddccf0ae2c3101d9$export$6c1f59b2f89fe4f1;
module.exports["USAGE_LIMITS_DOCS_URL"] = $ddccf0ae2c3101d9$export$b4fefae0b724683f;
module.exports["ACCEPTABLE_USE_POLICY_URL"] = $ddccf0ae2c3101d9$export$2876254020381b5e;

});

parcelRegister("i1vUz", function(module, exports) {

var $4qmCZ = parcelRequire("4qmCZ");


var $8SLNj = parcelRequire("8SLNj");


var $8G3G6 = parcelRequire("8G3G6");


var $8uM2K = parcelRequire("8uM2K");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $h2uld = parcelRequire("h2uld");

const $649e6d4fa880ffb0$var$useDynamicSplitButtonCatchupLastViewedTimeQuery = (0, $8G3G6.default);
const $649e6d4fa880ffb0$var$useDynamicSplitButtonContentHistoryQuery = (0, $8SLNj.default);
const $649e6d4fa880ffb0$export$ca7c63318c849d7a = (contentId, contentType, isRefreshRovoButton = false)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, userId: userId } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT);
    const { data: data, loading: catchupLastViewedLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($649e6d4fa880ffb0$var$useDynamicSplitButtonCatchupLastViewedTimeQuery, {
        variables: {
            contentId: contentId,
            contentType: contentType
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT
    });
    const { data: lastModifiedDateData, loading: lastModifiedLoading } = (0, $jMyy4.useQueryInterop)((0, $4qmCZ.default), {
        variables: {
            contentId: contentId
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT
    });
    const { data: contentHistoryData, loading: contentHistoryLoading } = (0, $jMyy4.useQueryInterop)($649e6d4fa880ffb0$var$useDynamicSplitButtonContentHistoryQuery, {
        variables: {
            contentId: contentId
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT || !isRovoButtonEnabled,
        fetchPolicy: 'network-only'
    });
    const lastModifiedDate = lastModifiedDateData?.content?.nodes?.[0]?.metadata?.lastModifiedDate ?? '';
    const lastViewedTime = data?.catchupGetLastViewedTime?.lastViewedTimeISO ?? '';
    // Guard against cases where lastViewedTime would otherwise cause a NaN parse result
    const cleanedLastViewedTime = lastViewedTime.replace(/\[.*?\]$/, '');
    const parsedLastViewedTime = Date.parse(cleanedLastViewedTime);
    const parsedLastModifiedDate = Date.parse(lastModifiedDate);
    const lastEditedCollaborators = contentHistoryData?.contentHistory?.nodes?.[0]?.collaborators?.userAccountIds ?? [];
    const isCurrentUserARecentCollaborator = lastEditedCollaborators.some((collaborator)=>collaborator === userId);
    const isFirstTimeVisit = Number.isNaN(parsedLastViewedTime);
    const lastViewedDate = isFirstTimeVisit ? undefined : new Date(parsedLastViewedTime);
    const queryLoading = catchupLastViewedLoading || lastModifiedLoading || contentHistoryLoading || readTimeLoading;
    let showCatchupAsDefault = false;
    let showSummarizeAsDefault = true;
    if (!parsedLastViewedTime && !isFirstTimeVisit || !parsedLastModifiedDate || queryError) return {
        showCatchupAsDefault: showCatchupAsDefault,
        queryLoading: queryLoading,
        queryError: queryError
    };
    if (isRovoButtonEnabled && pageMode !== (0, $cD1qu.PageMode).EDIT && !queryLoading && isFirstTimeVisit && readTime && readTime >= 5 && !isCurrentUserARecentCollaborator) {
        if (isRefreshRovoButton) return {
            showCatchupAsDefault: showCatchupAsDefault,
            showSummarizeAsDefault: showSummarizeAsDefault,
            queryLoading: queryLoading
        };
    }
    showCatchupAsDefault = pageMode !== (0, $cD1qu.PageMode).EDIT && !queryLoading && parsedLastModifiedDate > parsedLastViewedTime && !isCurrentUserARecentCollaborator;
    showSummarizeAsDefault = false;
    return {
        showCatchupAsDefault: showCatchupAsDefault,
        showSummarizeAsDefault: showSummarizeAsDefault,
        queryLoading: queryLoading,
        lastViewedDate: lastViewedDate
    };
};
module.exports["useDynamicSplitButton"] = $649e6d4fa880ffb0$export$ca7c63318c849d7a;

});

parcelRegister("4qmCZ", function(module, exports) {
/**
 * @generated SignedSource<<b548fa0d1413f1b5469ea325c47293cc>>
 * @relayHash 53828d84c0acb319d0f0762fbd51cfb9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3782297928019afae38deeb994658b9d2bfb75b3dd67df3051fac91d5ebf0e37
const $3f3bb2f2b7df90db$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifiedDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "53828d84c0acb319d0f0762fbd51cfb9",
            "id": "3782297928019afae38deeb994658b9d2bfb75b3dd67df3051fac91d5ebf0e37",
            "metadata": {},
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonLastModifiedDateQuery($contentId:ID!){content(id:$contentId){nodes{id,metadata{lastModifiedDate}}}}"
        }
    };
}();
$3f3bb2f2b7df90db$var$node.hash = "cb78a829ad38a06c36dc9615c22411b7";
var $3f3bb2f2b7df90db$export$2e2bcd8739ae039 = $3f3bb2f2b7df90db$var$node;
module.exports["default"] = $3f3bb2f2b7df90db$export$2e2bcd8739ae039;

});

parcelRegister("8SLNj", function(module, exports) {
/**
 * @generated SignedSource<<f5ef9a2a1e380a4e992dfecd51de50bc>>
 * @relayHash c82cedffd514ace9062cc5a7ea29b433
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7dd5a60846b03a6eacef04466d72dec90722d2cae751b0c9b97f555a408d7190
const $a7452eae54a23656$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                }
            ],
            "concreteType": "PaginatedContentHistoryList",
            "kind": "LinkedField",
            "name": "contentHistory",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentHistory",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "ContributorUsers",
                            "kind": "LinkedField",
                            "name": "collaborators",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "userAccountIds"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c82cedffd514ace9062cc5a7ea29b433",
            "id": "7dd5a60846b03a6eacef04466d72dec90722d2cae751b0c9b97f555a408d7190",
            "metadata": {},
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonContentHistoryQuery($contentId:ID!){contentHistory(contentId:$contentId,first:1){nodes{collaborators{userAccountIds}}}}"
        }
    };
}();
$a7452eae54a23656$var$node.hash = "428e55c833e4f9ecc04af6435214d702";
var $a7452eae54a23656$export$2e2bcd8739ae039 = $a7452eae54a23656$var$node;
module.exports["default"] = $a7452eae54a23656$export$2e2bcd8739ae039;

});

parcelRegister("auLW1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b253f08be2669ace$export$c463287b61deee24 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wRZLE",
    name: "PageCatchupComponent",
    loader: async ()=>(await (parcelRequire("izcyj"))).PageCatchupComponentWithErrorBoundary
});
module.exports["PageCatchupComponent"] = $b253f08be2669ace$export$c463287b61deee24;

});

parcelRegister("izcyj", function(module, exports) {

let $d8453b8a6eb69e76$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d8453b8a6eb69e76$var$load("hhBQG"),
    $d8453b8a6eb69e76$var$load("l0dTs"),
    $d8453b8a6eb69e76$var$load("6wr18"),
    $d8453b8a6eb69e76$var$load("8VT23"),
    $d8453b8a6eb69e76$var$load("ffEVr"),
    $d8453b8a6eb69e76$var$load("hhss7"),
    $d8453b8a6eb69e76$var$load("eN6nL")
]).then(()=>parcelRequire('4RbVT'));

});

parcelRegister("afBrg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28e818db41afcf6fce742cecb9d4361e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $776858abadb4b212$var$_react = $776858abadb4b212$var$_interopRequireDefault((parcelRequire("42omo")));

var $776858abadb4b212$var$_baseNew = $776858abadb4b212$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $776858abadb4b212$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeAudioBriefing".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Audio Briefings, a new feature launching within Confluence to help people develop an expanded awareness on a topic by generating AI-powered podcasts about their work.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $776858abadb4b212$var$AiGenerativeAudioBriefingIcon = (props)=>/*#__PURE__*/ $776858abadb4b212$var$_react.default.createElement($776858abadb4b212$var$_baseNew.default, Object.assign({
        name: "AiGenerativeAudioBriefingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0c.97 0 1.88.2 2.72.55l-.24.09c-.52.19-.93.56-1.19 1.02A5.5 5.5 0 0 0 2.5 7v.71A2.5 2.5 0 0 1 6 10v3.08A1.92 1.92 0 0 1 4.08 15 3.08 3.08 0 0 1 1 12V7a7 7 0 0 1 7-7M3.5 9a1 1 0 0 0-1 1v1.92c0 .87.71 1.58 1.58 1.58.23 0 .42-.19.42-.42V10a1 1 0 0 0-1-1m11.46-2.78Q15 6.6 15 7v5a3.08 3.08 0 0 1-3.08 3A1.92 1.92 0 0 1 10 13.08V10a2.5 2.5 0 0 1 3.5-2.29v-.73a2.25 2.25 0 0 0 1.46-.77M12.5 9a1 1 0 0 0-1 1v3.08c0 .23.19.42.42.42.87 0 1.58-.71 1.58-1.58V10a1 1 0 0 0-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M13.365.009a.75.75 0 0 1 .541.378l.05.106.334.92a.5.5 0 0 0 .298.297l.919.335a.75.75 0 0 1 0 1.41l-.92.335a.5.5 0 0 0-.297.298l-.335.919a.75.75 0 0 1-1.41 0l-.335-.92a.5.5 0 0 0-.298-.297l-.919-.335a.75.75 0 0 1-.484-.589L10.5 2.75l.009-.116a.75.75 0 0 1 .484-.59l.92-.334a.5.5 0 0 0 .297-.298l.335-.919A.75.75 0 0 1 13.249 0z"/>`
    }, props));
$776858abadb4b212$var$AiGenerativeAudioBriefingIcon.displayName = 'AiGenerativeAudioBriefingIcon';
var $776858abadb4b212$var$_default = module.exports.default = $776858abadb4b212$var$AiGenerativeAudioBriefingIcon;

});

parcelRegister("NomII", function(module, exports) {
/* CustomPopupContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eyWa4 = parcelRequire("eyWa4");


var $bmowW = parcelRequire("bmowW");

const $7ecedb5cea5467d4$var$PopupWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1mok _16qs130s _1pbykb7n _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});
const $7ecedb5cea5467d4$export$2db9b01e44994880 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, ...props }, ref)=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7ecedb5cea5467d4$var$PopupWrapper, {
        ...props,
        ref: ref,
        role: "dialog",
        "aria-label": intl.formatMessage((0, $bmowW.i18n).quickSummaryLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, children));
});
module.exports["CustomPopupContainer"] = $7ecedb5cea5467d4$export$2db9b01e44994880;

});

parcelRegister("bmowW", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $jhwJP = parcelRequire("jhwJP");

const $c2de17ff654b3217$var$i18nBase = (0, $aXWIB.defineMessages)({
    quickSummaryLabel: {
        id: "quick-summary.label.text",
        defaultMessage: "Quick summary"
    },
    quickSummaryToolTipText: {
        id: "quick-summary.tooltip.text",
        defaultMessage: "Summarize"
    },
    quickSummaryFeatureSpotlightText: {
        id: "quick-summary.feature-spotlight-one.text",
        defaultMessage: "This might be a longer read. Save time and read a quick summary from Atlassian Intelligence."
    },
    quickSummarySpotlightSummarizeText: {
        id: "quick-summary.spotlight.summarize.button.text",
        defaultMessage: "Summarize"
    },
    quickSummarySpotlightCloseButtonText: {
        id: "quick-summary.spotlight.close.button.text",
        defaultMessage: "Dismiss"
    },
    quickSummaryOptInDialogHeaderText: {
        id: "quick-summary.opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    quickSummaryOptInDialogBodyText: {
        id: "quick-summary.opt-in.dialog.body.text",
        defaultMessage: "Save time by reading an Al-generated summary instead of an entire page or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    quickSummaryAdminOptInDialogBodyText: {
        id: "quick-summary.admin.opt-in.dialog.body.text",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $c2de17ff654b3217$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    quickSummaryOptInDialogBodyText: {
        id: "quick-summary.opt-in.dialog.body.text.livedocs",
        defaultMessage: "Save time by reading an Al-generated summary instead of an entire page, live doc, or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    quickSummaryAdminOptInDialogBodyText: {
        id: "quick-summary.admin.opt-in.dialog.body.text.livedocs",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page or live doc with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $c2de17ff654b3217$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($c2de17ff654b3217$var$i18nBase, $c2de17ff654b3217$var$i18nLiveDocs);
module.exports["i18n"] = $c2de17ff654b3217$export$a7357cdd1f0b0168;

});

parcelRegister("brrvF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1ytiN = parcelRequire("1ytiN");


var $42MJM = parcelRequire("42MJM");


var $fykBu = parcelRequire("fykBu");


var $7bACx = parcelRequire("7bACx");

const $a68160926e693700$var$i18n = (0, $aXWIB.defineMessages)({
    headerText: {
        id: "quick-summary.upsell.header.text",
        defaultMessage: "Improve productivity with Rovo"
    },
    headerTextAdmin: {
        id: "quick-summary.upsell.header.text.admin",
        defaultMessage: "Improve team productivity with Rovo"
    },
    learnMoreLinkTextUser: {
        id: "quick-summary.upsell.learn-more.link.text.user",
        defaultMessage: "Learn more about Rovo"
    },
    bodyTextAdmin: {
        id: "quick-summary.upsell.body.text.admin",
        defaultMessage: "Save time with page summaries, create and organize ideas efficiently, and get smarter, relevant search results you can act on. Upgrade to Premium"
    },
    bodyTextUser: {
        id: "quick-summary.upsell.body.text.user",
        defaultMessage: "Save time with page summaries, create and organize ideas efficiently, and get smarter, relevant search results you can act on. Try Rovo today"
    }
});
const $a68160926e693700$export$37172947b8f9cb48 = 'https://www.atlassian.com/software/rovo/guides/end-user-guide/introduction';
const $a68160926e693700$export$9f5718677d288e24 = 'https://www.atlassian.com/software/rovo/guides/admin-guide/introduction';
const $a68160926e693700$export$f552fbd4bef744fa = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const headerText = isSiteAdmin ? intl.formatMessage($a68160926e693700$var$i18n.headerTextAdmin) : intl.formatMessage($a68160926e693700$var$i18n.headerText);
    const bodyText = isSiteAdmin ? intl.formatMessage($a68160926e693700$var$i18n.bodyTextAdmin) : intl.formatMessage($a68160926e693700$var$i18n.bodyTextUser);
    const learnMoreLink = isSiteAdmin ? $a68160926e693700$export$9f5718677d288e24 : $a68160926e693700$export$37172947b8f9cb48;
    const learnMoreText = intl.formatMessage($a68160926e693700$var$i18n.learnMoreLinkTextUser);
    const learnMoreLinkProps = (0, $42omo.useMemo)(()=>({
            href: learnMoreLink,
            message: learnMoreText
        }), [
        learnMoreLink,
        learnMoreText
    ]);
    const imageProps = (0, $42omo.useMemo)(()=>({
            src: {
                default: (0, (/*@__PURE__*/$parcel$interopDefault($fykBu))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($7bACx)))
            },
            alt: ''
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42MJM.AIUpsell), {
        title: headerText,
        body: bodyText,
        feature: "quickSummary",
        learnMoreLink: learnMoreLinkProps,
        image: imageProps
    });
};
module.exports["QuickSummaryUpsell"] = $a68160926e693700$export$f552fbd4bef744fa;

});

parcelRegister("fykBu", function(module, exports) {
module.exports = new URL("quickSummaryUpsellBannerLight.edcc3647.svg", import.meta.url).toString();

});

parcelRegister("7bACx", function(module, exports) {
module.exports = new URL("quickSummaryUpsellBannerDark.e27429f6.svg", import.meta.url).toString();

});

parcelRegister("AL4QS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aeea3452b156c1a88293b0f0d28d725d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $06e7e17859e1d884$var$_react = $06e7e17859e1d884$var$_interopRequireDefault((parcelRequire("42omo")));

var $06e7e17859e1d884$var$_baseNew = $06e7e17859e1d884$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $06e7e17859e1d884$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GenerativeIndicator".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for indicating generative and suggested content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $06e7e17859e1d884$var$GenerativeIndicatorIcon = (props)=>/*#__PURE__*/ $06e7e17859e1d884$var$_react.default.createElement($06e7e17859e1d884$var$_baseNew.default, Object.assign({
        name: "GenerativeIndicatorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.117 1.009a.75.75 0 0 1 .588.484l1.55 4.251 4.252 1.55A.75.75 0 0 1 15 8v.002a.75.75 0 0 1-.493.704l-4.252 1.55-1.55 4.252a.75.75 0 0 1-.704.493h-.002a.75.75 0 0 1-.704-.493l-1.55-4.252-4.252-1.55A.75.75 0 0 1 1 8.001v-.002a.75.75 0 0 1 .493-.704l4.251-1.55 1.55-4.252.049-.106A.75.75 0 0 1 7.999 1h.002z"/>`
    }, props));
$06e7e17859e1d884$var$GenerativeIndicatorIcon.displayName = 'GenerativeIndicatorIcon';
var $06e7e17859e1d884$var$_default = module.exports.default = $06e7e17859e1d884$var$GenerativeIndicatorIcon;

});


//# sourceMappingURL=ObjectSidebarControl.97e64c91.js.map
